import {
	Component,
	OnInit,
	TemplateRef,
	ViewChild,
	OnDestroy,
} from "@angular/core";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { HttpParams } from "@angular/common/http";
import { IDropdownSettings } from "ng-multiselect-dropdown";
import { CommonService } from "./../common.service";
import { TabsetComponent } from "ngx-bootstrap/tabs";
import { Subject } from "rxjs";
import { DatePipe } from "@angular/common";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import "rxjs/add/observable/of";
import { DataTableDirective } from "angular-datatables";
import { CommonVariablesService } from "./../common-variables.service";

@Component({
	selector: "app-policy-configuration",
	templateUrl: "./policy-configuration.component.html",
	styleUrls: ["./policy-configuration.component.css"],
})
export class PolicyConfigurationComponent implements OnInit, OnDestroy {
	@ViewChild("tabset", { static: false }) tabset: TabsetComponent;
	modalRef: BsModalRef;
	isShowDraft = false;
	@ViewChild(DataTableDirective)
	dtElement: DataTableDirective;
	isShowConvertPolicy = false;
	isShowCreateClient = false;
	isShowAddClient = false;
	isShowCreateProducer = false;
	isShowAddProducer = false;
	isShowSave = true;
	config: any = { class: "theme-modal right modal-sm", backdrop: "static" };
	selectedPolicyNumber: any;
	selectedPolicyStatus: any;
	IsBulkDeclarationMandatory: boolean = true;
	//producer details
	producerName: string;
	// Policy setup Changes
    deletedData= [];
	producerCode: any;
	producerBranch: string;
	producerBranchCode: any;
	producerPhoneNumber: number;
	producerEmail: any;
	sme: any;
	tagicRMemail: any;
	// Stop Changes
	policy_type:any;
	utilised_opening_certificate_balance: any;
	utilised_premium_certificate_balance: any;
	utilised_opening_bulk_balance: any;
	utilised_premium_bulk_balance;
	SiValid: boolean = false;
	voyagePolicy: any = [];
	policy_no: any;
	//insured details variable
	insuredId: string;
	insuredName: string;
	insuredAdd1: string;
	insuredAdd2: string;
	insuredAdd3: string;
	insuredCity: string;
	insuredDistrict: string;
	insuredState: string;
	insuredCountry: string;
	insuredZipcode: number;
	insuredGSTINNumber: any;
	insuredgroupName = [];
	//policy details
	policyDetails: FormGroup;
	addGroup: FormGroup;
	selectGroup: FormGroup;
	insuredDetails: FormGroup;
	subvoyagePopup: FormGroup;
	bookingdate: any;
	bookingdateForPolicy: any;
	policyType: string;
	policyInceptionDate: any;
	PolicyEffectiveDate: any;
	policyExpiryDate: any;
	endorsementStartDate: any;
	isShowEndorsementStartDate: any = false;
	policyLockDate: any;
	policyCurrencyType: string;
	inceptionDate: any;
	expiryDate: any;
	tax: any;
	renewalCounter: any = "";
	policyNumber: any;
	policyReferenceNumber: any;
	endorsementPolicyReferenceNumber: any;
	policyNumberForDispaly: any;
	policyNumberMetaData: any;
	//policyId: any;
	policyStatus: number;
	policyNetPremium: any;
	policyServiceTax: any;
	policyStampDuty: any;
	//underwriter
	underwriterData: any = [];
	underwriterEmail: any;
	allUnderWriterDetails: any;
	checkedUnderWriterUsers: any = [];
	// Policy setup Changes
	actualData= [];
	//voyage
	voyageArr = [];
	voyageArrForDisplay = [];
	voyageArrData = [];
	voyageId: any;
	subvoyagename: any;
	subvoyagenameArr: any;
	subvoyagearray = [];
	voyagename: string;
	initialSumInsured: any;
	certificateorbulk: any;
	iscertificatebulkShow = true;
	// Policy setup Changes
	userdeletedData =[];
	iscertificateallowedShow = true;
	totalpremiumCellMerge = 0;
	certificateorbulkValue: any;
	suminsured: any;
	openingbalance: any;
	bulkdeclarationtype: any;
	bulkdeclarationtypevalue: any;
	certificateallowed: any;
	declarationtype: any;
	declarationtypevalue: any;
	bovpercent: any;
	psl: any;
	// Policy setup Changes
	deletedValue:any=[];
	transitexcess: any;
	transitexcessamount: any;
	marinefinalrate;
	shipmentpreminum;
	initialsuminsured: any;
	lowbalancetrigger: any;
	lowbalancetriggeramount: any;
	backdatedays: any;
	postexpiry: any;
	coveragetype = "";
	coveragetypeValue: any;
	modeofconveyance: any = [];
	modeofconveyanceValue: any = [];
	premiumdisplay: any;
	premiumBalance: any;
	netPremium: any;
	fromcountry = [];
	tocountry = [];
	fromCountryList = {};
	toCountryList = {};
	non_std_clauses: any;
	addclient: any;
	subvoyageId: number;
	subvoyageData = [];
	voyageArrGridData = [];
	totalPremium: any;
	modeOfConveyanceArray: any = [];
	removeModeOfConveyanceArray: any = [];
	fromCountryArray: any = [];
	toCountryArray: any = [];
	voyageArrForPolicy: any = [];
	//end
	//client user

	deleteVoyageClientUsersData: any = [];
	clientUsers: any = [];
	voyageClientUsersArr: any = [];
	clientUserDetailsForm: FormGroup;
	clientGroupIds = [];
	//end of client User
	//Producer User
	submitted: any;
	deleteVoyageProducerUsersData: any = [];
	producerUsers: any = [];
	voyageProducerUserArr: any = [];
	producerUserSetupForm: FormGroup;
	param: any;
	receivedEditData: any;
	producerGroupIds = [];
	//End of Producer User
	newsubVoyageObj: any = {};
	subVoyageNameDropdownArr = [];
	voyageNameDropdownArr = [];
	checkedProducerUsers: any = [];
	deleteProducerUserArr: any = [];
	checkedClientUsers: any = [];
	deleteClientUserArr: any = [];
	defaultProducerUserLength: any = [];
	defaultClientUserLength: any = [];
	allGroupData = [];
	isPostValid:boolean=false;
	// Policy setup Changes
	count= 0;
	allGroupDataId = [];
	dtTrigger: Subject<any> = new Subject();
	dtTrigger1: Subject<any> = new Subject();
	dtTrigger2: Subject<any> = new Subject();
	dtOptions: any = {};
	dtOptions1: any = {};
	isShow: any;
	isOpen = true;
	ShowRightContent: boolean = false;
	isShowButtons = true;
	response: any;
	countToTab = 0;
	isShowConvertPolicyButton: boolean = false;
	config1: any = {
		displayKey: "description", //if objects array passed which key to be displayed defaults to description
		search: true, //true/false for the search functionlity defaults to false,
		height: "auto", //height of the list so that if there are more no of items it can show a scroll defaults to auto. With auto height scroll will never appear
		placeholder: "Please Select Group Name", // text to be displayed when no item is selected defaults to Select,
		customComparator: () => {}, // a custom function using which user wants to sort the items. default is undefined and Array.sort() will be used in that case,
		limitTo: 5, // a number thats limits the no of options displayed in the UI similar to angular's limitTo pipe
		moreText: "more", // text to be displayed whenmore than one items are selected like Option 1 + 5 more
		noResultsFound: "No results found!", // text to be displayed when no items are found while searching
		searchPlaceholder: "Search group name", // label thats displayed in search input,
		searchOnKey: "group", // key on which search should be performed this will be selective search. if undefined this will be extensive search on all keys
	};
	constructor(
		private modalService: BsModalService,
		public commonService: CommonService,
		public commonVariablesService: CommonVariablesService,
		private datePipe: DatePipe,
		private formBuilder: FormBuilder,
		private activatedRoute: ActivatedRoute,
		private spinner: NgxSpinnerService,
		private router: Router
	) {}
	dropdownListFromCountry = [];
	dropdownListToCountry = [];
	dropdownListConveyance = [];
	dropdownList = [];
	dropdownSettings: IDropdownSettings = {};
	ngOnInit() {
		window.localStorage.setItem("pageName", "Policy Configuration");
		this.dtOptions = {
			dom: "ftipr",
			destroy: true,
			paging: false,
			bInfo: false,
		};
		this.policyDetails = this.formBuilder.group({
			effectiveDate: ["", Validators.required],
			portLockDate: ["", Validators.required],
		});

		this.subvoyagePopup = this.formBuilder.group({
			subVoyageName: [""],
			SI_Percentage: [
				"",
				[Validators.required, Validators.pattern("^[0-9][0-9]?$|^100$")],
			],
			txtopeningBalance: ["", [Validators.required]],
			coveragetype: [""],
			declarationType: ["", Validators.required],
			bulkdeclarationtype: [""],
			backdatedays: ["", Validators.required],
			postexpiry: ["", Validators.required],
			modeOfConveyance: [""],
			psl: ["", Validators.required],
			bovpercent: ["", Validators.required],
			transitexcess: ["", Validators.required],
			transitexcessamount: [""],
			shipmentpreminum: ["", Validators.required],
			lowbalTrigger: [""],
			lowbalTriggerAmt: ["", Validators.required],
			premiumdisplay: [""],
			non_std_clauses: [""],
			fromCountryArray: ["", Validators.required],
			toCountryArray: ["", Validators.required],
			addclient: [""],
			marineRate: ["", Validators.required],
			certificate: [""],
			certificateAllowed: [""],
		});
		this.addGroup = this.formBuilder.group({
			addGroupValue: ["", Validators.pattern("^[A-Z0-9]{3,10}$")],
		});
		this.selectGroup = this.formBuilder.group({
			groupNameValue: [""],
		});
		this.insuredDetails = this.formBuilder.group({
			selectGroupName: [""],
		});
		this.clientUserDetailsForm = this.formBuilder.group({
			clientUserEmail: [
				"",
				[
					Validators.required,
					Validators.pattern(
						"^[_a-z0-9-]+(.[_a-z0-9-]+)*@[a-z0-9-]+(.[a-z0-9-]+)*(.[a-z]{2,4})$"
					),
				],
			],
			clientUserFirstName: ["", Validators.required],
			clientUserLastName: ["", Validators.required],
			clientUserPhoneNumber: ["", Validators.pattern("^[0-9]{10,30}")],
			clientUserSelectStatus: ["", Validators.required],
		});

		this.producerUserSetupForm = this.formBuilder.group({
			producerUserFirstName: ["", Validators.required],
			producerUserEmailID: [
				"",
				[
					Validators.required,
					Validators.pattern(
						"^[_a-z0-9-]+(.[_a-z0-9-]+)*@[a-z0-9-]+(.[a-z0-9-]+)*(.[a-z]{2,4})$"
					),
				],
			],
			producerUserPhoneNo: ["", Validators.pattern("^[0-9]{10}")],
			producerUserSelectStatus: ["", Validators.required],
		});

		this.selectedPolicyStatus =
			this.activatedRoute.snapshot.paramMap.get("status");
		if (this.selectedPolicyStatus != 0) {
			this.isShowDraft = true;
			this.isShowConvertPolicy = true;
			this.isShowSave = false;
			this.selectedPolicyNumber =
				this.activatedRoute.snapshot.paramMap.get("id");
		}
		if (this.selectedPolicyStatus == 0) {
			/* let status = this.cookie.get('status'); */
			let status = window.localStorage.getItem("status");
			let tmpUserType = window.localStorage.getItem("userProfile");
			let getUserProfile = this.commonService.decryptData(tmpUserType);
			if (
				status.toLowerCase() == "cancelled" ||
				["adminview"].includes((getUserProfile || "").toLowerCase())
			)
				this.isShowButtons = false;
			else this.isShowButtons = true;
		}
		$("#DataTables_Table_0_length").hide();
		this.getQuote("");
		this.dropdownSettings = {
			singleSelection: false,
			idField: "item_id",
			textField: "item_text",
			selectAllText: "Select All",
			unSelectAllText: "UnSelect All",
			itemsShowLimit: 5,
			allowSearchFilter: true,
		};
	}
	get producerUserForm() {
		return this.producerUserSetupForm.controls;
	}
	get clientUserForm() {
		return this.clientUserDetailsForm.controls;
	}
	get policyDetailsForm() {
		return this.policyDetails.controls;
	}
	get subvoyagePopupForm() {
		return this.subvoyagePopup.controls;
	}
	get selectGroupForm() {
		return this.selectGroup.controls;
	}
	get addGroupForm() {
		return this.addGroup.controls;
	}
	tabToBeActive() {
		let id = this.commonService.idToRoutePolicyConfig;
		if (this.selectedPolicyStatus == 1) {
			if (id == 1 || id == 2) this.tabset.tabs[id].active = true;
			else if (id == 3) this.tabset.tabs[0].active = true;
			else if (this.policyStatus == 0) this.tabset.tabs[0].active = true;
			else if (this.policyStatus == 1) this.tabset.tabs[1].active = true;
			else if (this.policyStatus == 2) this.tabset.tabs[2].active = true;
			this.commonService.idToRoutePolicyConfig = 0;
		} else {
			if (id == 1 || id == 2) this.tabset.tabs[id].active = true;
			else this.tabset.tabs[0].active = true;
		}
	}
	scroll(element: HTMLInputElement) {
		this.tabset.tabs[0].active = true;
		element.scrollIntoView({ behavior: "smooth", block: "center" });
	}
	scrollToProducerTab() {
		this.tabset.tabs[2].active = true;
	}
	/*
	* Created By : PriyaDharshini M
	* Description : Takes the policy_ref_number from Master policy 
					and gets the data from serve to render in dom.
	*********************************************/
	async getQuote(type) {
		if (this.commonVariablesService.productId == "") {
			let res = await this.commonService.commonLOBvalues();
			if (res == false) {
				this.router.navigate(["/login"]);
			}
		}
		this.spinner.show();
		await this.showGroupName();
		//await this.loadAllgroup();
		await this.loadcountrylist();
		var url;
		var parameter;
		var contentType;
		this.voyageArrGridData = [];
		this.voyageArr = [];
		this.voyageArrForDisplay = [];
		this.voyageArrData = [];
		this.voyageArrForPolicy = [];
		if (this.selectedPolicyStatus != 0) {
			url =
				this.commonVariablesService.baseURL + "api/v1/marine_mp_gc_data/fetch";
			parameter = {
				policy_ref_num: this.selectedPolicyNumber,
			};
			contentType = "application/x-www-form-urlencoded";
			this.response = await this.commonService.httpGetMethod(
				url,
				contentType,
				true,
				parameter,
				"Policy Configuration"
			);
			if (this.response.status == 0) {
				this.policyStatus = this.response.data.gc_policy_status;
				this.bookingdate = this.response.data.gc_booking_date;
				this.bookingdateForPolicy = this.response.data.gc_booking_date;
				this.bookingdate = this.datePipe.transform(
					this.bookingdate,
					"dd/MM/yyyy"
				);
				this.policyType = this.response.data.policy_type;
				this.policyInceptionDate = this.response.data.policy_inception_date;
				this.inceptionDate = this.response.data.policy_inception_date;
				this.PolicyEffectiveDate = this.response.data.portal_effective_date;
				this.policyExpiryDate = this.response.data.policy_expiry_date;
				this.expiryDate = this.response.data.policy_expiry_date;
				this.policyLockDate = this.response.data.portal_lock_date;
				this.policyCurrencyType = this.response.data.policy_currency_type;
				if (
					this.response.data.renewal_counter + "" != null &&
					this.response.data.renewal_counter + "" != ""
				)
					this.renewalCounter = Math.floor(this.response.data.renewal_counter);
				else this.renewalCounter = "";
				this.policyNumber = this.response.data.policy_ref_num;
				this.policyNumberForDispaly = this.response.data.policy_number;
				this.producerCode = this.response.data.producer_code;
				this.sme = this.response.data.sme;
				this.tagicRMemail = this.response.data.tagic_rm_email;
				this.totalPremium = this.response.data.policy_total_premium;
				this.insuredId = this.response.data.insured_id;
				this.policyNetPremium = this.response.data.policy_net_premium;
				this.policyServiceTax = this.response.data.policy_service_tax;
				this.policyStampDuty = this.response.data.policy_stamp_duty;
				this.selectGroup.patchValue({
					groupNameValue: this.response.data.group_name,
				});
				this.underwriterEmail = this.response.data.underwriter_email;
				if (this.policyType == "STOP" || this.policyType == "Project Policy") {
					for (let i = 0; i < this.response.data.voyage.length; i++) {
						if (this.response.data.voyage[i].rate_applicable != "No") {
							this.voyageArrForDisplay.push(this.response.data.voyage[i]);
						}
					}
				} else this.voyageArrForDisplay = this.response.data.voyage || [];
				this.voyageArr = this.response.data.voyage || [];

				if (Number(this.response.data.tax_applicable) > 0) this.tax = "Yes";
				else this.tax = "No";

				this.producerName = this.response.data.producer_name;
				this.producerBranchCode = this.response.data.producer_branch_code;
				this.producerBranch = this.response.data.producer_branch_name;
				this.producerPhoneNumber = this.response.data.producer_phone_no;
				this.producerEmail = this.response.data.producer_email;
				this.insuredName = this.response.data.insured_name;
				this.insuredAdd1 = this.response.data.insured_add1;
				this.insuredAdd2 = this.response.data.insured_add2;
				this.insuredAdd3 = this.response.data.insured_add3;
				this.insuredCity = this.response.data.insured_city;
				this.insuredDistrict = this.response.data.insured_district;
				this.insuredState = this.response.data.insured_state;
				this.insuredCountry = this.response.data.insured_country;
				this.insuredZipcode = this.response.data.insured_zipcode;
				this.insuredGSTINNumber = this.response.data.insured_gstin;

				for (let i = 0; i < this.voyageArr.length; i++) {
					let voyage = this.voyageArr[i];
					for (let j = 0; j < voyage.sub_voyage.length; j++) {
						if (voyage.sub_voyage.length > 0) {
							var fromCountry = voyage.sub_voyage[j].from_country;
							var toCountry = voyage.sub_voyage[j].to_country;
							var fromCountryvalue = "",
								toCountryvalue = "";
							if (fromCountry != "" && fromCountry != null)
								fromCountryvalue = fromCountry.replace(/~/g, ",");
							if (toCountry != "" && toCountry != null)
								toCountryvalue = toCountry.replace(/~/g, ",");
							let openingBalance = "",
								siPercent = "",
								premiumBalance = "";
							if (voyage.sub_voyage[j].si_percentage > 0) {
								siPercent = voyage.sub_voyage[j].si_percentage;
								openingBalance = voyage.sub_voyage[j].opening_balance;
								premiumBalance = voyage.sub_voyage[j].premium_balance;
							}

							this.voyageArrGridData.push({
								voyage_name: voyage.sub_voyage[j].voyage_name,
								sub_voyage_name: voyage.sub_voyage[j].sub_voyage_name,
								initial_sum_insured: voyage.initial_sum_insured,
								certificate_allowed: voyage.sub_voyage[j].certificate_allowed,
								declaration_type: voyage.declaration_type_sub_voyage,
								bulk_declaration_type:
									voyage.sub_voyage[j].bulk_declaration_type,
								bov_percentage: voyage.sub_voyage[j].bov_percentage,
								per_seeding_limit: voyage.sub_voyage[j].per_seeding_limit,
								transit_excees: voyage.sub_voyage[j].transit_excees,
								min_shipment_premium: voyage.sub_voyage[j].min_shipment_premium,
								low_balance_trigger: voyage.low_balance_trigger,
								low_balance_trigger_amount: voyage.low_balance_trigger_amount,
								back_date_days: voyage.sub_voyage[j].back_date_days,
								days_post_expiry: voyage.sub_voyage[j].days_post_expiry,
								mode_of_conveyance: voyage.sub_voyage[j].mode_of_conveyance,
								display_premium: voyage.sub_voyage[j].display_premium,
								non_standard_clauses: voyage.sub_voyage[j].non_standard_clauses,
								from_country: voyage.sub_voyage[j].from_country,
								to_country: voyage.sub_voyage[j].to_country,
								from_country_split: fromCountryvalue,
								to_country_split: toCountryvalue,
								id: voyage.sub_voyage[j].id,
								coverage_type: voyage.sub_voyage[j].coverage_type,
								certificate_bulk: voyage.sub_voyage[j].certificate_bulk,
								transit_excess_in_certificate:
									voyage.sub_voyage[j].transit_excess_in_certificate,
								client_in_certificate:
									voyage.sub_voyage[j].client_in_certificate,
								si_percentage: voyage.sub_voyage[j].si_percentage,
								opening_balance: voyage.sub_voyage[j].opening_balance,
								si_percentage_display: siPercent,
								opening_balance_display: openingBalance,
								gc_running_id: voyage.sub_voyage[j].gc_running_id,
								net_premium: voyage.net_premium,
								net_premium_with_tax: voyage.net_premium_with_tax,
								premium_balance: voyage.sub_voyage[j].premium_balance,
								premium_balance_display: premiumBalance,
								marine_final_rate_percentage:
									voyage.sub_voyage[j].marine_final_rate_percentage,
								voyage_description: voyage.voyage_description,
							});
						}
					}
				}

				for (let i = 0; i < this.voyageArr.length; i++) {
					this.voyageArrData.push({
						gc_running_id: this.voyageArr[i].gc_running_id,
						si_percentage: this.voyageArr[i].si_percentage,
						opening_balance: this.voyageArr[i].opening_balance,
						client_users: this.voyageArr[i].client_users,
						producer_users: this.voyageArr[i].producer_users,
						rate_applicable: this.voyageArr[i].rate_applicable,
						low_balance_trigger: this.voyageArr[i].low_balance_trigger,
						low_balance_trigger_amount:
							this.voyageArr[i].low_balance_trigger_amount,
						declaration_type_sub_voyage:
							this.voyageArr[i].declaration_type_sub_voyage,
						voyage_description: this.voyageArr[i].voyage_description,
					});
					this.voyageArrForPolicy.push({
						gc_running_id: this.voyageArr[i].gc_running_id,
						voyage_name: this.voyageArr[i].voyage_name,
						voyage_description: this.voyageArr[i].voyage_description,
						initial_sum_insured: this.voyageArr[i].initial_sum_insured,
						marine_final_rate_percentage:
							this.voyageArr[i].marine_final_rate_percentage,
						net_premium: this.voyageArr[i].net_premium,
						net_premium_with_tax: this.voyageArr[i].net_premium_with_tax,
						rate_applicable: this.voyageArr[i].rate_applicable,
						back_date_days: this.voyageArr[i].back_date_days,
						bov_percentage: this.voyageArr[i].bov_percentage,
						bulk_declaration_type: this.voyageArr[i].bulk_declaration_type,
						coverage_type: this.voyageArr[i].coverage_type,
						declaration_type: this.voyageArr[i].declaration_type,
						declaration_type_sub_voyage:
							this.voyageArr[i].declaration_type_sub_voyage,
						display_premium: this.voyageArr[i].display_premium,
						low_balance_trigger: this.voyageArr[i].low_balance_trigger,
						low_balance_trigger_amount:
							this.voyageArr[i].low_balance_trigger_amount,
						min_shipment_premium: this.voyageArr[i].min_shipment_premium,
						mode_of_conveyance: this.voyageArr[i].mode_of_conveyance,
						non_standard_clauses: this.voyageArr[i].non_standard_clauses,
						per_seeding_limit: this.voyageArr[i].per_seeding_limit,
						transit_excees: this.voyageArr[i].transit_excees,
						annual_estimate_turnover:
							this.voyageArr[i].annual_estimate_turnover,
						risk_detail_serial: this.voyageArr[i].risk_detail_serial,
					});
				}
			} else if (this.response.status != -114) {
				this.commonService.errorsmsg(this.response.txt, "Error");
			}
		} else {
			/* let id = this.cookie.get('policyId').split(','); */
			let idArray = window.localStorage.getItem("policyId") + "";
			let id = idArray.split(",");
			let endorsementResponse,
				voyageArrayResponse = [],
				endorsementArray = [],
				endorsementDataArray = [],
				voyageArrayDataResponse = [];
			/* this.policyReferenceNumber = this.cookie.get('referenceNumber'); */
			this.policyReferenceNumber =
				window.localStorage.getItem("referenceNumber");
			let voyageArray = [];
			let voyageArrayDisplay = [];
			let subvoyageArray = [];
			url = this.commonVariablesService.baseURL + "api/v1/policy";
			for (let i = 0; i < id.length; i++) {
				parameter = {
					policy_id: id[i],
				};
				let url1 =
					this.commonVariablesService.baseURL +
					"api/v2/endorsement/list/" +
					id[i];
				let flag = 0,
					flag1 = 0;
				contentType = "";
				this.response = await this.commonService.httpGetMethod(
					url,
					contentType,
					true,
					parameter,
					"Policy Configuration"
				);
				this.voyagePolicy.push({
					voyage_name: this.response.data[0].quote.data.voyage.voyage_name,
					policy_no: this.response.data[0].policy.policy_no,
					declaration_type:
					  this.response.data[0].quote.data.voyage.declaration_type,
				  });
				let response = await this.commonService.httpGetMethod(
					url1,
					contentType,
					true,
					"",
					"Policy Configuration"
				);
				if (response.status == 0) {
					endorsementArray = [];
					voyageArrayResponse = [];
					endorsementDataArray = [];
					voyageArrayDataResponse = [];
					if (response.data.length > 0) {
						let local_id = [];
						for (let x = 0; x < response.data.length; x++) {
							if (response.data[x].status == 0) {
								local_id.push(response.data[x].endorsement_index);
							}
						}
						const max = local_id.reduce((a, b) => Math.max(a, b));
						let param;
						for (let y = 0; y < response.data.length; y++) {
							if (response.data[y].endorsement_index == max) {
								param = {
									endorsement_id: response.data[y].endorsement_id,
								};
							}
						}
						let endorsementurl =
							this.commonVariablesService.baseURL + "api/v2/endorsement";

						endorsementResponse = await this.commonService.httpGetMethod(
							endorsementurl,
							contentType,
							true,
							param,
							"Policy Configuration"
						);
						if (endorsementResponse.status == 0) {
							this.endorsementStartDate =
								endorsementResponse.data[0].eproposal.data.endorsement_start_date;
							this.isShowEndorsementStartDate = true;
							endorsementArray.push(
								endorsementResponse.data[0].eproposal.data.voyage
							);
							endorsementDataArray.push(
								endorsementResponse.data[0].eproposal.data
							);
							this.endorsementPolicyReferenceNumber =
								endorsementResponse.data[0].eproposal.data.policy_ref_num;
						} else if (endorsementResponse.status != -114)
							this.commonService.errorsmsg(response.txt, "Error");
					}
				} else if (response.status != -114)
					this.commonService.errorsmsg(response.txt, "Error");
				if (endorsementArray.length > 0) {
					voyageArrayResponse = endorsementArray;
					voyageArrayDataResponse = endorsementDataArray;
				} else {
					voyageArrayResponse.push(this.response.data[0].quote.data.voyage);
					voyageArrayDataResponse.push(this.response.data[0].quote.data);
				}
				this.policyType = voyageArrayDataResponse[0].policy_type;
				let subvoyage = this.response.data[0].data.sub_voyage;
				if (voyageArray.length == 0) {
					voyageArray.push({
						gc_running_id: voyageArrayResponse[0].gc_running_id,
						voyage_name: voyageArrayResponse[0].voyage_name,
						voyage_description: voyageArrayResponse[0].voyage_description,
						initial_sum_insured: voyageArrayResponse[0].initial_sum_insured,
						marine_final_rate_percentage:
							voyageArrayResponse[0].marine_final_rate_percentage,
						net_premium: voyageArrayResponse[0].net_premium,
						net_premium_with_tax: voyageArrayResponse[0].net_premium_with_tax,
						rate_applicable: voyageArrayResponse[0].rate_applicable,
						back_date_days: voyageArrayResponse[0].back_date_days,
						bov_percentage: voyageArrayResponse[0].bov_percentage,
						bulk_declaration_type: voyageArrayResponse[0].bulk_declaration_type,
						coverage_type: voyageArrayResponse[0].coverage_type,
						declaration_type: voyageArrayResponse[0].declaration_type,
						declaration_type_sub_voyage:
							this.response.data[0].data.declaration_type_sub_voyage,
						display_premium: voyageArrayResponse[0].display_premium,
						low_balance_trigger: this.response.data[0].data.low_balance_trigger,
						low_balance_trigger_amount:
							this.response.data[0].data.low_balance_trigger_amount,
						min_shipment_premium: voyageArrayResponse[0].min_shipment_premium,
						mode_of_conveyance: voyageArrayResponse[0].mode_of_conveyance,
						non_standard_clauses: voyageArrayResponse[0].non_standard_clauses,
						per_seeding_limit: voyageArrayResponse[0].per_seeding_limit,
						transit_excees: voyageArrayResponse[0].transit_excees,
						client_users: this.response.data[0].data.client_users,
						producer_users: this.response.data[0].data.producer_users,
						policy_id: this.response.data[0].policy_id,
						policy_ref_num: this.response.data[0].cust_fld_3,
						policy_no: this.response.data[0].policy_no,
					});
					if (
						this.policyType == "STOP" ||
						this.policyType == "Project Policy"
					) {
						if (voyageArrayResponse[0].rate_applicable != "No") {
							voyageArrayDisplay.push({
								gc_running_id: voyageArrayResponse[0].gc_running_id,
								voyage_name: voyageArrayResponse[0].voyage_name,
								voyage_description: voyageArrayResponse[0].voyage_description,
								initial_sum_insured: voyageArrayResponse[0].initial_sum_insured,
								marine_final_rate_percentage:
									voyageArrayResponse[0].marine_final_rate_percentage,
								net_premium: voyageArrayResponse[0].net_premium,
								net_premium_with_tax:
									voyageArrayResponse[0].net_premium_with_tax,
								rate_applicable: voyageArrayResponse[0].rate_applicable,
								back_date_days: voyageArrayResponse[0].back_date_days,
								bov_percentage: voyageArrayResponse[0].bov_percentage,
								bulk_declaration_type:
									voyageArrayResponse[0].bulk_declaration_type,
								coverage_type: voyageArrayResponse[0].coverage_type,
								declaration_type: voyageArrayResponse[0].declaration_type,
								display_premium: voyageArrayResponse[0].display_premium,
								low_balance_trigger: this.response.data[0].data,
								low_balance_trigger_amount:
									this.response.data[0].data.low_balance_trigger_amount,
								min_shipment_premium:
									voyageArrayResponse[0].min_shipment_premium,
								mode_of_conveyance: voyageArrayResponse[0].mode_of_conveyance,
								non_standard_clauses:
									voyageArrayResponse[0].non_standard_clauses,
								per_seeding_limit: voyageArrayResponse[0].per_seeding_limit,
								transit_excees: voyageArrayResponse[0].transit_excees,
								client_users: this.response.data[0].data.client_users,
								producer_users: this.response.data[0].data.producer_users,
								policy_id: this.response.data[0].policy_id,
								policy_ref_num: this.response.data[0].cust_fld_3,
								policy_no: this.response.data[0].policy_no,
								declaration_type_sub_voyage:
									this.response.data[0].data.declaration_type_sub_voyage,
							});
						}
					} else
						voyageArrayDisplay.push({
							gc_running_id: voyageArrayResponse[0].gc_running_id,
							voyage_name: voyageArrayResponse[0].voyage_name,
							voyage_description: voyageArrayResponse[0].voyage_description,
							initial_sum_insured: voyageArrayResponse[0].initial_sum_insured,
							marine_final_rate_percentage:
								voyageArrayResponse[0].marine_final_rate_percentage,
							net_premium: voyageArrayResponse[0].net_premium,
							net_premium_with_tax: voyageArrayResponse[0].net_premium_with_tax,
							rate_applicable: voyageArrayResponse[0].rate_applicable,
							back_date_days: voyageArrayResponse[0].back_date_days,
							bov_percentage: voyageArrayResponse[0].bov_percentage,
							bulk_declaration_type:
								voyageArrayResponse[0].bulk_declaration_type,
							coverage_type: voyageArrayResponse[0].coverage_type,
							declaration_type: voyageArrayResponse[0].declaration_type,
							display_premium: voyageArrayResponse[0].display_premium,
							low_balance_trigger:
								this.response.data[0].data.low_balance_trigger,
							low_balance_trigger_amount:
								this.response.data[0].data.low_balance_trigger_amount,
							min_shipment_premium: voyageArrayResponse[0].min_shipment_premium,
							mode_of_conveyance: voyageArrayResponse[0].mode_of_conveyance,
							non_standard_clauses: voyageArrayResponse[0].non_standard_clauses,
							per_seeding_limit: voyageArrayResponse[0].per_seeding_limit,
							transit_excees: voyageArrayResponse[0].transit_excees,
							client_users: this.response.data[0].data.client_users,
							producer_users: this.response.data[0].data.producer_users,
							policy_id: this.response.data[0].policy_id,
							policy_ref_num: this.response.data[0].cust_fld_3,
							policy_no: this.response.data[0].policy_no,
							declaration_type_sub_voyage:
								this.response.data[0].data.declaration_type_sub_voyage,
						});
				} else {
					for (let count = 0; count < voyageArray.length; count++) {
						if (
							voyageArray[count].gc_running_id ==
							voyageArrayResponse[0].gc_running_id
						) {
							flag = 1;
							break;
						}
					}
					if (flag == 0) {
						voyageArray.push({
							gc_running_id: voyageArrayResponse[0].gc_running_id,
							voyage_name: voyageArrayResponse[0].voyage_name,
							voyage_description: voyageArrayResponse[0].voyage_description,
							initial_sum_insured: voyageArrayResponse[0].initial_sum_insured,
							marine_final_rate_percentage:
								voyageArrayResponse[0].marine_final_rate_percentage,
							net_premium: voyageArrayResponse[0].net_premium,
							net_premium_with_tax: voyageArrayResponse[0].net_premium_with_tax,
							rate_applicable: voyageArrayResponse[0].rate_applicable,
							back_date_days: voyageArrayResponse[0].back_date_days,
							bov_percentage: voyageArrayResponse[0].bov_percentage,
							bulk_declaration_type:
								voyageArrayResponse[0].bulk_declaration_type,
							coverage_type: voyageArrayResponse[0].coverage_type,
							declaration_type: voyageArrayResponse[0].declaration_type,
							declaration_type_sub_voyage:
								this.response.data[0].data.declaration_type_sub_voyage,
							display_premium: voyageArrayResponse[0].display_premium,
							low_balance_trigger:
								this.response.data[0].data.low_balance_trigger,
							low_balance_trigger_amount:
								this.response.data[0].data.low_balance_trigger_amount,
							min_shipment_premium: voyageArrayResponse[0].min_shipment_premium,
							mode_of_conveyance: voyageArrayResponse[0].mode_of_conveyance,
							non_standard_clauses: voyageArrayResponse[0].non_standard_clauses,
							per_seeding_limit: voyageArrayResponse[0].per_seeding_limit,
							transit_excees: voyageArrayResponse[0].transit_excees,
							client_users: this.response.data[0].data.client_users,
							producer_users: this.response.data[0].data.producer_users,
							policy_id: this.response.data[0].policy_id,
							policy_ref_num: this.response.data[0].cust_fld_3,
							policy_no: this.response.data[0].policy_no,
						});
						if (
							this.policyType == "STOP" ||
							this.policyType == "Project Policy"
						) {
							if (voyageArrayResponse[0].rate_applicable != "No") {
								voyageArrayDisplay.push({
									gc_running_id: voyageArrayResponse[0].gc_running_id,
									voyage_name: voyageArrayResponse[0].voyage_name,
									voyage_description: voyageArrayResponse[0].voyage_description,
									initial_sum_insured:
										voyageArrayResponse[0].initial_sum_insured,
									marine_final_rate_percentage:
										voyageArrayResponse[0].marine_final_rate_percentage,
									net_premium: voyageArrayResponse[0].net_premium,
									net_premium_with_tax:
										voyageArrayResponse[0].net_premium_with_tax,
									rate_applicable: voyageArrayResponse[0].rate_applicable,
									back_date_days: voyageArrayResponse[0].back_date_days,
									bov_percentage: voyageArrayResponse[0].bov_percentage,
									bulk_declaration_type:
										voyageArrayResponse[0].bulk_declaration_type,
									coverage_type: voyageArrayResponse[0].coverage_type,
									declaration_type: voyageArrayResponse[0].declaration_type,
									display_premium: voyageArrayResponse[0].display_premium,
									low_balance_trigger:
										this.response.data[0].data.low_balance_trigger,
									low_balance_trigger_amount:
										this.response.data[0].data.low_balance_trigger_amount,
									min_shipment_premium:
										voyageArrayResponse[0].min_shipment_premium,
									mode_of_conveyance: voyageArrayResponse[0].mode_of_conveyance,
									non_standard_clauses:
										voyageArrayResponse[0].non_standard_clauses,
									per_seeding_limit: voyageArrayResponse[0].per_seeding_limit,
									transit_excees: voyageArrayResponse[0].transit_excees,
									client_users: this.response.data[0].data.client_users,
									producer_users: this.response.data[0].data.producer_users,
									policy_id: this.response.data[0].policy_id,
									policy_ref_num: this.response.data[0].cust_fld_3,
									policy_no: this.response.data[0].policy_no,
									declaration_type_sub_voyage:
										this.response.data[0].data.declaration_type_sub_voyage,
								});
							}
						} else
							voyageArrayDisplay.push({
								gc_running_id: voyageArrayResponse[0].gc_running_id,
								voyage_name: voyageArrayResponse[0].voyage_name,
								voyage_description: voyageArrayResponse[0].voyage_description,
								initial_sum_insured: voyageArrayResponse[0].initial_sum_insured,
								marine_final_rate_percentage:
									voyageArrayResponse[0].marine_final_rate_percentage,
								net_premium: voyageArrayResponse[0].net_premium,
								net_premium_with_tax:
									voyageArrayResponse[0].net_premium_with_tax,
								rate_applicable: voyageArrayResponse[0].rate_applicable,
								back_date_days: voyageArrayResponse[0].back_date_days,
								bov_percentage: voyageArrayResponse[0].bov_percentage,
								bulk_declaration_type:
									voyageArrayResponse[0].bulk_declaration_type,
								coverage_type: voyageArrayResponse[0].coverage_type,
								declaration_type: voyageArrayResponse[0].declaration_type,
								display_premium: voyageArrayResponse[0].display_premium,
								low_balance_trigger:
									this.response.data[0].data.low_balance_trigger,
								low_balance_trigger_amount:
									this.response.data[0].data.low_balance_trigger_amount,
								min_shipment_premium:
									voyageArrayResponse[0].min_shipment_premium,
								mode_of_conveyance: voyageArrayResponse[0].mode_of_conveyance,
								non_standard_clauses:
									voyageArrayResponse[0].non_standard_clauses,
								per_seeding_limit: voyageArrayResponse[0].per_seeding_limit,
								transit_excees: voyageArrayResponse[0].transit_excees,
								client_users: this.response.data[0].data.client_users,
								producer_users: this.response.data[0].data.producer_users,
								policy_id: this.response.data[0].policy_id,
								policy_ref_num: this.response.data[0].cust_fld_3,
								policy_no: this.response.data[0].policy_no,
								declaration_type_sub_voyage:
									this.response.data[0].data.declaration_type_sub_voyage,
							});
					}
				}
				if (subvoyage.length > 0) {
					if (subvoyageArray.length == 0) {
						for (let idx = 0; idx < voyageArray.length; idx++) {
							for (
								let innner_idx = 0;
								innner_idx < subvoyage.length;
								innner_idx++
							) {
								if (
									voyageArray[idx].gc_running_id ==
									subvoyage[innner_idx].gc_running_id
								) {
									var fromCountry_subvoyage =
										subvoyage[innner_idx].from_country;
									var toCountry_subvoyage = subvoyage[innner_idx].to_country;
									var fromCountryvalue_subvoyage = "",
										toCountryvalue_subvoyage = "";
									if (
										fromCountry_subvoyage != "" &&
										fromCountry_subvoyage != null
									)
										fromCountryvalue_subvoyage = fromCountry_subvoyage.replace(
											/~/g,
											","
										);
									if (toCountry_subvoyage != "" && toCountry_subvoyage != null)
										toCountryvalue_subvoyage = toCountry_subvoyage.replace(
											/~/g,
											","
										);
									let openingBalance = "",
										siPercent = "",
										premiumBalance = "";
									let openingBalanceDisplay = "",
										siPercentDisplay = "",
										premiumBalanceDisplay = "";
									if (
										this.policyType == "STOP" ||
										this.policyType == "Project Policy"
									) {
										if (subvoyage[innner_idx].certificate_allowed == "Yes") {
											openingBalance =
												this.response.data[0].data
													.opening_balance_certificateyes;
											siPercent =
												this.response.data[0].data.si_percentage_certificateyes;
											premiumBalance =
												this.response.data[0].data
													.premium_balance_certificateyes;
										} else if (
											subvoyage[innner_idx].certificate_allowed == "No"
										) {
											openingBalance =
												this.response.data[0].data
													.opening_balance_certificateno;
											siPercent =
												this.response.data[0].data.si_percentage_certificateno;
											premiumBalance =
												this.response.data[0].data
													.premium_balance_certificateno;
										}
									} else if (
										this.policyType == "MOP" ||
										this.policyType == "Open Cover"
									) {
										if (
											subvoyage[innner_idx].certificate_bulk.includes("Bulk")
										) {
											openingBalance =
												this.response.data[0].data.opening_balance_bulk;
											siPercent = this.response.data[0].data.si_percentage_bulk;
											premiumBalance =
												this.response.data[0].data.premium_balance_bulk;
										} else if (
											subvoyage[innner_idx].certificate_bulk.includes(
												"Certificate"
											)
										) {
											openingBalance =
												this.response.data[0].data.opening_balance_certificate;
											siPercent =
												this.response.data[0].data.si_percentage_certificate;
											premiumBalance =
												this.response.data[0].data.premium_balance_certificate;
										}
									}
									if (siPercent != "0") {
										openingBalanceDisplay = openingBalance;
										siPercentDisplay = siPercent;
										premiumBalanceDisplay = premiumBalance;
									}
									/* if (siPercent == '0') {
										openingBalanceDisplay = "";
										siPercentDisplay = "";
										premiumBalanceDisplay = "";
									} else {
										openingBalanceDisplay = openingBalance;
										siPercentDisplay = siPercent;
										premiumBalanceDisplay = premiumBalance;
									} */
									subvoyageArray.push({
										sub_voyage_name: subvoyage[innner_idx].sub_voyage_name,
										initial_sum_insured:
											voyageArrayResponse[0].initial_sum_insured,
										certificate_allowed:
											subvoyage[innner_idx].certificate_allowed,
										declaration_type:
											this.response.data[0].data.declaration_type_sub_voyage,
										bulk_declaration_type:
											subvoyage[innner_idx].bulk_declaration_type,
										bov_percentage: subvoyage[innner_idx].bov_percentage,
										per_seeding_limit: subvoyage[innner_idx].per_seeding_limit,
										transit_excees: subvoyage[innner_idx].transit_excees,
										min_shipment_premium:
											subvoyage[innner_idx].min_shipment_premium,
										low_balance_trigger:
											this.response.data[0].data.low_balance_trigger,
										low_balance_trigger_amount:
											this.response.data[0].data.low_balance_trigger_amount,
										back_date_days: subvoyage[innner_idx].back_date_days,
										days_post_expiry: subvoyage[innner_idx].days_post_expiry,
										mode_of_conveyance:
											subvoyage[innner_idx].mode_of_conveyance,
										display_premium: subvoyage[innner_idx].display_premium,
										non_standard_clauses:
											subvoyage[innner_idx].non_standard_clauses,
										from_country: subvoyage[innner_idx].from_country,
										to_country: subvoyage[innner_idx].to_country,
										id: subvoyage[innner_idx].id,
										coverage_type: subvoyage[innner_idx].coverage_type,
										certificate_bulk: subvoyage[innner_idx].certificate_bulk,
										transit_excess_in_certificate:
											subvoyage[innner_idx].transit_excess_in_certificate,
										client_in_certificate:
											subvoyage[innner_idx].client_in_certificate,
										gc_running_id: subvoyage[innner_idx].gc_running_id,
										marine_final_rate_percentage:
											subvoyage[innner_idx].marine_final_rate_percentage,
										net_premium: voyageArrayResponse[0].net_premium,
										net_premium_with_tax:
											voyageArrayResponse[0].net_premium_with_tax,
										opening_balance: openingBalance,
										premium_balance: premiumBalance,
										si_percentage: siPercent,
										opening_balance_display: openingBalanceDisplay,
										premium_balance_display: premiumBalanceDisplay,
										si_percentage_display: siPercentDisplay,
										voyage_name: voyageArrayResponse[0].voyage_name,
										voyage_description:
											voyageArrayResponse[0].voyage_description,
										policy_id: this.response.data[0].policy_id,
										from_country_split: fromCountryvalue_subvoyage,
										to_country_split: toCountryvalue_subvoyage,
									});
									this.totalPremium =
										voyageArrayDataResponse[0].policy_total_premium;
									this.bookingdate = voyageArrayDataResponse[0].gc_booking_date;
									this.bookingdate = this.datePipe.transform(
										this.bookingdate,
										"dd/MM/yyyy"
									);
									this.policyInceptionDate =
										voyageArrayDataResponse[0].gc_policy_start_date;
									this.inceptionDate =
										voyageArrayDataResponse[0].gc_policy_start_date;
									this.PolicyEffectiveDate =
										this.response.data[0].data.portal_effective_date;
									this.policyExpiryDate =
										voyageArrayDataResponse[0].gc_policy_end_date;
									this.expiryDate =
										voyageArrayDataResponse[0].gc_policy_end_date;
									this.policyLockDate =
										this.response.data[0].data.portal_lock_date;
									this.policyCurrencyType =
										voyageArrayDataResponse[0].policy_currency_type;
									//this.renewalCounter = voyageArrayDataResponse[0].renewal_counter;

									if (
										voyageArrayDataResponse[0].renewal_counter + "" != null &&
										voyageArrayDataResponse[0].renewal_counter + "" != ""
									) {
										this.renewalCounter = Math.floor(
											voyageArrayDataResponse[0].renewal_counter
										);
									} else this.renewalCounter = "";
									this.policyNumber = this.response.data[0].cust_fld_3;
									this.policyNumberForDispaly =
										this.response.data[0].cust_fld_1;
									this.producerCode = voyageArrayDataResponse[0].producer_code;
									this.tagicRMemail = this.response.data[0].data.tagic_rm_email;
									this.insuredId = voyageArrayDataResponse[0].insured_id;
									this.selectGroup.patchValue({
										groupNameValue: this.response.data[0].data.group_name,
									});
									this.underwriterEmail =
										this.response.data[0].data.underwriter_email;
									this.producerName = voyageArrayDataResponse[0].producer_name;
									this.producerBranchCode =
										voyageArrayDataResponse[0].producer_branch_code;
									this.producerBranch =
										voyageArrayDataResponse[0].producer_branch_name;
									this.producerPhoneNumber =
										voyageArrayDataResponse[0].producer_phone_no;
									this.producerEmail =
										voyageArrayDataResponse[0].producer_email;
									this.insuredName = voyageArrayDataResponse[0].insured_name;
									this.insuredAdd1 = voyageArrayDataResponse[0].insured_add1;
									this.insuredAdd2 = voyageArrayDataResponse[0].insured_add2;
									this.insuredAdd3 = voyageArrayDataResponse[0].insured_add3;
									this.insuredCity = voyageArrayDataResponse[0].insured_city;
									this.insuredState = voyageArrayDataResponse[0].insured_state;
									this.insuredCountry =
										voyageArrayDataResponse[0].insured_country;
									this.insuredZipcode =
										voyageArrayDataResponse[0].insured_zipcode;
									this.insuredGSTINNumber =
										voyageArrayDataResponse[0].insured_gstin;
									/* this.policyNumberMetaData = this.response.data[0].policy_no; */
								}
							}
						}
					} else {
						for (let count = 0; count < subvoyageArray.length; count++) {
							for (let count1 = 0; count1 < subvoyage.length; count1++) {
								if (subvoyageArray[count].id == subvoyage[count1].id) {
									flag1 = 1;
									break;
								}
							}
						}
						if (flag1 == 0) {
							for (let idx = 0; idx < voyageArray.length; idx++) {
								for (
									let innner_idx = 0;
									innner_idx < subvoyage.length;
									innner_idx++
								) {
									if (
										voyageArray[idx].gc_running_id ==
										subvoyage[innner_idx].gc_running_id
									) {
										//this.policyType = this.response.data[0].quote.data.policy_type;
										var fromCountry_voyage = subvoyage[innner_idx].from_country;
										var toCountry_voyage = subvoyage[innner_idx].to_country;
										var fromCountryvalue_voyage = "",
											toCountryvalue_voyage = "";
										if (fromCountry_voyage != "" && fromCountry_voyage != null)
											fromCountryvalue_voyage = fromCountry_voyage.replace(
												/~/g,
												","
											);
										if (toCountry_voyage != "" && toCountry_voyage != null)
											toCountryvalue_voyage = toCountry_voyage.replace(
												/~/g,
												","
											);
										let openingBalance = "",
											siPercent = "",
											premiumBalance = "";
										let openingBalanceDisplay = "",
											siPercentDisplay = "",
											premiumBalanceDisplay = "";
										if (
											this.policyType == "STOP" ||
											this.policyType == "Project Policy"
										) {
											if (subvoyage[innner_idx].certificate_allowed == "Yes") {
												openingBalance =
													this.response.data[0].data
														.opening_balance_certificateyes;
												siPercent =
													this.response.data[0].data
														.si_percentage_certificateyes;
												premiumBalance =
													this.response.data[0].data
														.premium_balance_certificateyes;
											} else if (
												subvoyage[innner_idx].certificate_allowed == "No"
											) {
												openingBalance =
													this.response.data[0].data
														.opening_balance_certificateno;
												siPercent =
													this.response.data[0].data
														.si_percentage_certificateno;
												premiumBalance =
													this.response.data[0].data
														.premium_balance_certificateno;
											}
										} else if (
											this.policyType == "MOP" ||
											this.policyType == "Open Cover"
										) {
											if (
												subvoyage[innner_idx].certificate_bulk.includes("Bulk")
											) {
												openingBalance =
													this.response.data[0].data.opening_balance_bulk;
												siPercent =
													this.response.data[0].data.si_percentage_bulk;
												premiumBalance =
													this.response.data[0].data.premium_balance_bulk;
											} else if (
												subvoyage[innner_idx].certificate_bulk.includes(
													"Certificate"
												)
											) {
												openingBalance =
													this.response.data[0].data
														.opening_balance_certificate;
												siPercent =
													this.response.data[0].data.si_percentage_certificate;
												premiumBalance =
													this.response.data[0].data
														.premium_balance_certificate;
											}
										}
										if (siPercent != "0") {
											openingBalanceDisplay = openingBalance;
											siPercentDisplay = siPercent;
											premiumBalanceDisplay = premiumBalance;
										}
										/* if (siPercent == '0') {
											openingBalanceDisplay = "";
											siPercentDisplay = "";
											premiumBalanceDisplay = "";
										} else {
											openingBalanceDisplay = openingBalance;
											siPercentDisplay = siPercent;
											premiumBalanceDisplay = premiumBalance;
										} */
										subvoyageArray.push({
											sub_voyage_name: subvoyage[innner_idx].sub_voyage_name,
											initial_sum_insured:
												voyageArrayResponse[0].initial_sum_insured,
											certificate_allowed:
												subvoyage[innner_idx].certificate_allowed,
											declaration_type:
												this.response.data[0].data.declaration_type_sub_voyage,
											bulk_declaration_type:
												subvoyage[innner_idx].bulk_declaration_type,
											bov_percentage: subvoyage[innner_idx].bov_percentage,
											per_seeding_limit:
												subvoyage[innner_idx].per_seeding_limit,
											transit_excees: subvoyage[innner_idx].transit_excees,
											min_shipment_premium:
												subvoyage[innner_idx].min_shipment_premium,
											low_balance_trigger:
												this.response.data[0].data.low_balance_trigger,
											low_balance_trigger_amount:
												this.response.data[0].data.low_balance_trigger_amount,
											back_date_days: subvoyage[innner_idx].back_date_days,
											days_post_expiry: subvoyage[innner_idx].days_post_expiry,
											mode_of_conveyance:
												subvoyage[innner_idx].mode_of_conveyance,
											display_premium: subvoyage[innner_idx].display_premium,
											non_standard_clauses:
												subvoyage[innner_idx].non_standard_clauses,
											from_country: subvoyage[innner_idx].from_country,
											to_country: subvoyage[innner_idx].to_country,
											id: subvoyage[innner_idx].id,
											coverage_type: subvoyage[innner_idx].coverage_type,
											certificate_bulk: subvoyage[innner_idx].certificate_bulk,
											transit_excess_in_certificate:
												subvoyage[innner_idx].transit_excess_in_certificate,
											client_in_certificate:
												subvoyage[innner_idx].client_in_certificate,
											gc_running_id: subvoyage[innner_idx].gc_running_id,
											marine_final_rate_percentage:
												subvoyage[innner_idx].marine_final_rate_percentage,
											net_premium: voyageArrayResponse[0].net_premium,
											net_premium_with_tax:
												voyageArrayResponse[0].net_premium_with_tax,
											opening_balance: openingBalance,
											premium_balance: premiumBalance,
											si_percentage: siPercent,
											opening_balance_display: openingBalanceDisplay,
											premium_balance_display: premiumBalanceDisplay,
											si_percentage_display: siPercentDisplay,
											voyage_name: voyageArrayResponse[0].voyage_name,
											voyage_description:
												voyageArrayResponse[0].voyage_description,
											policy_id: this.response.data[0].policy_id,
											from_country_split: fromCountryvalue_voyage,
											to_country_split: toCountryvalue_voyage,
										});
										this.totalPremium =
											voyageArrayDataResponse[0].policy_total_premium;
										this.bookingdate =
											voyageArrayDataResponse[0].gc_booking_date;
										this.bookingdate = this.datePipe.transform(
											this.bookingdate,
											"dd/MM/yyyy"
										);

										this.policyInceptionDate =
											voyageArrayDataResponse[0].gc_policy_start_date;
										this.inceptionDate =
											voyageArrayDataResponse[0].gc_policy_start_date;
										this.PolicyEffectiveDate =
											this.response.data[0].data.portal_effective_date;
										this.policyExpiryDate =
											voyageArrayDataResponse[0].gc_policy_end_date;
										this.expiryDate =
											voyageArrayDataResponse[0].gc_policy_end_date;
										this.policyLockDate =
											this.response.data[0].data.portal_lock_date;
										this.policyCurrencyType =
											voyageArrayDataResponse[0].policy_currency_type;
										//this.renewalCounter = voyageArrayDataResponse[0].renewal_counter;
										if (
											voyageArrayDataResponse[0].renewal_counter + "" != null &&
											voyageArrayDataResponse[0].renewal_counter + "" != ""
										)
											this.renewalCounter = Math.floor(
												voyageArrayDataResponse[0].renewal_counter
											);
										else this.renewalCounter = "";
										this.policyNumber = this.response.data[0].cust_fld_3;
										this.policyNumberForDispaly =
											this.response.data[0].cust_fld_1;
										this.producerCode =
											voyageArrayDataResponse[0].producer_code;
										this.tagicRMemail =
											this.response.data[0].data.tagic_rm_email;
										this.insuredId = voyageArrayDataResponse[0].insured_id;
										this.selectGroup.patchValue({
											groupNameValue: this.response.data[0].data.group_name,
										});
										this.underwriterEmail =
											this.response.data[0].data.underwriter_email;
										this.producerName =
											voyageArrayDataResponse[0].producer_name;
										this.producerBranchCode =
											voyageArrayDataResponse[0].producer_branch_code;
										this.producerBranch =
											voyageArrayDataResponse[0].producer_branch_name;
										this.producerPhoneNumber =
											voyageArrayDataResponse[0].producer_phone_no;
										this.producerEmail =
											voyageArrayDataResponse[0].producer_email;
										this.insuredName = voyageArrayDataResponse[0].insured_name;
										this.insuredAdd1 = voyageArrayDataResponse[0].insured_add1;
										this.insuredAdd2 = voyageArrayDataResponse[0].insured_add2;
										this.insuredAdd3 = voyageArrayDataResponse[0].insured_add3;
										this.insuredCity = voyageArrayDataResponse[0].insured_city;
										this.insuredState =
											voyageArrayDataResponse[0].insured_state;
										this.insuredCountry =
											voyageArrayDataResponse[0].insured_country;
										this.insuredZipcode =
											voyageArrayDataResponse[0].insured_zipcode;
										this.insuredGSTINNumber =
											voyageArrayDataResponse[0].insured_gstin;
										/* this.policyNumberMetaData = this.response.data[0].policy_no; */
									}
								}
							}
						}
					}
				}
			}

			if (Number(voyageArrayDataResponse[0].tax_applicable) > 0)
				this.tax = "Yes";
			else this.tax = "No";
			this.voyageArr = voyageArray;
			this.voyageArrForDisplay = voyageArrayDisplay;
			this.voyageArrData = JSON.parse(JSON.stringify(this.voyageArr));
			this.voyageArrForPolicy = voyageArray;
			this.voyageArrGridData = subvoyageArray;
			for (let count = 0; count < this.voyageArr.length; count++) {
				var dataToDelete = {
					gcRunningId: this.voyageArr[count].gc_running_id,
					deletevoyageGridClientUserData: [],
					policy_no: this.voyageArr[count].policy_no,
				};
				var dataToDeleteProducerUser = {
					gcRunningId: this.voyageArr[count].gc_running_id,
					deletevoyageGridProducerUserData: [],
					policy_no: this.voyageArr[count].policy_no,
				};
				this.deleteVoyageClientUsersData.push(dataToDelete);
				this.deleteVoyageProducerUsersData.push(dataToDeleteProducerUser);
			}
		}
		this.PolicyEffectiveDate = new Date(this.PolicyEffectiveDate);
		this.policyLockDate = new Date(this.policyLockDate);
		// this.policyInceptionDate = this.policyInceptionDate;
		// this.policyExpiryDate = this.policyExpiryDate;
		this.getDeclarationType(this.voyageArrGridData);
		let voyageStr = "";
		if (type != "subvoyage") {
			if (this.policyType == "STOP" || this.policyType == "Project Policy") {
				let table = $("#voyageGrid2").DataTable();
				table.destroy();
				table.column(3).visible(false);
				this.dtTrigger.next();
				this.iscertificatebulkShow = false;
				this.iscertificateallowedShow = true;
			} else if (this.policyType == "MOP" || this.policyType == "Open Cover") {
				let table = $("#voyageGrid2").DataTable();
				table.destroy();
				table.column(4).visible(false);
				this.dtTrigger.next();
				this.iscertificatebulkShow = true;
				this.iscertificateallowedShow = false;
			} else {
				this.commonService.errorsmsg("Invalid Policy", "Error");
				this.router.navigate(["/master-policy-complete"]);
			}
		}
		if (this.policyType == "STOP" || this.policyType == "Project Policy") {
			this.voyageArrGridData.sort(function (a, b) {
				if (a.gc_running_id == b.gc_running_id) {
					return a.certificate_allowed.localeCompare(b.certificate_allowed);
				}
			});
			await this.loaddropdownvalues("voyage/STOP", "voyage");
			for (let i = 0; i < this.voyageArr.length; i++) {
				voyageStr += this.voyageArr[i].voyage_name + ",";
			}
			voyageStr = voyageStr.substring(0, voyageStr.length - 1);
			this.fromCountryList = {};
			this.toCountryList = {};
			url =
				this.commonVariablesService.baseURL +
				"api/v1/marine_master/fetchall/subvoyage_country";

			let param = new HttpParams()
				.set("policy_type", "STOP")
				.set("voyage_name", voyageStr);
			let response = await this.commonService.httpGetMethod(
				url,
				"application/json",
				true,
				param,
				"Policy Configuration"
			);
			if (response.status == 0) {
				if (response.data.length > 0) {
					response.data.forEach((voyageData) => {
						let name = voyageData.voyage + "-" + voyageData.sub_voyage;
						if (this.fromCountryList[name]) {
							this.fromCountryList[name].push(voyageData.from_country);
						} else {
							this.fromCountryList[name] = [];
							this.fromCountryList[name].push(voyageData.from_country);
						}
						if (this.toCountryList[name]) {
							this.toCountryList[name].push(voyageData.to_country);
						} else {
							this.toCountryList[name] = [];
							this.toCountryList[name].push(voyageData.to_country);
						}
						/* this.fromCountryList[name] ?
							this.fromCountryList[name].push(voyageData.from_country)
							: (this.fromCountryList[name] = [], this.fromCountryList[name].push(voyageData.from_country))
						this.toCountryList[name] ?
							this.toCountryList[name].push(voyageData.to_country)
							: (this.toCountryList[name] = [], this.toCountryList[name].push(voyageData.to_country)) */
					});
				}
			} else if (response.status != -114) {
				this.commonService.errorsmsg(response.txt, "Error");
			}
		} else if (this.policyType == "MOP" || this.policyType == "Open Cover") {
			this.voyageArrGridData.sort(function (a, b) {
				if (a.gc_running_id == b.gc_running_id) {
					return a.certificate_bulk.localeCompare(b.certificate_bulk);
				}
			});
			await this.loaddropdownvalues("voyage/MOP", "voyage");
			for (let i = 0; i < this.voyageArr.length; i++) {
				voyageStr += this.voyageArr[i].voyage_name + ",";
			}
			voyageStr = voyageStr.substring(0, voyageStr.length - 1);
			this.fromCountryList = {};
			url =
				this.commonVariablesService.baseURL +
				"api/v1/marine_master/fetchall/subvoyage_country";

			let param = new HttpParams()
				.set("policy_type", "MOP")
				.set("voyage_name", voyageStr);
			let response = await this.commonService.httpGetMethod(
				url,
				"application/json",
				true,
				param,
				"Policy Configuration"
			);
			if (response.status == 0) {
				if (response.data.length > 0) {
					response.data.forEach((voyageData) => {
						let name = voyageData.voyage + "-" + voyageData.sub_voyage;
						let fromCountry_voyagedata = voyageData.from_country.split("~");
						let toCountry_voyagedata = voyageData.to_country.split("~");
						let fromCountryValue = "",
							toCountryValue = "";
						for (let j = 0; j < fromCountry_voyagedata.length; j++) {
							for (let i = 0; i < this.dropdownList.length; i++) {
								if (
									this.dropdownList[i].country_name == fromCountry_voyagedata[j]
								) {
									if (fromCountryValue == "")
										fromCountryValue = fromCountry_voyagedata[j];
									else
										fromCountryValue =
											fromCountryValue + "~" + fromCountry_voyagedata[j];
								}
							}
						}
						for (let j = 0; j < toCountry_voyagedata.length; j++) {
							for (let i = 0; i < this.dropdownList.length; i++) {
								if (
									this.dropdownList[i].country_name == toCountry_voyagedata[j]
								) {
									if (toCountryValue == "")
										toCountryValue = toCountry_voyagedata[j];
									else
										toCountryValue =
											toCountryValue + "~" + toCountry_voyagedata[j];
								}
							}
						}
						if (this.fromCountryList[name]) {
							this.fromCountryList[name].push(fromCountryValue);
						} else {
							this.fromCountryList[name] = [];
							this.fromCountryList[name].push(fromCountryValue);
						}
						if (this.toCountryList[name]) {
							this.toCountryList[name].push(toCountryValue);
						} else {
							this.toCountryList[name] = [];
							this.toCountryList[name].push(toCountryValue);
						}
						/* this.fromCountryList[name] ?
							this.fromCountryList[name].push(fromCountryValue)
							: (this.fromCountryList[name] = [], this.fromCountryList[name].push(fromCountryValue))
						this.toCountryList[name] ?
							this.toCountryList[name].push(toCountryValue)
							: (this.toCountryList[name] = [], this.toCountryList[name].push(toCountryValue)) */
					});
				}
			} else if (response.status != -114) {
				this.commonService.errorsmsg(response.txt, "Error");
			}
		} else {
			this.commonService.errorsmsg("Invalid Policy", "Error");
			this.router.navigate(["/master-policy-complete"]);
		}
		await this.allUnderwriterData();
		if (this.underwriterEmail == "" || this.underwriterEmail == null) {
			$("#table_underwriter").DataTable({
				/* language: {
					"infoEmpty": "No Data Available in Table"
				}, */
				destroy: true,
				paging: false,
			});
		} else {
			this.underwriterInfo(this.underwriterEmail);
		}
		await this.loadmodeofconveyance();
		if (this.countToTab == 0) this.tabToBeActive();
		this.countToTab = 1;
		this.clientUsers = [];
		this.producerUsers = [];
		await this.fetchAllClientUserData("", "");
		await this.fetchAllProducerUserData("", "");
		this.clientUserDataTable();
		this.producerUserDataTable();
		this.certificateorbulkValue = await this.loaddropdownvalues(
			"declaration/certificate_bulk",
			""
		);
		this.bulkdeclarationtypevalue = await this.loaddropdownvalues(
			"declaration/bulk",
			""
		);
		this.coveragetypeValue = await this.loaddropdownvalues("coverage", "");
		this.declarationtypevalue = await this.loaddropdownvalues(
			"declaration",
			""
		);
		if (this.policyType == "STOP" || this.policyType == "Project Policy") {
			this.declarationtypevalue.splice("Both", 1);
			this.declarationtypevalue.splice(5, 1);
		}
	}
	/*
	 * Created By : PriyaDharshini M
	 * Description : it loades the country list with in dropdown .
	 *********************************************/
	async loadcountrylist() {
		let fromcountryValue: any = await this.loaddropdownvalues(
			"country_master",
			""
		);
		for (let i = 0; i < fromcountryValue.length; i++) {
			if (fromcountryValue[i].status == 0)
				this.dropdownList.push({
					country_code: fromcountryValue[i].country_code,
					country_name: fromcountryValue[i].country_name,
				});
		}
	}
	/*
	 * Created By : PriyaDharshini M
	 * Description : gets the group names and id's.
	 *********************************************/
	async loadAllgroup() {
		let url = this.commonVariablesService.baseURL + "api/v1/group";
		let response = await this.commonService.httpGetMethod(
			url,
			"application/json",
			true,
			"",
			"Policy Configuration"
		);
		if (response.status == 0) {
			this.allGroupData = response.data;
		} else if (response.status != -114) {
			this.commonService.errorsmsg(response.txt, "Error");
			return;
		}
	}

	/*
	 * Created By : PriyaDharshini M
	 * Description : gets the declartion types for particular subvoayge data.
	 *********************************************/
	getDeclarationType(subvoyageArrayData) {
		for (let count = 0; count < this.voyageArr.length; count++) {
			let declarationType = [];
			for (let count1 = 0; count1 < subvoyageArrayData.length; count1++) {
				if (
					subvoyageArrayData[count1].gc_running_id ==
					this.voyageArr[count].gc_running_id
				) {
					declarationType.push(subvoyageArrayData[count1].declaration_type);
				}
			}
			let declarationtype = [...new Set(declarationType)]; //elemenats duplicate records
			this.voyageArr[count]["declaration_type"] = declarationtype.join(",");
		}
	}
	/*
	 * Created By : Manasa R
	 * Description : Trigger mail to client users added in voyage grid.
	 *********************************************/
	async triggerMailToClient() {
		let clientArr = [];
		for (let count = 0; count < this.voyageArr.length; count++) {
			for (
				let count1 = 0;
				count1 < this.voyageArr[count].client_users.length;
				count1++
			)
				clientArr.push(this.voyageArr[count].client_users[count1]);
		}
		let clientData = [...new Set(clientArr)];
		let param = {
			policy_ref_num: this.voyageArr[0].policy_ref_num,
			users: clientData,
			mail_data: {
				policy_no: this.policyNumberForDispaly,
			},
		};
		let mailTriggerUrl =
			this.commonVariablesService.baseURL +
			"api/v1/marine_mailer/send_mail/mp_add_client";
		let mailTriggerResponse = await this.commonService.httpPostMethod(
			mailTriggerUrl,
			param,
			"application/json",
			true,
			"policy Configuration"
		);
		if (
			mailTriggerResponse.body.status != 0 &&
			mailTriggerResponse.body.status != -114
		) {
			this.commonService.errorsmsg(mailTriggerResponse.body.txt, "Error");
			this.isShowConvertPolicyButton = false;
		}
	}
	/*
	 * Created By : Manasa R
	 * Description : Trigger mail to producer users added in voyage grid.
	 *********************************************/
	async triggerMailToProducer() {
		let producerArr = [];
		for (let count = 0; count < this.voyageArr.length; count++) {
			for (
				let count1 = 0;
				count1 < this.voyageArr[count].producer_users.length;
				count1++
			)
				producerArr.push(this.voyageArr[count].producer_users[count1].email);
		}
		let producerData = [...new Set(producerArr)];
		let param = {
			policy_ref_num: this.voyageArr[0].policy_ref_num,
			users: producerData,
			mail_data: {
				policy_no: this.policyNumberForDispaly,
			},
		};
		let mailTriggerUrl =
			this.commonVariablesService.baseURL +
			"api/v1/marine_mailer/send_mail/mp_add_producer";
		let mailTriggerResponse = await this.commonService.httpPostMethod(
			mailTriggerUrl,
			param,
			"application/json",
			true,
			"policy Configuration"
		);
		if (
			mailTriggerResponse.body.status != 0 &&
			mailTriggerResponse.body.status != -114
		) {
			this.commonService.errorsmsg(mailTriggerResponse.body.txt, "Error");
			this.isShowConvertPolicyButton = false;
		}
	}
	/*
	 * Created By : Manasa R
	 * Description : fetching and updating client Group with in completed status.
	 *********************************************/
	async clientDetailsOnSave() {
		for (
			let count = 0;
			count < this.deleteVoyageClientUsersData.length;
			count++
		) {
			for (
				let count1 = 0;
				count1 <
				this.deleteVoyageClientUsersData[count].deletevoyageGridClientUserData
					.length;
				count1++
			) {
				let url =
					this.commonVariablesService.baseURL + "api/v1/marine_mp_gc_data/acl";
				let param = [];
				param.push({
					policy_no: this.deleteVoyageClientUsersData[count].policy_no,
					email_id:
						this.deleteVoyageClientUsersData[
							count
						].deletevoyageGridClientUserData[count1].toLowerCase(),
					status: 1,
				});
				let response = await this.commonService.httpPostMethod(
					url,
					param,
					"",
					true,
					"client User Setup"
				);
				if (response.body.status == 0) {
					this.commonService.warningmsg(
						this.deleteVoyageClientUsersData[count]
							.deletevoyageGridClientUserData[count1] +
							" user Deleted Successfully",
						"Worning"
					);
				} else if (response.body.status != -114) {
					this.commonService.errorsmsg(
						"Unable to delete the user" +
							this.deleteVoyageClientUsersData[count]
								.deletevoyageGridClientUserData[count1],
						"error"
					);
					for (let i = 0; i < this.voyageArr.length; i++) {
						if (
							this.voyageArr[i].gc_running_id ==
							this.deleteVoyageClientUsersData[count].gcRunningId
						) {
							this.voyageArr[i].client_users.push(
								this.deleteVoyageClientUsersData[count]
									.deletevoyageGridClientUserData[count1]
							);
						}
					}
				}
			}
		}
	}
	/*
	 * Created By : Manasa R
	 * Description : fetching and updating producer Group with in completed status.
	 *********************************************/
	async producerDetailsOnSave() {
		for (
			let count = 0;
			count < this.deleteVoyageProducerUsersData.length;
			count++
		) {
			for (
				let count1 = 0;
				count1 <
				this.deleteVoyageProducerUsersData[count]
					.deletevoyageGridProducerUserData.length;
				count1++
			) {
				let url =
					this.commonVariablesService.baseURL + "api/v1/marine_mp_gc_data/acl";
				let param = [];
				param.push({
					policy_no: this.deleteVoyageClientUsersData[count].policy_no,
					email_id:
						this.deleteVoyageProducerUsersData[
							count
						].deletevoyageGridProducerUserData[count1].toLowerCase(),
					status: 1,
				});
				let response = await this.commonService.httpPostMethod(
					url,
					param,
					"",
					true,
					"producer User Setup"
				);
				if (response.body.status == 0) {
					this.commonService.warningmsg(
						this.deleteVoyageProducerUsersData[count]
							.deletevoyageGridProducerUserData[count1] +
							" user Deleted Successfully",
						"Worning"
					);
				} else if (response.body.status != -114) {
					this.commonService.errorsmsg(
						"Unable to delete the user" +
							this.deleteVoyageProducerUsersData[count]
								.deletevoyageGridProducerUserData[count1],
						"error"
					);
					for (let i = 0; i < this.voyageArr.length; i++) {
						if (
							this.voyageArr[i].gc_running_id ==
							this.deleteVoyageClientUsersData[count].gcRunningId
						) {
							this.voyageArr[i].producer_users.push({
								email:
									this.deleteVoyageProducerUsersData[
										count
									].deletevoyageGridProducerUserData[count1].toLowerCase(),
								allow_certificate: "No",
							});
						}
					}
				}
			}
		}
	}
	/*
	 * Created By : Manasa R
	 * Description : loads the data with in client user datatable.
	 *********************************************/
	clientUserDataTable() {
		// Policy setup Changes
		if(this.count === 0) {
			this.actualData = [];
			this.voyageArr.forEach( value =>{
				this.actualData.push({
					email_id: value.client_users,
					gc_running_id: value.gc_running_id,
					policy_no: value.policy_no
				})
			})
			this.count++;
		}
		for (let i = 0; i < this.voyageArr.length; i++) {
			var sampledata: any = [];
			for (let k = 0; k < this.voyageArr[i].client_users.length; k++) {
				for (let j = 0; j < this.clientUsers.length; j++) {
					if (
						this.clientUsers[j].email_id.toString().toLowerCase() ==
						this.voyageArr[i].client_users[k].toString().toLowerCase()
					) {
						sampledata.push(this.clientUsers[j]);
					}
				}
			}
			if (
				$.fn.dataTable.isDataTable(
					"#table_clientUser" + this.voyageArr[i].gc_running_id
				)
			) {
				$("#table_clientUser" + this.voyageArr[i].gc_running_id)
					.DataTable()
					.destroy();
			}
			// var table = $("#table_clientUser" + this.voyageArr[i].gc_running_id).DataTable({
			$("#table_clientUser" + this.voyageArr[i].gc_running_id)
				.DataTable({
					data: sampledata,
					columns: [
						{ data: "email_id" },
						{
							data: null,
							render: function (data) {
								return data.first_name + " " + data.last_name;
							},
						},
						{ data: "mobile_no" },
						/* {
						data: null,
						defaultContent: "Active"
					}, */
						{
							data: null,
							render: function (data) {
								return '<div  class="text-center"><span tblHead="Action"></span><i class="fa fa-trash-o" aria-hidden="true"></i></div>';
							},
						},
					],
					paging: false,
					info: false,
					rowCallback: (row: Node, data: any[] | Object, index: number) => {
						const self = this;
						$("td:last-child", row).unbind("click");
						$("td:last-child", row).bind("click", async () => {
							let status = await this.commonService.deleteAlertMsg();
							if (status)
								self.deleteClientUserData(
									row,
									data["email_id"],
									this.voyageArr[i].gc_running_id,
									this.voyageArr[i].policy_ref_num
								);
						});
						return row;
					},
				})
				.draw();
			if (this.selectedPolicyStatus == 0 && this.isShowButtons == false) {
				let clientTable = $(
					"#table_clientUser" + this.voyageArr[i].gc_running_id
				).DataTable();
				clientTable.destroy();
				clientTable.column(3).visible(false);
				this.dtTrigger.next();
			}
		}
	}
	/*
	 * Created By : Manasa R
	 * Description : Loads the data with in producer user DataTable.
	 *********************************************/
	producerUserDataTable() {
		for (let i = 0; i < this.voyageArr.length; i++) {
			var sampledata: any = [];
			for (let k = 0; k < this.voyageArr[i].producer_users.length; k++) {
				for (let j = 0; j < this.producerUsers.length; j++) {
					if (
						this.producerUsers[j].email_id.toString().toLowerCase() ==
						this.voyageArr[i].producer_users[k].email.toString().toLowerCase()
					) {
						var code = this.producerUsers[j].branch_code;
						var lastFive = code.substr(code.length - 4);
						this.producerUsers[j]["gc_running_id"] = "";
						this.producerUsers[j]["branch_code"] = lastFive;
						if (this.voyageArr[i].producer_users[k].allow_certificate == "No")
							this.producerUsers[j]["allow_certificate"] = "";
						else this.producerUsers[j]["allow_certificate"] = "checked";
						sampledata.push(this.producerUsers[j]);
					}
				}
			}
			if (
				$.fn.dataTable.isDataTable(
					"#table_producerUser" + this.voyageArr[i].gc_running_id
				)
			) {
				$("#table_producerUser" + this.voyageArr[i].gc_running_id)
					.DataTable()
					.destroy();
			}
			// var table = $("#table_producerUser" + this.voyageArr[i].gc_running_id).DataTable({
			$("#table_producerUser" + this.voyageArr[i].gc_running_id)
				.DataTable({
					data: sampledata,
					columns: [
						{
							data: null,
							render: function (data) {
								let isChecked = data["allow_certificate"];
								let obj =
									'<div class="theme-checkbox" ><span tblHead="Select"></span><span class="tblValue">' +
									'<input type="checkbox" value="" ' +
									isChecked +
									"></span></div>";
								return obj;
							},
						},
						{
							data: "producer_code",
						},
						{ data: "branch_code" },
						{ data: "branch_location" },
						{
							data: null,
							render: function (data) {
								return data.first_name + " " + data.last_name;
							},
						},
						{
							data: "email_id",
						},
						{
							data: "mobile_no",
						},
						{
							data: null,
							render: function (data) {
								return '<div  class="text-center"><span tblHead="Action"></span><i class="fa fa-trash-o" aria-hidden="true"></i></div>';
							},
						},
					],
					paging: false,
					info: false,
					rowCallback: (row: Node, data: any[] | Object, index: number) => {
						const self = this;
						$("td:first-child", row).unbind("change");
						$("td:first-child", row).bind("change", () => {
							self.isProducerUserCertificateAllowed(
								data["email_id"],
								this.voyageArr[i].gc_running_id,
								this.voyageArr[i].policy_ref_num
							);
						});
						$("td:last-child", row).unbind("click");
						$("td:last-child", row).bind("click", async () => {
							let status = await this.commonService.deleteAlertMsg();
							if (status)
								self.deleteProducerUserData(
									row,
									data["email_id"],
									this.voyageArr[i].gc_running_id,
									this.voyageArr[i].policy_ref_num
								);
						});
						return row;
					},
				})
				.draw();
			if (this.selectedPolicyStatus == 0 && this.isShowButtons == false) {
				let table_producerUser = $(
					"#table_producerUser" + this.voyageArr[i].gc_running_id
				).DataTable();
				table_producerUser.destroy();
				table_producerUser.column(7).visible(false);
				this.dtTrigger.next();
			}
		}
	}
	/*
	 * Created By : Manasa R
	 * Description : On changing the allow certificate status with in producer User it will get update in voyageArr.
	 *********************************************/
	async isProducerUserCertificateAllowed(email, gcRunningId, policy_ref_num) {
		let producerId = "",
			clientId = "";
		for (let i = 0; i < this.voyageArr.length; i++) {
			if (this.voyageArr[i].gc_running_id == gcRunningId) {
				for (
					let count = 0;
					count < this.voyageArr[i].producer_users.length;
					count++
				) {
					if (
						this.voyageArr[i].producer_users[count].allow_certificate == "No" &&
						this.voyageArr[i].producer_users[count].email.toLowerCase() ==
							email.toLowerCase()
					) {
						this.voyageArr[i].producer_users[count].allow_certificate = "Yes";
						/* for (let j = 0; j < this.allGroupData.length; j++) {
							if (this.policyNumber + '_PRODUCER_' + gcRunningId == this.allGroupData[j].group_name) {
								producerId = this.allGroupData[j].group_id
							}
							if (this.policyNumber + '_CLIENT_' + gcRunningId == this.allGroupData[j].group_name) {
								clientId = this.allGroupData[j].group_id
							}
						}
						if (this.selectedPolicyStatus == 0) {
							let url = this.commonVariablesService.baseURL + 'api/v1/group/proxy/entity'
							let param = {
								group_id: producerId,
								entity_id: clientId
							}
							let response = await this.commonService.httpPostMethod(url, param, 'application/json', true, 'Policy Configuration')
							if (response.body.status == 0)
							else if (response.body.status != -114) {
								this.commonService.errorsmsg(response.body.txt, 'Error');
								return;
							}
						} */
					} else if (
						this.voyageArr[i].producer_users[count].allow_certificate ==
							"Yes" &&
						this.voyageArr[i].producer_users[count].email.toLowerCase() ==
							email.toLowerCase()
					)
						this.voyageArr[i].producer_users[count].allow_certificate = "No";
				}
			}
		}
	}

	/*
	 * Created By : PriyaDharshini M
	 * Description : On changing SI percentage with in subvoyage popup changes the opening ang premium balance.
	 *********************************************/
	voyageSIChange(id, type) {
		this.voyageId = id;
		let value = this.suminsured;
		let initialSI, opening_balance;
		for (let i = 0; i < this.voyageArr.length; i++) {
			if (this.voyageArr[i].gc_running_id == id) {
				initialSI = this.voyageArr[i].initial_sum_insured;
				if (type != "openingBalance") {
					opening_balance = Math.round(initialSI * (value / 100));
					this.openingbalance = opening_balance.toFixed(2);
				}
				this.premiumBalance =
					this.voyageArr[i].net_premium_with_tax * (value / 100);
			}
		}
		if(this.policy_type == 'STOP'){
			if(this.subvoyagePopup.get('certificateAllowed').value == "Yes"){
			  if (
					 this.openingbalance < this.utilised_opening_certificate_balance ||
					 this.premiumBalance < this.utilised_premium_certificate_balance
				   ) 
				  {
					this.SiValid = true;
				  }
			 else{
			  this.SiValid = false;
			 }
			 }
			 else{
			  this.SiValid = false;
			 }
		  }if(this.policy_type == 'MOP'){
			 if(this.subvoyagePopup.get('certificate').value == "Certificate"){
	  if(
		this.openingbalance < this.utilised_opening_certificate_balance ||
		this.premiumBalance < this.utilised_premium_certificate_balance){
		  this.SiValid = true;
	  }else{
		this.SiValid = false;
	  }
			 }else{
			  if (
					this.openingbalance < this.utilised_opening_bulk_balance ||
					this.premiumBalance < this.utilised_premium_bulk_balance
				  ){
					this.SiValid = true;
				  }else{
					this.SiValid = false;
				  }
	  
			 }
	}
	}

	/*
	 * Created By : Manasa R
	 * Description :on changing the opening balance with in subvoyage SI% and premium balance are going to change.
	 *********************************************/
	onOpeningBalanceChange(id) {
		/* if(parseInt(this.openingbalance)>parseInt(this.initialSumInsured))
		{
            this.commonService.errorsmsg("Opening Balance should not be more than initial sum insured","error");
			return;
		} */
		let value = (this.openingbalance / this.initialSumInsured) * 100;
		this.suminsured = value;
		this.voyageSIChange(id, "openingBalance");
	}
	/*
	 * Created By : PriyaDharshini M
	 * Description :On selecting the from country data pushes to array.
	 *********************************************/
	onFromCountrySelect(item: any) {
		this.fromcountry.push(item);
	}
	/*
	 * Created By : PriyaDharshini M
	 * Description :On selecting the to country data pushes to array.
	 *********************************************/
	onToCountrySelect(item: any) {
		this.tocountry.push(item);
	}
	/*
	 * Created By : PriyaDharshini M
	 * Description :On selecting ModeofConvoyance data pushes to array.
	 *********************************************/
	onModeofConvoyanceSelect(item: any) {
		this.modeofconveyance.push(item);
	}

	/*
	 * Created By : PriyaDharshini M
	 * Description :On deselecting ModeofConvoyance data deletes from array.
	 *********************************************/
	onModeofConvoyanceDeSelect(item: any) {
		//this.modeofconveyance = this.modeofconveyance;
		for (let i = 0; i < this.modeofconveyance.length; i++) {
			if (this.modeofconveyance[i].item_text == item.item_text) {
				this.modeofconveyance.splice(i, 1);
				break;
			}
		}
	}
	/*
	 * Created By : PriyaDharshini M
	 * Description :On selecting  ModeofConvoyance  data at one short pushes to array.
	 *********************************************/
	onModeofConvoyanceSelectAll(items: any) {
		this.modeofconveyance = [];
		for (let i = 0; i < items.length; i++) this.modeofconveyance.push(items[i]);
	}
	/*
	 * Created By : PriyaDharshini M
	 * Description :On deselecting  ModeofConvoyance  data at one short deletes from array.
	 *********************************************/
	onModeofConvoyanceDeSelectAll(items: any) {
		this.modeofconveyance = [];
	}
	/*
	 * Created By : PriyaDharshini M
	 * Description :On deselecting  from country  data it deletes from array.
	 *********************************************/
	onDeSelectFromCountry(item: any) {
		//this.fromcountry = this.fromcountry;
		for (let i = 0; i < this.fromcountry.length; i++) {
			if (this.fromcountry[i].item_text == item.item_text) {
				this.fromcountry.splice(i, 1);
				break;
			}
		}
	}
	/*
	 * Created By : PriyaDharshini M
	 * Description :On deselecting  to country  data it deletes from array.
	 *********************************************/
	onDeSelectToCountry(item: any) {
		//this.tocountry = this.tocountry;
		for (let i = 0; i < this.tocountry.length; i++) {
			if (this.tocountry[i].item_text == item.item_text) {
				this.tocountry.splice(i, 1);
				break;
			}
		}
	}
	/*
	 * Created By : PriyaDharshini M
	 * Description :On selecting  from country  data it pushes all data at a short to array.
	 *********************************************/
	onFromCountrySelectAll(items: any) {
		this.fromcountry = [];
		for (let i = 0; i < items.length; i++) this.fromcountry.push(items[i]);
	}

	/*
	 * Created By : PriyaDharshini M
	 * Description :On deselecting  from country  data it deletes all data at a short from array.
	 *********************************************/
	onFromCountryDeSelectAll(items: any) {
		this.fromcountry = [];
	}

	/*
	 * Created By : PriyaDharshini M
	 * Description :On selecting  to country  data it pushes all data at a short to array.
	 *********************************************/
	onToCountrySelectAll(items: any) {
		this.tocountry = [];
		for (let i = 0; i < items.length; i++) this.tocountry.push(items[i]);
	}

	/*
	 * Created By : PriyaDharshini M
	 * Description :On deselecting  to country  data it deletes all data at a short from array.
	 *********************************************/
	onToCountryDeSelectAll(items: any) {
		this.tocountry = [];
	}

	/*
	 * Created By : PriyaDharshini M
	 * Description : To open add group popup.
	 *********************************************/
	openModal(template: TemplateRef<any>) {
		this.modalRef = this.modalService.show(template, this.config);
	}

	openRightView() {
		this.ShowRightContent = true;
	}

	closeRightView() {
		this.ShowRightContent = false;
	}

	/*
	 * Created By : PriyaDharshini M
	 * Description : To add the row span and to hide the cell with in subvoyage datatable based on condition in voyagelevel.
	 *********************************************/
	rowSpanVoyageLeval(resp) {
		let rowspan = 0;
		let tmpVal = 0;
		let rowNo = 0;
		for (let Count1 = 0; Count1 < this.voyageArrGridData.length; Count1++) {
			if (this.voyageArrGridData[Count1].gc_running_id == resp.gc_running_id) {
				rowNo++;
				if (this.voyageArrGridData[Count1].id == resp.id) break;
			}
		}
		if (rowNo == 1) {
			for (let Count1 = 0; Count1 < this.voyageArrGridData.length; Count1++) {
				if (this.voyageArrGridData[Count1].gc_running_id == resp.gc_running_id)
					rowspan++;
			}
		} else {
			rowspan = 1;
			$("#" + resp.id + "SI").remove();
		}
		return rowspan;
	}

	/*
	 * Created By : PriyaDharshini M
	 * Description : To add the row span and to hide the cell with in subvoyage datatable based on condition.
	 *********************************************/
	rowspan(resp) {
		let rowspan = 0;
		let tmpVal = 0;
		let rowNo = 0;
		for (let Count1 = 0; Count1 < this.voyageArrGridData.length; Count1++) {
			if (
				(this.policyType == "STOP" || this.policyType == "Project Policy") &&
				this.voyageArrGridData[Count1].gc_running_id == resp.gc_running_id &&
				this.voyageArrGridData[Count1].certificate_allowed ==
					resp.certificate_allowed
			) {
				rowNo++;
				if (this.voyageArrGridData[Count1].id == resp.id) break;
			}
			if (
				(this.policyType == "MOP" || this.policyType == "Open Cover") &&
				this.voyageArrGridData[Count1].gc_running_id == resp.gc_running_id &&
				this.voyageArrGridData[Count1].certificate_bulk.includes(
					"Certificate"
				) &&
				resp.certificate_bulk.includes("Certificate")
			) {
				rowNo++;
				if (this.voyageArrGridData[Count1].id == resp.id) break;
			}
			if (
				(this.policyType == "MOP" || this.policyType == "Open Cover") &&
				this.voyageArrGridData[Count1].gc_running_id == resp.gc_running_id &&
				this.voyageArrGridData[Count1].certificate_bulk.includes("Bulk") &&
				resp.certificate_bulk.includes("Bulk")
			) {
				rowNo++;
				if (this.voyageArrGridData[Count1].id == resp.id) break;
			}
		}
		if (rowNo == 1) {
			for (let Count1 = 0; Count1 < this.voyageArrGridData.length; Count1++) {
				if (
					(this.policyType == "STOP" || this.policyType == "Project Policy") &&
					this.voyageArrGridData[Count1].gc_running_id == resp.gc_running_id &&
					this.voyageArrGridData[Count1].certificate_allowed ==
						resp.certificate_allowed
				)
					rowspan++;

				if (
					(this.policyType == "MOP" || this.policyType == "Open Cover") &&
					this.voyageArrGridData[Count1].gc_running_id == resp.gc_running_id &&
					this.voyageArrGridData[Count1].certificate_bulk.includes(
						"Certificate"
					) &&
					resp.certificate_bulk.includes("Certificate")
				) {
					rowspan++;
				}
				if (
					(this.policyType == "MOP" || this.policyType == "Open Cover") &&
					this.voyageArrGridData[Count1].gc_running_id == resp.gc_running_id &&
					this.voyageArrGridData[Count1].certificate_bulk.includes("Bulk") &&
					resp.certificate_bulk.includes("Bulk")
				) {
					rowspan++;
				}
			}
		} else {
			rowspan = 1;
			$("#" + resp.id).remove();
		}
		return rowspan;
	}

	/*
	 * Created By : PriyaDharshini M
	 * Description : according to subvoyage type the data get changes with in subvoyage popup.
	 *********************************************/
	subvoyageChange() {
		this.dropdownListFromCountry = [];
		this.dropdownListToCountry = [];
		let name = this.voyagename + "-" + this.subvoyagePopup.value.subVoyageName;
		let fromCountryList = this.fromCountryList[name] + "";
		if (fromCountryList != "" && fromCountryList != "undefined") {
			let fromCountryarray = fromCountryList.split("~");
			for (let i = 0; i < fromCountryarray.length; i++)
				this.dropdownListFromCountry.push({
					item_id: fromCountryarray[i],
					item_text: fromCountryarray[i],
				});
		}
		let toCountryList = this.toCountryList[name] + "";
		if (toCountryList != "" && toCountryList != "undefined") {
			let toCountryarray = toCountryList.split("~");
			for (let i = 0; i < toCountryarray.length; i++)
				this.dropdownListToCountry.push({
					item_id: toCountryarray[i],
					item_text: toCountryarray[i],
				});
		}
	}
	/*
	 * Created By : Manasa R
	 * Description : according to certificate/bulk field value some fields are disabled.
	 *********************************************/
	onCertificateBulkChange(id) {
		if (this.subvoyagePopup.value.certificate != "Certificate") {
			this.subvoyagePopup
				.get("bulkdeclarationtype")
				.setValidators([Validators.required]);
			$("#minShipmentPremium").attr("disabled", "true");
			$("#noofDaysBackdate").attr("disabled", "true");
			$("#premiumDisplay").attr("disabled", "true");
			$("#nonStdClauses").attr("disabled", "true");
			$("#addClientinCertificate").attr("disabled", "true");
			this.IsBulkDeclarationMandatory = true;
		} else {
			$("#minShipmentPremium").removeAttr("disabled");
			$("#noofDaysBackdate").removeAttr("disabled");
			$("#premiumDisplay").removeAttr("disabled");
			$("#nonStdClauses").removeAttr("disabled");
			$("#addClientinCertificate").removeAttr("disabled");
			for (let i = 0; i < this.voyageArrGridData.length; i++) {
				if (this.voyageArrGridData[i].id == id) {
					this.voyageArrGridData[i].display_premium = "No";
					this.voyageArrGridData[i].min_shipment_premium = 0;
					this.voyageArrGridData[i].non_standard_clauses = 0;
					this.voyageArrGridData[i].back_date_days = 0;
					this.subvoyagePopup.patchValue({
						backdatedays: 0,
						premiumdisplay: "No",
						shipmentpreminum: 0,
						non_std_clauses: 0,
					});
				}
			}
			this.subvoyagePopup.get("bulkdeclarationtype").clearValidators();
			this.IsBulkDeclarationMandatory = false;
		}
		this.subvoyagePopup.get("bulkdeclarationtype").updateValueAndValidity();
		this.voyageSIChange(this.voyageId,"");
	}
	/*
	 * Created By : PriyaDharshini M
	 * Description : On opening subvoyage popup reqired data get sets in arrays.
	 *********************************************/
	async openPopupView(VoyageTemplate: TemplateRef<any>, response) {

		this.SiValid = false;
		this.isPostValid = false;
		for (let i = 0; i < this.voyagePolicy.length; i++) {
		  console.log("voya", this.voyagePolicy[i].voyage_name);
		  if (response.voyage_name == this.voyagePolicy[i]?.voyage_name) {
			console.log("true");
			this.policy_no = this.voyagePolicy[i].policy_no;
			//this.declarationTypeValue = this.voyagePolicy[i].declaration_type;
		  }
		}
		//  if(this.voyagePolicy.
		const avalBalcUrl = `${this.commonVariablesService.baseURL}api/v1/marine_declaration/policy_balance`;
		let balcParamData = {
		  policy_no: this.policy_no,
		};
	
		let res = await this.commonService.httpGetMethod(
		  avalBalcUrl,
		  "application/json",
		  true,
		  balcParamData,
		  "Declaration"
		);
		this.utilised_opening_certificate_balance =
		  res?.data?.utilized_opening_balance_certificate;
		this.utilised_premium_certificate_balance =
		  res?.data?.utilized_premium_balance_certificate;
		this.utilised_opening_bulk_balance =
		  res?.data?.utilized_opening_balance_bulk;
		this.utilised_premium_bulk_balance =
		  res?.data?.utilized_premium_balance_bulk;
		this.policy_type= res?.data?.policy_type;
		if(this.selectedPolicyStatus == 0 && this.isShowButtons == false) {
				return;
			}
			this.modalRef = this.modalService.show(VoyageTemplate, this.config);
			this.modeofconveyance = [];
			this.fromcountry = [];
			this.tocountry = [];
			if (response.voyage_name == "OTHERS" && response.voyage_description != "")
				this.voyagename =
					response.voyage_name + "(" + response.voyage_description + ")";
			else this.voyagename = response.voyage_name;
			this.voyageId = response.gc_running_id;
			this.premiumBalance = response.premium_balance;
			this.netPremium = response.net_premium_with_tax;
			this.dropdownListFromCountry = [];
			this.dropdownListToCountry = [];
			this.suminsured = response.si_percentage;
			this.initialSumInsured = response.initial_sum_insured;
			this.openingbalance = response.opening_balance;
			this.certificateallowed = response.certificate_allowed;
			this.certificateorbulk = response.certificate_bulk;
			let declarationValue, coverageValue, bulkDeclarationValue, name;
			this.subVoyageNameDropdownArr = this.newsubVoyageObj[response.voyage_name];
			name = response.voyage_name + "-" + response.sub_voyage_name;
			let fromCountryList = this.fromCountryList[name] + "";
			if (fromCountryList != "" && fromCountryList != "undefined") {
				let fromCountryarray = fromCountryList.split("~");
				for (let i = 0; i < fromCountryarray.length; i++)
					this.dropdownListFromCountry.push({
						item_id: fromCountryarray[i],
						item_text: fromCountryarray[i],
					});
			}
			let toCountryList = this.toCountryList[name] + "";
			if (toCountryList != "" && toCountryList != "undefined") {
				let toCountryarray = toCountryList.split("~");
				for (let i = 0; i < toCountryarray.length; i++)
					this.dropdownListToCountry.push({
						item_id: toCountryarray[i],
						item_text: toCountryarray[i],
					});
			}
			this.subvoyagePopup.patchValue({
				subVoyageName: response.sub_voyage_name,
				declarationType: response.declaration_type,
				bulkdeclarationtype: response.bulk_declaration_type,
				coveragetype: response.coverage_type,
				backdatedays: response.back_date_days,
				postexpiry: response.days_post_expiry,
				psl: response.per_seeding_limit,
				transitexcessamount: response.transit_excess_in_certificate,
				shipmentpreminum: response.min_shipment_premium,
				lowbalTrigger: response.low_balance_trigger,
				premiumdisplay: response.display_premium,
				non_std_clauses: response.non_standard_clauses,
				addclient: response.client_in_certificate,
				lowbalTriggerAmt: response.low_balance_trigger_amount,
				bovpercent: response.bov_percentage,
				transitexcess: response.transit_excees,
				marineRate: response.marine_final_rate_percentage,
				certificate: response.certificate_bulk,
				certificateAllowed: response.certificate_allowed,
			});
			if (this.subvoyagePopup.value.certificate != "Certificate") {
				this.subvoyagePopup
					.get("bulkdeclarationtype")
					.setValidators([Validators.required]);
				this.IsBulkDeclarationMandatory = true;
			} else {
				this.subvoyagePopup.get("bulkdeclarationtype").clearValidators();
				this.IsBulkDeclarationMandatory = false;
			}
			this.subvoyagePopup.get("bulkdeclarationtype").updateValueAndValidity();
			if (this.subvoyagePopup.value.lowbalTrigger == "No")
				$("#lowbalTriggerAmt").attr("disabled", "true");
			if (this.policyType == "STOP" || this.policyType == "Project Policy") {
				if (this.subvoyagePopup.value.certificateAllowed == "No") {
					$("#minShipmentPremium").attr("disabled", "true");
					$("#noofDaysBackdate").attr("disabled", "true");
					$("#premiumDisplay").attr("disabled", "true");
					$("#nonStdClauses").attr("disabled", "true");
					$("#addClientinCertificate").attr("disabled", "true");
					$("#sipercent").attr("disabled", "true");
					$("#openingBalance").attr("disabled", "true");
					this.openingbalance = 0;
					this.premiumBalance = 0;
					this.suminsured = 0;
				}
			}
			this.addclient = response.client_in_certificate;
			if (this.subvoyagePopup.value.certificate != "Certificate") {
				$("#minShipmentPremium").attr("disabled", "true");
				$("#noofDaysBackdate").attr("disabled", "true");
				$("#premiumDisplay").attr("disabled", "true");
				$("#nonStdClauses").attr("disabled", "true");
				$("#addClientinCertificate").attr("disabled", "true");
			}
			if (this.policyType == "STOP" || this.policyType == "Project Policy") {
				if (this.subvoyagePopup.value.certificateAllowed == "Yes") {
					$("#premiumDisplay").removeAttr("disabled");
					$("#nonStdClauses").removeAttr("disabled");
					$("#noofDaysBackdate").removeAttr("disabled");
					$("#addClientinCertificate").removeAttr("disabled");
					$("#minShipmentPremium").removeAttr("disabled");
				}
			}
			this.modeOfConveyanceArray = [];
			if (response.mode_of_conveyance != "") {
				let array = response.mode_of_conveyance.split(",");
				for (let i = 0; i < array.length; i++) {
					for (let j = 0; j < this.modeofconveyanceValue.length; j++) {
						if (array[i] == this.modeofconveyanceValue[j].name) {
							this.modeOfConveyanceArray.push({
								item_id: j,
								item_text: array[i],
							});
						}
					}
				}
				this.modeofconveyance = this.modeOfConveyanceArray;
				this.subvoyagePopup.patchValue({
					modeOfConveyance: this.modeOfConveyanceArray,
				});
			} else {
				this.modeOfConveyanceArray = response.mode_of_conveyance;
				this.subvoyagePopup.patchValue({
					modeOfConveyance: this.modeOfConveyanceArray,
				});
			}
			this.fromCountryArray = [];
			if (response.from_country != "" && response.from_country != null) {
				let array = response.from_country.split("~");
				for (let i = 0; i < array.length; i++) {
					let count = 0;
					if (this.fromCountryArray.length == 0)
						this.fromCountryArray.push({
							item_id: array[i],
							item_text: array[i],
						});
					else {
						for (let k = 0; k < this.fromCountryArray.length; k++) {
							if (array[i] == this.fromCountryArray[k].item_text) {
								count++;
							}
						}
						if (count > 0) break;
						else
							this.fromCountryArray.push({
								item_id: array[i],
								item_text: array[i],
							});
					}
				}
				this.subvoyagePopup.patchValue({
					fromCountryArray: this.fromCountryArray,
				});
				this.fromcountry = this.fromCountryArray;
			} else {
				this.fromCountryArray = response.from_country;
				this.subvoyagePopup.patchValue({
					fromCountryArray: response.from_country,
				});
			}
			this.toCountryArray = [];
			if (response.to_country != "" && response.to_country != null) {
				let array = response.to_country.split("~");
				for (let i = 0; i < array.length; i++) {
					let count = 0;
					if (this.toCountryArray.length == 0)
						this.toCountryArray.push({ item_id: array[i], item_text: array[i] });
					else {
						for (let k = 0; k < this.toCountryArray.length; k++) {
							if (array[i] == this.toCountryArray[k].item_text) {
								count++;
							}
						}
						if (count > 0) break;
						else
							this.toCountryArray.push({
								item_id: array[i],
								item_text: array[i],
							});
					}
				}
				this.tocountry = this.toCountryArray;
				this.subvoyagePopup.patchValue({
					toCountryArray: this.toCountryArray,
				});
			} else {
				this.toCountryArray = response.to_country;
				this.subvoyagePopup.patchValue({
					toCountryArray: response.to_country,
				});
			}
			this.subvoyageId = response.id;
		}

	/*
	 * Created By : PriyaDharshini M
	 * Description : On changing the declaration type few fields get changed there data.
	 *********************************************/
	declarationTypeChange(value, id) {
		if (value == "declaration") {
			// when field is declaration
		} else if (value == "si") {
			if (this.subvoyagePopup.value.certificateAllowed == "No") {
				$("#sipercent").attr("disabled", "true");
				$("#openingBalance").attr("disabled", "true");
				$("#nonStdClauses").attr("disabled", "true");
				$("#noofDaysBackdate").attr("disabled", "true");
				$("#premiumDisplay").attr("disabled", "true");
				$("#addClientinCertificate").attr("disabled", "true");
				$("#minShipmentPremium").attr("disabled", "true");
				this.openingbalance = 0;
				this.premiumBalance = 0;
				this.suminsured = 0;
			} else {
				$("#sipercent").removeAttr("disabled");
				$("#openingBalance").removeAttr("disabled");
				$("#minShipmentPremium").removeAttr("disabled");
				$("#noofDaysBackdate").removeAttr("disabled");
				$("#addClientinCertificate").removeAttr("disabled");
				$("#premiumDisplay").removeAttr("disabled");
				$("#nonStdClauses").removeAttr("disabled");
			}
		} else {
			let typeValue = this.subvoyagePopup.value.lowbalTrigger;
			if (typeValue == "Yes") {
				$("#lowbalTriggerAmt").removeAttr("disabled");
				let lowbalanceAmount = this.netPremium * 0.2;
				for (let i = 0; i < this.voyageArrGridData.length; i++) {
					if (this.voyageArrGridData[i].id == id) {
						this.voyageArrGridData[i].low_balance_trigger_amount =
							lowbalanceAmount;
						this.subvoyagePopup.patchValue({
							lowbalTriggerAmt: lowbalanceAmount,
						});
					}
				}
			} else {
				$("#lowbalTriggerAmt").attr("disabled", "true");
				for (let i = 0; i < this.voyageArrGridData.length; i++) {
					if (this.voyageArrGridData[i].id == id) {
						this.voyageArrGridData[i].low_balance_trigger_amount = 0;
						this.subvoyagePopup.patchValue({
							lowbalTriggerAmt: 0,
						});
					}
				}
			}
		}

		this.voyageSIChange(this.voyageId,'');
	}
	/*
	 * Created By : PriyaDharshini M
	 * Description : it saves the subvoayge that has edited with in the popup.
	 *********************************************/
	async saveSubVoyageData(voyageId, subvoyageId, openingbalance) {
		if (this.subvoyagePopup.invalid || this.SiValid == true || this.isPostValid ==true) {
			this.submitted = true;
			return;
		} else {
			this.spinner.show();
			let pslValue = this.subvoyagePopup.value.psl;
			for (let a = 0; a < this.voyageArr.length; a++) {
				if (this.voyageArr[a].gc_running_id == voyageId) {
					if (Number(pslValue) > Number(this.voyageArr[a].per_seeding_limit)) {
						this.commonService.errorsmsg(
							"Per Seeding Limit value should not be greater than " +
								this.voyageArr[a].per_seeding_limit,
							"Error"
						);
						this.spinner.hide();
						return;
					}
				}
			}
			let si_percentage_value = 0;
			let value = this.subvoyagePopup.value;
			for (let i = 0; i < this.voyageArrGridData.length; i++) {
				for (let j = 0; j < this.voyageArrData.length; j++) {
					if (voyageId == this.voyageArrData[j].gc_running_id) {
						this.voyageArrData[j].declaration_type_sub_voyage =
							this.subvoyagePopup.value.declarationType;
						this.voyageArrData[j].low_balance_trigger =
							this.subvoyagePopup.value.lowbalTrigger;
						this.voyageArrData[j].low_balance_trigger_amount =
							this.subvoyagePopup.value.lowbalTriggerAmt;
					}
				}
				for (let j = 0; j < this.voyageArrForPolicy.length; j++) {
					if (voyageId == this.voyageArrForPolicy[j].gc_running_id) {
						this.voyageArrForPolicy[j].declaration_type_sub_voyage =
							this.subvoyagePopup.value.declarationType;
						this.voyageArrForPolicy[j].low_balance_trigger =
							this.subvoyagePopup.value.lowbalTrigger;
						this.voyageArrForPolicy[j].low_balance_trigger_amount =
							this.subvoyagePopup.value.lowbalTriggerAmt;
					}
				}
				for (let j = 0; j < this.voyageArr.length; j++) {
					if (voyageId == this.voyageArr[j].gc_running_id) {
						this.voyageArr[j].declaration_type_sub_voyage =
							this.subvoyagePopup.value.declarationType;
						this.voyageArr[j].low_balance_trigger =
							this.subvoyagePopup.value.lowbalTrigger;
						this.voyageArr[j].low_balance_trigger_amount =
							this.subvoyagePopup.value.lowbalTriggerAmt;
					}
				}
				if (this.voyageArrGridData[i].id == subvoyageId) {
					let conveyance = "";
					let count = 0;
					for (let idx = 0; idx < this.modeofconveyance.length; idx++) {
						if (count == 0) {
							conveyance = this.modeofconveyance[idx].item_text;
							count++;
						} else {
							conveyance =
								conveyance + "," + this.modeofconveyance[idx].item_text;
							count++;
						}
					}
					let from_country = "";
					let from_country_display = "";
					let count1 = 0;
					for (let idx = 0; idx < this.fromcountry.length; idx++) {
						if (count1 == 0) {
							from_country = this.fromcountry[idx].item_text;
							from_country_display = this.fromcountry[idx].item_text;
							count1++;
						} else {
							from_country =
								from_country + "~" + this.fromcountry[idx].item_text;
							from_country_display =
								from_country_display + "," + this.fromcountry[i].item_text;
							count1++;
						}
					}
					let to_country = "";
					let to_country_display = "";
					let count2 = 0;
					for (let idx = 0; idx < this.tocountry.length; idx++) {
						if (count2 == 0) {
							to_country = this.tocountry[idx].item_text;
							to_country_display = this.tocountry[idx].item_text;
							count2++;
						} else {
							to_country = to_country + "~" + this.tocountry[idx].item_text;
							to_country_display =
								to_country_display + "," + this.tocountry[idx].item_text;
							count2++;
						}
					}
					this.voyageArrGridData[i].sub_voyage_name =
						this.subvoyagePopup.value.subVoyageName;
					this.voyageArrGridData[i].coverage_type =
						this.subvoyagePopup.value.coveragetype;
					this.voyageArrGridData[i].certificate_bulk =
						this.subvoyagePopup.value.certificate;
					this.voyageArrGridData[i].certificate_allowed =
						this.subvoyagePopup.value.certificateAllowed;
					this.voyageArrGridData[i].transit_excess_in_certificate =
						this.subvoyagePopup.value.transitexcessamount;
					this.voyageArrGridData[i].mode_of_conveyance = conveyance;
					this.voyageArrGridData[i].min_shipment_premium =
						this.subvoyagePopup.value.shipmentpreminum;
					this.voyageArrGridData[i].declaration_type =
						this.subvoyagePopup.value.declarationType;
					this.voyageArrGridData[i].low_balance_trigger =
						this.subvoyagePopup.value.lowbalTrigger;
					this.voyageArrGridData[i].low_balance_trigger_amount =
						this.subvoyagePopup.value.lowbalTriggerAmt;
					this.voyageArrGridData[i].back_date_days =
						this.subvoyagePopup.value.backdatedays;
					this.voyageArrGridData[i].days_post_expiry =
						this.subvoyagePopup.value.postexpiry;
					this.voyageArrGridData[i].display_premium =
						this.subvoyagePopup.value.premiumdisplay;
					this.voyageArrGridData[i].non_standard_clauses =
						this.subvoyagePopup.value.non_std_clauses;
					this.voyageArrGridData[i].client_in_certificate =
						this.subvoyagePopup.value.addclient;
					this.voyageArrGridData[i].bulk_declaration_type =
						this.subvoyagePopup.value.bulkdeclarationtype;
					this.voyageArrGridData[i].from_country = from_country;
					this.voyageArrGridData[i].to_country = to_country;
					this.voyageArrGridData[i].from_country_split = from_country_display;
					this.voyageArrGridData[i].to_country_split = to_country_display;
					this.voyageArrGridData[i].per_seeding_limit =
						this.subvoyagePopup.value.psl;
					this.voyageArrGridData[i].bov_percentage =
						this.subvoyagePopup.value.bovpercent;
					this.voyageArrGridData[i].transit_excees =
						this.subvoyagePopup.value.transitexcess;
					this.voyageArrGridData[i].marine_final_rate_percentage =
						this.subvoyagePopup.value.marineRate;
				}

				if (
					(this.policyType == "MOP" || this.policyType == "Open Cover") &&
					this.voyageArrGridData[i].gc_running_id == voyageId
				) {
					if (
						(this.voyageArrGridData[i].certificate_bulk.includes("Bulk") &&
							value.certificate.includes("Bulk")) ||
						(this.voyageArrGridData[i].certificate_bulk.includes(
							"Certificate"
						) &&
							value.certificate.includes("Certificate"))
					) {
						this.voyageArrGridData[i].si_percentage =
							this.subvoyagePopup.value.SI_Percentage;
						this.voyageArrGridData[i].opening_balance = this.openingbalance;
						this.voyageArrGridData[i].premium_balance = this.premiumBalance;
						this.voyageArrGridData[i].si_percentage_display =
							this.subvoyagePopup.value.SI_Percentage;
						this.voyageArrGridData[i].opening_balance_display =
							this.openingbalance;
						this.voyageArrGridData[i].premium_balance_display =
							this.premiumBalance;
					} else {
						let siPercentage = 100 - this.subvoyagePopup.value.SI_Percentage;
						let premiumBalance =
							this.voyageArrGridData[i].net_premium_with_tax *
							(siPercentage / 100);
						let openingBalance =
							this.voyageArrGridData[i].initial_sum_insured *
							(siPercentage / 100);
						this.voyageArrGridData[i].si_percentage = siPercentage;
						this.voyageArrGridData[i].opening_balance = openingBalance;
						this.voyageArrGridData[i].premium_balance = premiumBalance;
						this.voyageArrGridData[i].si_percentage_display = siPercentage;
						this.voyageArrGridData[i].opening_balance_display = openingBalance;
						this.voyageArrGridData[i].premium_balance_display = premiumBalance;
					}
				}

				if (
					(this.policyType == "STOP" || this.policyType == "Project Policy") &&
					this.voyageArrGridData[i].gc_running_id == voyageId &&
					this.voyageArrGridData[i].certificate_allowed ==
						value.certificateAllowed
				) {
					if (this.subvoyagePopup.value.certificateAllowed == "No") {
						this.voyageArrGridData[i].si_percentage = 0;
						this.voyageArrGridData[i].opening_balance = 0;
						this.voyageArrGridData[i].premium_balance = 0;
						this.voyageArrGridData[i].si_percentage_display = "";
						this.voyageArrGridData[i].opening_balance_display = "";
						this.voyageArrGridData[i].premium_balance_display = "";
					} else {
						this.voyageArrGridData[i].si_percentage =
							this.subvoyagePopup.value.SI_Percentage;
						this.voyageArrGridData[i].opening_balance = this.openingbalance;
						this.voyageArrGridData[i].premium_balance = this.premiumBalance;
					}
				}
				if (this.voyageArrGridData[i].gc_running_id == voyageId) {
					if (si_percentage_value == 0)
						si_percentage_value = parseInt(
							this.voyageArrGridData[i].si_percentage
						);
					else
						si_percentage_value =
							si_percentage_value +
							parseInt(this.voyageArrGridData[i].si_percentage);
				}
			}

			await this.submit("subvoyage");
			$("voyageGrid2").DataTable().destroy();
			// let table = $('voyageGrid2').DataTable().destroy();
			await this.getQuote("subvoyage");
			/* this.dtTrigger.next(); */
			this.commonService.successmsg(
				"Voyage Details saved successfully",
				"Success"
			);
			this.modalRef.hide();
			this.spinner.hide();
		}
	}

	//days post expiry start//
	postExpiryDateChange(event){
		let PostExpiryDateValid = event.target.value;
		if(PostExpiryDateValid >= 0 && PostExpiryDateValid <= 365){
		  this.isPostValid = false
		 
		}else{
		  this.isPostValid = true
		 
		}
	  }
	  //days post expiry end>

	/*
	 * Created By : PriyaDharshini M
	 * Description : saves the entire from data  with in server.
	 *********************************************/
	async submit(type) {
		//this.isShowConvertPolicyButton = true;
		if (this.policyDetails.invalid) {
			this.submitted = true;
			return;
		} else {
			this.spinner.show();
			let effDate, lockDateVal;
			effDate = this.datePipe.transform(this.PolicyEffectiveDate, "yyyy-MM-dd");
			lockDateVal = this.datePipe.transform(this.policyLockDate, "yyyy-MM-dd");
			this.policyInceptionDate = new Date(this.policyInceptionDate);
			this.policyExpiryDate = new Date(this.policyExpiryDate);
			this.policyInceptionDate = this.datePipe.transform(
				this.policyInceptionDate,
				"yyyy-MM-dd"
			);
			this.policyExpiryDate = this.datePipe.transform(
				this.policyExpiryDate,
				"yyyy-MM-dd"
			);
			let effectiveDate = new Date(effDate);
			let lockDate = new Date(lockDateVal);
			let inceptionDate = new Date(this.policyInceptionDate);
			let expiryDate = new Date(this.policyExpiryDate);
			let underwriterMail = [];
			for (let count = 0; count < this.underwriterData.length; count++) {
				underwriterMail.push(this.underwriterData[count].email.toLowerCase());
			}
			this.underwriterEmail = underwriterMail.join(",");
			if (effectiveDate < inceptionDate || effectiveDate > expiryDate) {
				this.commonService.errorsmsg(
					"Portal Effective Date Should be Greater than Inception date and Less than Expiry date",
					"Error"
				);
				this.isShowConvertPolicyButton = false;
				this.spinner.hide();
				return;
			}
			if (lockDate < inceptionDate || lockDate > expiryDate) {
				this.commonService.errorsmsg(
					"Portal Lock Date Should be Greater than Inception date and Less than Expiry date",
					"Error"
				);
				this.isShowConvertPolicyButton = false;
				this.spinner.hide();
				return;
			}
			this.voyageArrData = this.voyageArr;
			let url, params: any, response;
			let grpName = this.selectGroup.value.groupNameValue;
       //GroupName changes start
       if(grpName?.length === 0 || grpName === "" || grpName === undefined || grpName === null ) {
        grpName = "";
      }
      //GroupName changes end
			if (this.selectedPolicyStatus != 0) {
				url =
					this.commonVariablesService.baseURL +
					"api/v1/marine_mp_gc_data/update";
				params = {
					policy_ref_num: this.selectedPolicyNumber,
					policy_number: this.policyNumberForDispaly,
					group_name: grpName || "",
					portal_lock_date: lockDateVal,
					portal_effective_date: effDate,
					tagic_rm_email: this.tagicRMemail,
					underwriter_email: this.underwriterEmail,
					voyage: this.voyageArrData,
					sub_voyage: this.voyageArrGridData,
					/* author: this.cookie.get('email') */
					author: window.localStorage.getItem("email"),
				};
				response = await this.commonService.httpPostMethod(
					url,
					params,
					"application/json",
					true,
					"Policy Configuration"
				);
				if (response.body.status == 0) {
					if (type == "subvoyage") {
						//window.location.reload();
					} else if (type == "convertToPolicy") {
						// when type is 'convertToPolicy'
					} else {
						this.commonService.successmsg(
							"Policy Details updated Successfully",
							"Success"
						);
						this.router.navigate(["/master-policy-complete"]);
					}
				} else if (response.status != -114) {
					this.commonService.errorsmsg(response.body.txt, "Error");
					this.isShowConvertPolicyButton = false;
					return;
				}
			} else {
				await this.clientDetailsOnSave();
				await this.producerDetailsOnSave();
				this.allGroupDataId = [];
				this.voyageArrData = JSON.parse(JSON.stringify(this.voyageArr));
				let referenceNumber = "";
				let updateResponse;
				if (
					this.endorsementPolicyReferenceNumber != "" &&
					this.endorsementPolicyReferenceNumber != undefined
				)
					referenceNumber = this.endorsementPolicyReferenceNumber;
				else referenceNumber = this.policyNumber;
				url =
					this.commonVariablesService.baseURL +
					"api/v1/marine_mp_gc_data/update";
				params = {
					policy_ref_num: referenceNumber,
					policy_number: this.policyNumberForDispaly,
					group_name: grpName || "",
					portal_lock_date: lockDateVal,
					portal_effective_date: effDate,
					tagic_rm_email: this.tagicRMemail,
					underwriter_email: this.underwriterEmail,
					voyage: this.voyageArrData,
					sub_voyage: this.voyageArrGridData,
					/* author: this.cookie.get('email') */
					author: window.localStorage.getItem("email"),
				};
				updateResponse = await this.commonService.httpPostMethod(
					url,
					params,
					"application/json",
					true,
					"Policy Configuration"
				);
				if (updateResponse.body.status == 0) {
					for (let i = 0; i < this.voyageArrForPolicy.length; i++) {
						let openingBalanceYes = "",
							siPercentYes = "",
							premiumBalanceYes = "";
						let openingBalanceNo = "",
							siPercentNo = "",
							premiumBalanceNo = "";
						let openingBalanceBulk = "",
							siPercentBulk = "",
							premiumBalanceBulk = "";
						let openingBalanceCertificate = "",
							siPercentCertificate = "",
							premiumBalanceCertificate = "";
						let clientUser = [],
							producerUser = [],
							policyId;
						let responseArray;
						this.subvoyagearray = [];
						let aclurl = "",
							aclClientParam = [],
							aclProducerParam = [];
						aclurl =
							this.commonVariablesService.baseURL +
							"api/v1/marine_mp_gc_data/acl";
						for (
							let d = 0;
							d < this.voyageArrForPolicy[i].client_users.length;
							d++
						) {
							// Policy setup Changes
                            var finalData = [];
							this.actualData.forEach( value => {
								this.userdeletedData.forEach( value1 =>{
									if(value.gc_running_id == value1.gc_running_id) {
										console.log('enter')
										value.email_id.forEach( x=> {
											if(value1.email_id.indexOf(x) == -1) {
												finalData.push({
													email_id : x,
													gc_running_id : value.gc_running_id,
													policy_no : value.policy_no
												})
											}
										})
										
									}
								})
								
							});
							
							if(this.deletedData.length !== 0) {
								for(let j=0;this.deletedValue.length>j;j++){
									if(this.voyageArrForPolicy[i].policy_no ==this.deletedValue[j].policy_no){
										console.log("this.deletedValue[j]",this.deletedValue)
										aclClientParam.push({
											policy_no: this.voyageArrForPolicy[i].policy_no,
											email_id:this.deletedData[j].email_id.toLowerCase(),
											//this.deleteVoyageClientUsersData[j].deletevoyageGridClientUserData,
											status: 1,
										});    
									}
								}
							} else {
								console.log(this.deletedValue)
								console.log(this.voyageArrForPolicy)
								console.log(finalData)
								for(let j=0;finalData.length>j;j++){
									if(this.voyageArrForPolicy[i].policy_no ==finalData[j].policy_no && this.voyageArrForPolicy[i].gc_running_id == finalData[j].gc_running_id){
										console.log("this.deletedValue[j]",finalData)
										aclClientParam.push({
											policy_no: finalData[j].policy_no,
											email_id: finalData[j].email_id.toLowerCase(),
											//this.deleteVoyageClientUsersData[j].deletevoyageGridClientUserData,
											status: 1,
										});    
									}
								}
							}

							aclClientParam.push({
								policy_no: this.voyageArrForPolicy[i].policy_no,
								email_id:
									this.voyageArrForPolicy[i].client_users[d].toLowerCase(),
								status: 0,
							});

							// Policy setup Changes
							aclClientParam = aclClientParam.filter((v,i,a)=>a.findIndex(v2=>['email_id'].every(k=>v2[k] ===v[k]))===i)

							console.log(aclClientParam);
						}
						for (
							let e = 0;
							e < this.voyageArrForPolicy[i].producer_users.length;
							e++
						) {
							aclProducerParam.push({
								policy_no: this.voyageArrForPolicy[i].policy_no,
								email_id:
									this.voyageArrForPolicy[i].producer_users[
										e
									].email.toLowerCase(),
								status: 0,
							});
						}
						let aclClientResponse = await this.commonService.httpPostMethod(
							aclurl,
							aclClientParam,
							"",
							true,
							"Policy Configuration"
						);
						if (
							aclClientResponse.body.status != 0 &&
							aclClientResponse.body.status != -114
						) {
							this.commonService.errorsmsg(aclClientResponse.body.txt, "Error");
							this.isShowConvertPolicyButton = false;
							return;
						}
						let aclProducerResponse = await this.commonService.httpPostMethod(
							aclurl,
							aclProducerParam,
							"",
							true,
							"Policy Configuration"
						);
						if (
							aclProducerResponse.body.status != 0 &&
							aclProducerResponse.body.status != -114
						) {
							this.commonService.errorsmsg(
								aclProducerResponse.body.txt,
								"Error"
							);
							this.isShowConvertPolicyButton = false;
							return;
						}
						for (let j = 0; j < this.voyageArrGridData.length; j++) {
							if (
								this.voyageArrForPolicy[i].gc_running_id ==
								this.voyageArrGridData[j].gc_running_id
							) {
								for (let b = 0; b < this.voyageArrData.length; b++) {
									if (
										this.voyageArrForPolicy[i].gc_running_id ==
										this.voyageArrData[b].gc_running_id
									) {
										clientUser = this.voyageArrData[b].client_users;
										producerUser = this.voyageArrData[b].producer_users;
									}
								}

								if (
									this.policyType == "STOP" ||
									this.policyType == "Project Policy"
								) {
									if (this.voyageArrGridData[j].certificate_allowed == "Yes") {
										openingBalanceYes =
											this.voyageArrGridData[j].opening_balance;
										siPercentYes = this.voyageArrGridData[j].si_percentage;
										premiumBalanceYes =
											this.voyageArrGridData[j].premium_balance;
									} else if (
										this.voyageArrGridData[j].certificate_allowed == "No"
									) {
										openingBalanceNo =
											this.voyageArrGridData[j].opening_balance;
										siPercentNo = this.voyageArrGridData[j].si_percentage;
										premiumBalanceNo =
											this.voyageArrGridData[j].premium_balance;
									}
								} else if (
									this.policyType == "MOP" ||
									this.policyType == "Open Cover"
								) {
									if (
										this.voyageArrGridData[j].certificate_bulk.includes("Bulk")
									) {
										openingBalanceBulk =
											this.voyageArrGridData[j].opening_balance;
										siPercentBulk = this.voyageArrGridData[j].si_percentage;
										premiumBalanceBulk =
											this.voyageArrGridData[j].premium_balance;
									} else if (
										this.voyageArrGridData[j].certificate_bulk.includes(
											"Certificate"
										)
									) {
										openingBalanceCertificate =
											this.voyageArrGridData[j].opening_balance;
										siPercentCertificate =
											this.voyageArrGridData[j].si_percentage;
										premiumBalanceCertificate =
											this.voyageArrGridData[j].premium_balance;
									}
								}
								policyId = this.voyageArrGridData[j].policy_id;
								this.subvoyagearray.push({
									id: this.voyageArrGridData[j].id,
									gc_running_id: this.voyageArrGridData[j].gc_running_id,
									sub_voyage_name: this.voyageArrGridData[j].sub_voyage_name,
									coverage_type: this.voyageArrGridData[j].coverage_type,
									certificate_bulk: this.voyageArrGridData[j].certificate_bulk,
									certificate_allowed:
										this.voyageArrGridData[j].certificate_allowed,
									bulk_declaration_type:
										this.voyageArrGridData[j].bulk_declaration_type,
									bov_percentage: this.voyageArrGridData[j].bov_percentage,
									per_seeding_limit:
										this.voyageArrGridData[j].per_seeding_limit,
									transit_excees: this.voyageArrGridData[j].transit_excees,
									transit_excess_in_certificate:
										this.voyageArrGridData[j].transit_excess_in_certificate,
									mode_of_conveyance:
										this.voyageArrGridData[j].mode_of_conveyance,
									min_shipment_premium:
										this.voyageArrGridData[j].min_shipment_premium,
									back_date_days: this.voyageArrGridData[j].back_date_days,
									days_post_expiry: this.voyageArrGridData[j].days_post_expiry,
									display_premium: this.voyageArrGridData[j].display_premium,
									non_standard_clauses:
										this.voyageArrGridData[j].non_standard_clauses,
									from_country: this.voyageArrGridData[j].from_country,
									to_country: this.voyageArrGridData[j].to_country,
									client_in_certificate:
										this.voyageArrGridData[j].client_in_certificate,
									marine_final_rate_percentage:
										this.voyageArrGridData[j].marine_final_rate_percentage,
								});
							}
						}
						responseArray = this.subvoyagearray;
						url =
							this.commonVariablesService.baseURL +
							"api/v1/policy/meta/" +
							policyId;
						params = {
							group_name: grpName || "",
							portal_lock_date: lockDateVal,
							portal_effective_date: effDate,
							tagic_rm_email: this.tagicRMemail,
							underwriter_email: this.underwriterEmail,
							producer_users: producerUser,
							sub_voyage: responseArray,
							client_users: clientUser,
							opening_balance_certificate: openingBalanceCertificate,
							si_percentage_certificate: siPercentCertificate,
							premium_balance_certificate: premiumBalanceCertificate,
							opening_balance_bulk: openingBalanceBulk,
							si_percentage_bulk: siPercentBulk,
							premium_balance_bulk: premiumBalanceBulk,
							opening_balance_certificateyes: openingBalanceYes,
							si_percentage_certificateyes: siPercentYes,
							premium_balance_certificateyes: premiumBalanceYes,
							opening_balance_certificateno: openingBalanceNo,
							si_percentage_certificateno: siPercentNo,
							premium_balance_certificateno: premiumBalanceNo,
							low_balance_trigger:
								this.voyageArrForPolicy[i].low_balance_trigger,
							low_balance_trigger_amount:
								this.voyageArrForPolicy[i].low_balance_trigger_amount,
							declaration_type_sub_voyage:
								this.voyageArrForPolicy[i].declaration_type_sub_voyage,
						};
						response = await this.commonService.httpPostMethod(
							url,
							params,
							"application/json",
							true,
							"Policy Configuration"
						);
					}
					if (response.body.status == 0) {
						//if(this.defaultClientUserLength.length > 0)
						await this.triggerMailToClient();
						//if(this.defaultProducerUserLength.length > 0)
						await this.triggerMailToProducer();
						if (type == "subvoyage") {
							//window.location.reload();
						} else {
							this.commonService.successmsg(
								"Policy Details updated Successfully",
								"Success"
							);
							this.router.navigate(["/master-policy-complete"]);
						}
					} else if (response.status != -114) {
						this.commonService.errorsmsg(response.body.txt, "Error");
					}
				} else if (updateResponse.body.status != -114)
					this.commonService.errorsmsg(updateResponse.body.txt, "Error");
			}
		}
		// Policy setup Changes
		this.deletedData = [];
		this.actualData = [];
		this.userdeletedData = [];
	}
	/*
	 * Created By : Manasa R
	 * Description : While  the group name is about to select  few configaratons are added.
	 *********************************************/
	onOpenOfGroupName() {
		this.config1 = {
			//displayKey:"", //if objects array passed which key to be displayed defaults to description
			search: true, //true/false for the search functionlity defaults to false,
			height: "auto", //height of the list so that if there are more no of items it can show a scroll defaults to auto. With auto height scroll will never appear
			placeholder: "Select", // text to be displayed when no item is selected defaults to Select,
			customComparator: () => {}, // a custom function using which user wants to sort the items. default is undefined and Array.sort() will be used in that case,
			limitTo: 5, // a number thats limits the no of options displayed in the UI similar to angular's limitTo pipe
			//moreText: 'more', // text to be displayed whenmore than one items are selected like Option 1 + 5 more
			noResultsFound: "No results found!", // text to be displayed when no items are found while searching
			searchPlaceholder: "Search group name", // label thats displayed in search input,
			//searchOnKey: 'group', // key on which search should be performed this will be selective search. if undefined this will be extensive search on all keys
		};
	}
	/*
	 * Created By : PriyaDharshini M
	 * Description : sets the group name to variable that has been added with in dom.
	 *********************************************/
	async addGroupName() {
		if (this.addGroup.invalid) {
			this.submitted = true;
			return;
		} else {
			let groupName = this.addGroup.value.addGroupValue;
			if (groupName.trim() == "") {
				this.commonService.errorsmsg("Unable to Add Group Name", "Error");
				return;
			}
			if (groupName != "") {
				let url =
					this.commonVariablesService.baseURL +
					"api/v1/marine_master/add/group";
				let param = new HttpParams().set("name", groupName);
				let response = await this.commonService.httpPostMethod(
					url,
					param,
					"application/x-www-form-urlencoded",
					true,
					"Policy Configuration"
				);
				if (response.body.status == 0) {
					this.commonService.successmsg(
						"Group Name Added Successfully",
						"Success"
					);
					this.selectGroup.patchValue({
						groupNameValue: groupName,
					});
					this.showGroupName();
				} else if (response.body.data.includes("Duplicate entry")) {
					this.commonService.errorsmsg("Group name already exists", "Error");
					return;
				} else if (response.body.status != -114) {
					this.commonService.errorsmsg(response.body.txt, "Error");
					return;
				}
				this.addGroup.reset();
				this.modalRef.hide();
			}
		}
	}
	/*
	 * Created By : PriyaDharshini M
	 * Description : Shows the group name with in DOM if it already exist.
	 *********************************************/
	async showGroupName() {
		let url =
			this.commonVariablesService.baseURL +
			"api/v1/marine_master/fetchall/group";
		let response = await this.commonService.httpGetMethod(
			url,
			"",
			true,
			"",
			"Policy Configuration"
		);
		if (response.status == 0) {
			for (let i = 0; i < response.data.length; i++) {
				if (response.data[i].group_name != "") {
					this.insuredgroupName[i] = response.data[i].group_name;
				}
			}
		} else if (response.status != -114)
			this.commonService.errorsmsg(response.txt, "Error");
	}

	/*
	 * Created By : PriyaDharshini M
	 * Description : gets the underwriter info and pushes to table.
	 *********************************************/
	async underwriterInfo(code) {
		this.underwriterData = [];
		var emailarr = code.split(",");
		/* let url, response, param; */
		let name = "";
		for (let i = 0; i < emailarr.length; i++) {
			this.underwriterData.push({
				email: emailarr[i].toLowerCase(),
				name: "",
				phone_no: "",
				uw_level: "",
			});
		}
		/* url = this.commonVariablesService.baseURL + 'api/v1/marine_user_management/users'
		param = {
			product: this.commonVariablesService.user_management_product,
			role: this.commonVariablesService.role_uw
		}
		response = await this.commonService.httpGetMethod(url, 'application/json', true, param, 'Policy Configuration') */
		if (this.allUnderWriterDetails.length > 0) {
			/* this.allUnderWriterDetails = response.data; */
			for (let k = 0; k < this.underwriterData.length; k++) {
				for (let j = 0; j < this.allUnderWriterDetails.length; j++) {
					if (
						this.allUnderWriterDetails[j].email_id.toLowerCase() ==
						this.underwriterData[k].email.toLowerCase()
					) {
						name =
							this.allUnderWriterDetails[j].employee_first_name +
							" " +
							this.allUnderWriterDetails[j].employee_last_name;
						this.underwriterData[k].name = name;
						this.underwriterData[k].phone_no =
							this.allUnderWriterDetails[j].mobile_no;
						this.underwriterData[k].uw_level =
							this.allUnderWriterDetails[j].level;
					}
				}
			}
		}
		this.underWriterDataTable(); /* else if (response.status != -114)
			this.commonService.errorsmsg(response.txt, 'Error'); */
	}
	/*
	 * Created By : PriyaDharshini M
	 * Description : gets the underwriter info.
	 *********************************************/
	async allUnderwriterData() {
		let url, response, param;
		url =
			this.commonVariablesService.baseURL +
			"api/v1/marine_user_management/users";
		param = {
			product: this.commonVariablesService.user_management_product,
			role: this.commonVariablesService.role_uw,
		};
		response = await this.commonService.httpGetMethod(
			url,
			"application/json",
			true,
			param,
			"Policy Configuration"
		);
		if (response.status == 0) {
			this.allUnderWriterDetails = response.data;
		} else if (response.status != -114)
			this.commonService.errorsmsg(response.txt, "Error");
	}
	/*
	 * Created By : Manasa R
	 * Description : it is used to load the data in underwriter datatable.
	 *********************************************/
	underWriterDataTable() {
		if ($.fn.dataTable.isDataTable("#table_underwriter")) {
			$("#table_underwriter").DataTable().destroy();
		}
		$("#table_underwriter")
			.DataTable({
				data: this.underwriterData,
				columns: [
					{ data: "name" },
					{
						data: "email",
					},
					{ data: "phone_no" },
					{
						data: "uw_level",
					},
					{
						data: null,
						render: function (data) {
							return '<div  class="text-center"><span tblHead="Action"></span><i class="fa fa-trash-o" aria-hidden="true"></i></div>';
						},
					},
				],

				paging: false,
				info: false,
				rowCallback: (row: Node, data: any[] | Object, index: number) => {
					const self = this;
					$("td:last-child", row).unbind("click");
					$("td:last-child", row).bind("click", async () => {
						let status = await this.commonService.deleteAlertMsg();
						if (status) self.deleteUnderWriterUserDetails(row, data);
					});
				},
			})
			.draw();
		if (this.selectedPolicyStatus == 0 && this.isShowButtons == false) {
			let table = $("#table_underwriter").DataTable();
			table.destroy();
			table.column(4).visible(false);
			this.dtTrigger.next();
		}
	}
	/*
	 * Created By : Manasa R
	 * Description : used to delete under writer data with in grid.
	 *********************************************/
	async deleteUnderWriterUserDetails(element, data) {
		$(element).remove();
		for (let count = 0; count < this.underwriterData.length; count++) {
			if (
				this.underwriterData[count].email.toLowerCase() ==
				data.email.toLowerCase()
			) {
				this.underwriterData.splice(count, 1);
				break;
			}
		}
		this.underWriterDataTable();
		this.commonService.warningmsg("Deleted Successfully", "Worning");
	}
	/*
	 * Created By : Manasa R
	 * Description : loads the under writer data with in popup of add existing under writer.
	 *********************************************/
	async addUnderWriter(template: TemplateRef<any>) {
		this.checkedUnderWriterUsers = [];
		let dataToTable = [];
		for (let count = 0; count < this.allUnderWriterDetails.length; count++) {
			if (this.allUnderWriterDetails[count].level == "one")
				dataToTable.push(this.allUnderWriterDetails[count]);
		}
		for (let count = 0; count < dataToTable.length; count++) {
			if (this.underwriterData.length > 0) {
				for (let i = 0; i < this.underwriterData.length; i++) {
					let user = this.underwriterData[i].email;
					if (user.toLowerCase() == dataToTable[count].email_id.toLowerCase()) {
						dataToTable[count]["isChecked"] = "checked";
						break;
					} else {
						dataToTable[count]["isChecked"] = "";
					}
				}
			} else {
				dataToTable[count]["isChecked"] = "";
			}
		}
		this.modalRef = await this.modalService.show(template, this.config);
		for (let i = 0; i < this.underwriterData.length; i++) {
			this.checkedUnderWriterUsers.push(
				this.underwriterData[i].email.toLowerCase()
			);
		}
		if ($.fn.dataTable.isDataTable("#table_totalUnderWriterDetails")) {
			$("#table_totalUnderWriterDetails").DataTable().destroy();
		}
		$("#table_totalUnderWriterDetails")
			.DataTable({
				data: dataToTable,
				columns: [
					{
						data: null,
						render: function (data) {
							let isChecked = data["isChecked"];
							let obj =
								'<div class="theme-checkbox" ><span tblHead="Select"></span><span class="tblValue">' +
								'<input type="checkbox" value="" id="' +
								data["email_id"] +
								'" ' +
								isChecked +
								"></span></div>";
							return obj;
						},
					},
					{
						data: null,
						render: function (data) {
							return data.employee_first_name + "" + data.employee_last_name;
						},
					},
					{
						data: "email_id",
					},
					{ data: "mobile_no" },
					{
						data: "level",
					},
					{
						data: null,
						render: function (data) {
							if (data.active == "true") return "Active";
							else return "Inactive";
						},
					},
				],
				paging: false,
				info: false,
				rowCallback: (row: Node, data: any[] | Object, index: number) => {
					const self = this;
					$("td:first-child", row).unbind("change");
					$("td:first-child", row).bind("change", () => {
						self.underWriterUserIsChecked(data);
					});
				},
			})
			.draw();
	}

	/*
	 * Created By : Manasa R
	 * Description : to know the under writer is already checked or not with in popup.
	 *********************************************/
	underWriterUserIsChecked(data) {
		if ($("#" + $.escapeSelector(data.email_id)).is(":checked")) {
			this.checkedUnderWriterUsers.push(data.email_id.toLowerCase());
			for (let count = 0; count < this.allUnderWriterDetails.length; count++) {
				if (
					this.allUnderWriterDetails[count].locations == data.locations &&
					(this.allUnderWriterDetails[count].level == "two" ||
						this.allUnderWriterDetails[count].level == "three")
				) {
					if (
						this.checkedUnderWriterUsers.indexOf(
							this.allUnderWriterDetails[count].email_id
						) == -1
					)
						this.checkedUnderWriterUsers.push(
							this.allUnderWriterDetails[count].email_id
						);
				}
			}
		} else {
			var index = this.checkedUnderWriterUsers.indexOf(
				data.email_id.toLowerCase()
			);
			this.checkedUnderWriterUsers.splice(index, 1);
		}
	}
	/*
	 * Created By : Manasa R
	 * Description : To save the checked under writres with in under writer voyage grid.
	 *********************************************/
	saveCheckedUnderWriterDetails() {
		this.underwriterData = [];
		for (let count = 0; count < this.checkedUnderWriterUsers.length; count++) {
			for (
				let count1 = 0;
				count1 < this.allUnderWriterDetails.length;
				count1++
			) {
				if (
					this.checkedUnderWriterUsers[count].toLowerCase() ==
					this.allUnderWriterDetails[count1].email_id.toLowerCase()
				) {
					let data = {
						name:
							this.allUnderWriterDetails[count1].employee_first_name +
							" " +
							this.allUnderWriterDetails[count1].employee_last_name,
						email: this.allUnderWriterDetails[count1].email_id.toLowerCase(),
						phone_no: this.allUnderWriterDetails[count1].mobile_no,
						uw_level: this.allUnderWriterDetails[count1].level,
					};
					this.underwriterData.push(data);
					//this.underwriterEmail=""+this.allUnderWriterDetails[count1].email_id);
				}
			}
		}
		this.modalRef.hide();
		this.underWriterDataTable();
	}
	/*
	 * Created By : Manasa R
	 * Description : Assign value for subvoayge dropdown.
	 *********************************************/
	onVoyageNameChange() {
		this.subVoyageNameDropdownArr = this.newsubVoyageObj[this.voyagename];
	}
	/*
	 * Created By : Manasa R
	 * Description :Grouping the Voyage name with subvoyage.
	 *********************************************/
	async loaddropdownvalues(policytype, type) {
		return new Promise(async (resolve) => {
			if (type == "voyage") {
				let subVoyageurl =
					this.commonVariablesService.baseURL +
					"api/v1/marine_master/fetchall/" +
					policytype;
				let subVoyageresponse = await this.commonService.httpGetMethod(
					subVoyageurl,
					"",
					true,
					"",
					"Policy Configuration"
				);
				if (subVoyageresponse.status == 0) {
					subVoyageresponse.data.forEach((voyageData) => {
						// check if that array exists or not in newcars object
						if (this.newsubVoyageObj[voyageData.voyage_name]) {
							// just push directly if want can create obj with in array
							this.newsubVoyageObj[voyageData.voyage_name].push(
								voyageData.sub_voyage_name
							);
						} else {
							// create a new array and push
							this.newsubVoyageObj[voyageData.voyage_name] = [];
							this.newsubVoyageObj[voyageData.voyage_name].push(
								voyageData.sub_voyage_name
							);
						}
						/* this.newsubVoyageObj[voyageData.voyage_name] ? // check if that array exists or not in newcars object
							this.newsubVoyageObj[voyageData.voyage_name].push(voyageData.sub_voyage_name)  // just push directly if want can create obj with in array
							: (this.newsubVoyageObj[voyageData.voyage_name] = [], this.newsubVoyageObj[voyageData.voyage_name].push(voyageData.sub_voyage_name)) // create a new array and push */
					});
					for (var voyageName in this.newsubVoyageObj) {
						this.voyageNameDropdownArr.push(voyageName);
					}
					resolve(true);
				} else if (subVoyageresponse.status != -114) {
					this.commonService.errorsmsg(subVoyageresponse.txt, "Error");
					resolve(false);
				}
			} else if (policytype == "coverage") {
				let url =
					this.commonVariablesService.baseURL +
					"api/v1/master/marine_m_coverage_type";
				let response = await this.commonService.httpGetMethod(
					url,
					"",
					true,
					"",
					"Policy Configuration"
				);
				if (response.status == 0) return resolve(response.data);
				else if (response.status != -114) {
					this.commonService.errorsmsg(response.txt, "Error");
					return resolve([]);
				}
			} else if (policytype == "declaration") {
				let url =
					this.commonVariablesService.baseURL +
					"api/v1/master/marine_m_declaration_type";
				let response = await this.commonService.httpGetMethod(
					url,
					"",
					true,
					"",
					"Policy Configuration"
				);
				if (response.status == 0) return resolve(response.data);
				else if (response.status != -114) {
					this.commonService.errorsmsg(response.txt, "Error");
					return resolve([]);
				}
			} else if (policytype == "declaration/certificate_bulk") {
				let url =
					this.commonVariablesService.baseURL +
					"api/v1/master/marine_m_certificate_bulk";
				let response = await this.commonService.httpGetMethod(
					url,
					"",
					true,
					"",
					"Policy Configuration"
				);
				if (response.status == 0) return resolve(response.data);
				else if (response.status != -114) {
					this.commonService.errorsmsg(response.txt, "Error");
					return resolve([]);
				}
			} else if (policytype == "declaration/bulk") {
				let url =
					this.commonVariablesService.baseURL +
					"api/v1/master/marine_m_bulk_declaration_type";
				let response = await this.commonService.httpGetMethod(
					url,
					"",
					true,
					"",
					"Policy Configuration"
				);
				if (response.status == 0) return resolve(response.data);
				else if (response.status != -114) {
					this.commonService.errorsmsg(response.txt, "Error");
					return resolve([]);
				}
			} else if (policytype == "conveyance") {
				let url =
					this.commonVariablesService.baseURL +
					"api/v1/master/marine_m_mode_of_conveyance";
				let response = await this.commonService.httpGetMethod(
					url,
					"",
					true,
					"",
					"Policy Configuration"
				);
				if (response.status == 0) return resolve(response.data);
				else if (response.status != -114) {
					this.commonService.errorsmsg(response.txt, "Error");
					return resolve([]);
				}
			} else {
				let url =
					this.commonVariablesService.baseURL +
					"api/v1/marine_master/fetchall/" +
					policytype;
				let response = await this.commonService.httpGetMethod(
					url,
					"",
					true,
					"",
					"Policy Configuration"
				);
				if (response.status == 0) return resolve(response.data);
				else if (response.status != -114) {
					this.commonService.errorsmsg(response.txt, "Error");
					return resolve([]);
				}
			}
		});
	}

	/*
	 * Created By : PriyaDharshini M
	 * Description : it loades the modeofconveyance list with in dropdown .
	 *********************************************/
	async loadmodeofconveyance() {
		this.modeofconveyanceValue = await this.loaddropdownvalues(
			"conveyance",
			""
		);
		for (let i = 0; i < this.modeofconveyanceValue.length; i++) {
			this.dropdownListConveyance.push({
				item_id: i,
				item_text: this.modeofconveyanceValue[i].name,
			});
		}
	}
	/*
	 * Created By : PriyaDharshini M
	 * Description : it loades the brokerdetails from server.
	 *********************************************/
	async loadbrokerdetails(id) {
		let parameter = new HttpParams().set("producer_code", id);
		let url =
			this.commonVariablesService.baseURL +
			"api/v1/marine_user_management/broker";
		let response = await this.commonService.httpGetMethod(
			url,
			"application/json; charset=utf-8",
			true,
			parameter,
			"Policy Configuration"
		);
		if (response.status == 0) return response;
		else if (response.status != -114)
			this.commonService.errorsmsg(response.txt, "Error");
	}

	/*
	 * Created By : PriyaDharshini M
	 * Description :moves to client tab.
	 *********************************************/
	proceedtoClientUser() {
		this.spinner.show();
		this.tabset.tabs[1].active = true;
		this.spinner.hide();
	}
	/*
	 * Created By : Manasa R
	 * Description : makes the array empty and takes the template reference on add client.
	 *********************************************/
	addClientUser(template: TemplateRef<any>) {
		this.voyageClientUsersArr = [];
		this.fetchAllClientUserData(template, "addClientUser");
		/* this.cookie.set("runningId", ""); */
		window.localStorage.setItem("runningId", "");
	}
	/*
	 * Created By : Manasa R
	 * Description : To fetch client user details with in popup and gets data render with in table.
	 *********************************************/
	async fetchAllClientUserData(template, type) {
		if (template == "") {
			this.clientUsers = [];
			let url =
				this.commonVariablesService.baseURL +
				"api/v1/marine_user_management/broker_user";
			let params = {
				status: "true,false",
				product: this.commonVariablesService.user_management_product,
				broker_user_type: "ClientUser",
			};
			let response = await this.commonService.httpPostMethod(
				url,
				params,
				"application/json",
				true,
				"Policy Configuration"
			);
			if (response.body.status == 0) {
				for (let i = 0; i < response.body.data.length; i++) {
					this.clientUsers.push(response.body.data[i]);
				}
			} else if (response.body.status != -114)
				this.commonService.errorsmsg(
					"Unable to Load Data:" + response.body.txt,
					"Error"
				);
		} else {
			this.modalRef = await this.modalService.show(template, this.config);
			$("#btn_addClientUser").show();
			$("#btn_updateClientUser").hide();
			this.clientUserDetailsForm.reset();
			this.resetClientUserForm();
		}

		for (let count = 0; count < this.clientUsers.length; count++) {
			if (this.voyageClientUsersArr.length > 0) {
				for (let i = 0; i < this.voyageClientUsersArr.length; i++) {
					let user = this.voyageClientUsersArr[i];
					if (
						user.toString().toLowerCase() ==
						this.clientUsers[count].email_id.toString().toLowerCase()
					) {
						this.clientUsers[count]["isChecked"] = "checked";
						break;
					} else {
						this.clientUsers[count]["isChecked"] = "";
					}
				}
			} else {
				this.clientUsers[count]["isChecked"] = "";
			}
		}
		if ($.fn.dataTable.isDataTable("#table_clientUserDetails")) {
			$("#table_clientUserDetails").DataTable().destroy();
		}
		// var table = await $("#table_clientUserDetails").DataTable({
		await $("#table_clientUserDetails")
			.DataTable({
				data: this.clientUsers,
				columns: [
					{
						data: null,
						render: function (data) {
							let isChecked = data["isChecked"];
							let obj =
								'<div class="theme-checkbox" ><span tblHead="Select"></span><span class="tblValue">' +
								'<input type="checkbox" value="" id="' +
								data["email_id"] +
								'" ' +
								isChecked +
								"></span></div>";
							return obj;
						},
					},
					{
						data: "email_id",
					},
					{ data: "first_name" },
					{
						data: "last_name",
					},
					{
						data: "mobile_no",
					},
					{
						data: null,
						render: function (data) {
							if (data["status"] == "true") return "Active";
							else return "Inactive";
						},
					},
					{
						data: null,
						render: function (data) {
							return (
								'<div  class="text-center">' +
								'<span tblHead="Action"></span><span class="tblValue">' +
								'<i class="edit-icon fa fa-pencil pr-1" aria-hidden="true"></i>' +
								'<i class="fa fa-trash-o pl-1" aria-hidden="true"></i></span></div>'
							);
						},
					},
				],
				destroy: true,
				paging: true,
				dom: "ftipr",
				pageLength: 30,
				rowCallback: (row: Node, data: any[] | Object, index: number) => {
					const self = this;
					$("td:first-child", row).unbind("change");
					$("td:first-child", row).bind("change", () => {
						self.clientUserIsChecked(data["email_id"]);
					});
					$(".edit-icon", row).unbind("click");
					$(".edit-icon", row).bind("click", () => {
						self.editClientUserDetails(data);
					});
					$(".fa-trash-o", row).unbind("click");
					$(".fa-trash-o", row).bind("click", async () => {
						let status = await this.commonService.deleteAlertMsg();
						if (status) self.deleteClientUserDetails(data);
					});
					return row;
				},
			})
			.draw();

		if (type == "addClientUser") {
			$("#table_clientUserDetails").DataTable().column(0).visible(false);
			$("#btn_selectedClientUsers").hide();
			this.isShowCreateClient = true;
			this.isShowAddClient = false;
		} else if (type == "addExistingUser") {
			$("#collapseBasic").hide();
			$("#table_clientUserDetails").DataTable().column(6).visible(false);
			this.isShowCreateClient = false;
			this.isShowAddClient = true;
		}
	}

	/*
	 * Created By : Manasa R
	 * Description :To add new client user with in create new user popup.
	 *********************************************/
	async creatingNewClientUser() {
		const ret = await this.checkClientAndProducer(
			this.clientUserDetailsForm.value.clientUserEmail
		);
		if (ret) return;
		this.submitted = true;
		if (this.clientUserDetailsForm.invalid) {
			return;
		} else {
			if (this.clientUserDetailsForm.value.clientUserFirstName.trim() == "") {
				this.commonService.errorsmsg(
					"Invalid Parameter,Missing First Name",
					"Error"
				);
				return;
			} else {
				this.spinner.show();
				let statusData;
				if (
					this.clientUserDetailsForm.value.clientUserSelectStatus == "Active"
				) {
					statusData = "true";
				} else statusData = "false";
				let url =
					this.commonVariablesService.baseURL +
					"api/v1/transact/broker_user_creation";
				let params = [
					{
						status: statusData,
						email: this.clientUserDetailsForm.value.clientUserEmail,
						first_name: this.clientUserDetailsForm.value.clientUserFirstName,
						last_name: this.clientUserDetailsForm.value.clientUserLastName,
						phone_no: this.clientUserDetailsForm.value.clientUserPhoneNumber,
						broker_type: "InsuredEntity",
						broker_user_type: "ClientUser",
						product: this.commonVariablesService.user_management_product,
						producer_code: this.insuredId,
						client: this.commonVariablesService.user_management_product,
					},
				];
				let response = await this.commonService.httpPostMethod(
					url,
					params,
					"application/json",
					true,
					"Policy Configuration"
				);
				if (response.body.status == 0) {
					this.commonService.successmsg(
						"User Details Added Successfully",
						"Success"
					);
					$("#table_clientUserDetails").DataTable().destroy();
					this.fetchAllClientUserData("", "addClientUser");
					this.resetClientUserForm();
				} else if (response.body.status != -114) {
					this.commonService.errorsmsg(
						"Unable to add:" + response.body.txt,
						"Error"
					);
					this.resetClientUserForm();
				}
			}
		}
	}
	/*
	 * Created By : Manasa R
	 * Description : TO edit client user details with in popup.
	 *********************************************/
	editClientUserDetails(data) {
		$("#collapseBasic").show();
		$("#btn_addClientUser").hide();
		$("#btn_updateClientUser").show();
		$("#txtclientUserEmail").attr("disabled", "true");
		let status;
		if (data.status == "true") status = "Active";
		else status = "Inactive";
		this.clientUserDetailsForm.setValue({
			clientUserEmail: data.email_id,
			clientUserFirstName: data.first_name,
			clientUserLastName: data.last_name,
			clientUserPhoneNumber: data.mobile_no,
			clientUserSelectStatus: status,
		});
	}

	/*
	 * Created By : Manasa R
	 * Description : To delete client user details with in popup .
	 *********************************************/
	async deleteClientUserDetails(data) {
		let url =
			this.commonVariablesService.baseURL +
			"api/v1/transact/broker_user_creation";
		let params = [
			{
				status: "false",
				email: data.email_id.toLowerCase(),
				first_name: data.first_name,
				last_name: data.last_name,
				phone_no: data.mobile_no,
				broker_type: "InsuredEntity",
				broker_user_type: "ClientUser",
				product: this.commonVariablesService.user_management_product,
				producer_code: this.insuredId,
				client: this.commonVariablesService.user_management_product,
			},
		];
		let response = await this.commonService.httpPostMethod(
			url,
			params,
			"application/json",
			true,
			"Policy Configuration"
		);
		if (response.body.status == 0) {
			this.commonService.warningmsg("deleted Sucessfully", "Worning");
			this.fetchAllClientUserData("", "addClientUser");
		} else if (response.body.status != -114)
			this.commonService.errorsmsg("unable to delete user details", "Error");
	}
	/*
	 * Created By : Manasa R
	 * Description : To set the required data  on clicking add existing user.
	 *********************************************/
	addExistingUser(event, template: TemplateRef<any>, gcRunningId) {
		event.stopPropagation();
		this.voyageClientUsersArr = [];
		this.checkedClientUsers = [];
		for (let count = 0; count < this.voyageArr.length; count++) {
			if (this.voyageArr[count].gc_running_id == gcRunningId) {
				this.voyageClientUsersArr = JSON.parse(
					JSON.stringify(this.voyageArr[count].client_users)
				);
			}
		}
		for (let count = 0; count < this.voyageClientUsersArr.length; count++) {
			this.checkedClientUsers.push(
				this.voyageClientUsersArr[count].toString().toLowerCase()
			);
		}
		this.fetchAllClientUserData(template, "addExistingUser");
		/* this.cookie.set("runningId", gcRunningId); */
		window.localStorage.setItem("runningId", gcRunningId);
	}

	/*
	 * Created By : Manasa R
	 * Description : To check the status of client user  added or not with in popup.
	 *********************************************/
	clientUserIsChecked(val) {
		var index = this.checkedClientUsers.indexOf(val);
		if (index === -1) {
			// val not found, pushing onto array
			this.defaultClientUserLength.push(val.toLowerCase());
			this.checkedClientUsers.push(val.toLowerCase());
		} else {
			// val is found, removing from array
			this.defaultClientUserLength.splice(index, 1);
			this.checkedClientUsers.splice(index, 1);
		}
		/* if (this.selectedPolicyStatus == 0) {
			var runningId = this.cookie.get("runningId");
			for (let count = 0; count < this.deleteVoyageClientUsersData.length; count++) {

				if (this.deleteVoyageClientUsersData[count].gcRunningId == runningId) {
					var index1 = this.deleteVoyageClientUsersData[count].deletevoyageGridClientUserData.indexOf(val);
					if (!(index1 === -1))
						this.deleteVoyageClientUsersData[count].deletevoyageGridClientUserData.splice(index1, 1)
					break
				}
			}
		} */
	}
	/*
	 * Created By : Manasa R
	 * Description : it will save the changed status of client users with in voyageArr.
	 *********************************************/
	savingSelectedUsers() {
		if (this.selectedPolicyStatus == 0) {
			this.deleteClientUserArr = [];
			/* var runningId = this.cookie.get("runningId"); */
			var runningId = window.localStorage.getItem("runningId");
			for (let i = 0; i < this.voyageArrData.length; i++) {
				if (this.voyageArrData[i].gc_running_id == runningId) {
					let clientData = this.voyageArrData[i].client_users;
					for (let count1 = 0; count1 < clientData.length; count1++) {
						for (
							let count = 0;
							count < this.deleteVoyageClientUsersData.length;
							count++
						) {
							if (
								this.deleteVoyageClientUsersData[count].gcRunningId == runningId
							) {
								if (
									$("#" + $.escapeSelector(clientData[count])).prop(
										"checked"
									) == false
								) {
									let index = this.deleteVoyageClientUsersData[
										count
									].deletevoyageGridClientUserData.indexOf(clientData[count1]);
									if (index == -1)
										this.deleteVoyageClientUsersData[
											count
										].deletevoyageGridClientUserData.push(clientData[count1]);
								} else {
									let index1 = this.deleteVoyageClientUsersData[
										count
									].deletevoyageGridClientUserData.indexOf(clientData[count1]);
									if (index1 > -1)
										this.deleteVoyageClientUsersData[
											count
										].deletevoyageGridClientUserData.splice(index1, 1);
								}
							}
						}
					}
				}
			}
		}

		let clientUserdata = JSON.parse(JSON.stringify(this.checkedClientUsers));
		/* let gcRunningId = this.cookie.get("runningId"); */
		let gcRunningId = window.localStorage.getItem("runningId");
		for (let i = 0; i < this.voyageArr.length; i++) {
			if (this.voyageArr[i].gc_running_id == gcRunningId) {
				this.voyageArr[i].client_users = clientUserdata;
			// Policy setup Changes
			this.userdeletedData.push({
				email_id : clientUserdata,
				gc_running_id: gcRunningId
			})

			}
		}
		this.modalRef.hide();
		this.clientUserDataTable();
	}
	/*
	 * Created By : Manasa R
	 * Description : update the deleted clientusers with in voyageArr.
	 *********************************************/
	async deleteClientUserData(element, mailId, gcRunningId, policy_ref_num) {
		$(element).remove();
		let index1;
		if (this.selectedPolicyStatus == 0) {
			for (let i = 0; i < this.voyageArrData.length; i++) {
				if (this.voyageArrData[i].gc_running_id == gcRunningId) {
					index1 = this.voyageArrData[i].client_users.indexOf(
						mailId.toLowerCase()
					);
				}
			}
			if (index1 != -1) {
				for (
					let count = 0;
					count < this.deleteVoyageClientUsersData.length;
					count++
				) {
					if (
						this.deleteVoyageClientUsersData[count].gcRunningId == gcRunningId
					) {
						this.deleteVoyageClientUsersData[
							count
						].deletevoyageGridClientUserData.push(mailId.toLowerCase());
						// Policy setup Changes
						this.deletedValue.push(this.deleteVoyageClientUsersData[count])
						break;
					}
				}
			}
		}
		for (let i = 0; i < this.voyageArr.length; i++) {
			if (this.voyageArr[i].gc_running_id == gcRunningId) {
				for (
					let count = 0;
					count < this.voyageArr[i].client_users.length;
					count++
				) {
					if (
						mailId.toLowerCase() ==
						this.voyageArr[i].client_users[count].toLowerCase()
					) {
						var index = this.voyageArr[i].client_users.indexOf(
							mailId.toLowerCase()
						);
						this.voyageArr[i].client_users.splice(index, 1);
					}
				}
			}
		}
		this.clientUserDataTable();
		this.commonService.warningmsg("Deleted successfully", "Worning");

		// Policy setup Changes
		// only unique email id's
		if(this.deletedData.indexOf(mailId) === -1) {
			this.deletedData.push({
				email_id : mailId	
			});
		}
		
	}
	/*
	 * Created By : Manasa R
	 * Description : Save  the Client user data to server on save draft.
	 *********************************************/
	async updateClientUsersInDraft() {
		await this.checkAndUpdateInDraft();
		this.tabset.tabs[1].active = true;
	}
	/*
	 * Created By : Manasa R
	 * Description : calls the function on destroying the component helps to hide the popups.
	 *********************************************/
	ngOnDestroy() {
		this.dtTrigger.unsubscribe();

		if ($("#subvoyageModelPopup").is(":visible")) {
			this.modalRef.hide();
		}
		if ($("#addGroupModelPopup").is(":visible")) {
			this.modalRef.hide();
		}
		if ($("#clientModalPopup").is(":visible")) {
			this.modalRef.hide();
		}
		if ($("#producerModelPopup").is(":visible")) {
			this.modalRef.hide();
		}
	}
	/*
	 * Created By : Manasa R
	 * Description : To open the popup on clicking add producer.
	 *********************************************/
	addProducerUser(template: TemplateRef<any>) {
		this.voyageProducerUserArr = [];
		this.fetchAllProducerUserData(template, "addProducerUser");
		/* this.cookie.set("producerRunningId", ""); */
		window.localStorage.setItem("producerRunningId", "");
	}
	/*
	 * Created By : Manasa R
	 * Description : To get required data on clicking add Existing User.
	 *********************************************/
	addExistingProducerUserData(event, template: TemplateRef<any>, gcRunningId) {
		event.stopPropagation();
		this.voyageProducerUserArr = [];
		this.checkedProducerUsers = [];

		for (let count = 0; count < this.voyageArr.length; count++) {
			if (this.voyageArr[count].gc_running_id == gcRunningId) {
				for (let i = 0; i < this.voyageArr[count].producer_users.length; i++)
					this.voyageProducerUserArr.push(
						this.voyageArr[count].producer_users[i].email
							.toString()
							.toLowerCase()
					);
			}
		}
		for (let count = 0; count < this.voyageProducerUserArr.length; count++) {
			this.checkedProducerUsers.push(this.voyageProducerUserArr[count]);
		}
		/* this.cookie.set("producerRunningId", gcRunningId); */
		window.localStorage.setItem("producerRunningId", gcRunningId);
		this.fetchAllProducerUserData(template, "addExistingProducerUser");
	}
	/*
	 * Created By : Manasa R
	 * Description : To fetch all producer user data.
	 *********************************************/
	async fetchAllProducerUserData(template, type) {
		if (template == "") {
			this.producerUsers = [];
			let url =
				this.commonVariablesService.baseURL +
				"api/v1/marine_user_management/broker_user";
			let params = {
				status: "true,false",
				product: this.commonVariablesService.user_management_product,
				broker_user_type: "ProducerUser",
			};
			let response = await this.commonService.httpPostMethod(
				url,
				params,
				"application/json",
				true,
				"Producer User Setup"
			);
			if (response.body.status == 0) {
				for (let i = 0; i < response.body.data.length; i++) {
					this.producerUsers.push(response.body.data[i]);
				}
			} else if (response.body.status != -114)
				this.commonService.errorsmsg(response.body.txt, "Error");
		} else {
			this.modalRef = this.modalService.show(template, this.config);
			this.resetProducerUserForm();
		}
		for (let count = 0; count < this.producerUsers.length; count++) {
			if (this.voyageProducerUserArr.length > 0) {
				for (let i = 0; i < this.voyageProducerUserArr.length; i++) {
					let user = this.voyageProducerUserArr[i];
					if (
						user.toString().toLowerCase() ==
						this.producerUsers[count].email_id.toString().toLowerCase()
					) {
						this.producerUsers[count]["isChecked"] = "checked";
						break;
					} else this.producerUsers[count]["isChecked"] = "";
				}
			} else this.producerUsers[count]["isChecked"] = "";
		}
		if ($.fn.dataTable.isDataTable("#table_producerUserDetails")) {
			$("#table_producerUserDetails").DataTable().destroy();
		}
		// var table = await $("#table_producerUserDetails").DataTable({
		await $("#table_producerUserDetails")
			.DataTable({
				data: this.producerUsers,
				columns: [
					{
						data: null,
						render: function (data) {
							let isChecked = data["isChecked"];
							let obj =
								'<div class="theme-checkbox" ><span tblHead="Select"></span><span class="tblValue">' +
								'<input type="checkbox" value="" id="' +
								data["email_id"] +
								'" ' +
								isChecked +
								"></span></div>";
							return obj;
						},
					},
					{
						data: "email_id",
					},
					{
						data: null,
						render: function (data) {
							return data.first_name + " " + data.last_name;
						},
					},

					{
						data: "mobile_no",
					},
					{
						data: null,
						render: function (data) {
							if (data["status"] == "true") return "Active";
							else return "Inactive";
						},
					},
					{
						data: null,
						render: function (data) {
							return (
								'<div  class="text-center">' +
								'<span tblHead="Action"></span><span class="tblValue">' +
								'<i class="edit-icon fa fa-pencil pr-1" aria-hidden="true"></i>' +
								'<i class="fa fa-trash-o pl-1" aria-hidden="true"></i></span></div>'
							);
						},
					},
				],
				destroy: true,
				paging: true,
				dom: "ftipr",
				pageLength: 30,
				rowCallback: (row: Node, data: any[] | Object, index: number) => {
					const self = this;
					$("td:first-child", row).unbind("change");
					$("td:first-child", row).bind("change", () => {
						self.producerUserIsChecked(data["email_id"]);
					});
					$(".edit-icon", row).unbind("click");
					$(".edit-icon", row).bind("click", () => {
						self.editProducerUserSetupData(data);
					});
					$(".fa-trash-o", row).unbind("click");
					$(".fa-trash-o", row).bind("click", async () => {
						let status = await this.commonService.deleteAlertMsg();
						if (status) self.deleteProducerUserSetupData(data);
					});
					return row;
				},
			})
			.draw();
		if (type == "addProducerUser") {
			$("#table_producerUserDetails").DataTable().column(0).visible(false);
			$("#btn_selectedProducerUsers").hide();
			this.isShowCreateProducer = true;
			this.isShowAddProducer = false;
		} else if (type == "addExistingProducerUser") {
			$("#collapseBasicProducer").hide();
			$("#table_producerUserDetails").DataTable().column(5).visible(false);
			this.isShowCreateProducer = false;
			this.isShowAddProducer = true;
		}
	}
	moveToProduucerTab() {
		this.tabset.tabs[2].active = true;
	}
	/*
	 * Created By : Manasa R
	 * Description : To add new producer user details with in popup.
	 *********************************************/
	async addProducerUserSetupDetails() {
		const ret = await this.checkClientAndProducer(
			this.producerUserSetupForm.value.producerUserEmailID
		);
		if (ret) return;
		this.submitted = true;
		if (this.producerUserSetupForm.invalid) {
			return;
		} else {
			if (this.producerUserSetupForm.value.producerUserFirstName.trim() == "") {
				this.commonService.errorsmsg(
					"Invalid Parameter,Missing Producer Name",
					"Error"
				);
				return;
			} else {
				this.spinner.show();
				let statusData;
				if (
					this.producerUserSetupForm.value.producerUserSelectStatus == "Active"
				) {
					statusData = "true";
				} else statusData = "false";
				let url =
					this.commonVariablesService.baseURL +
					"api/v1/transact/broker_user_creation";
				let params = [
					{
						status: statusData,
						email:
							this.producerUserSetupForm.value.producerUserEmailID.toLowerCase(),
						first_name: this.producerUserSetupForm.value.producerUserFirstName,
						last_name: "",
						phone_no: this.producerUserSetupForm.value.producerUserPhoneNo,
						producer_code: this.producerCode,
						branch_location: this.producerBranch,
						branch_code: this.producerBranchCode,
						broker_type: "ProducerEntity",
						broker_user_type: "ProducerUser",
						product: this.commonVariablesService.user_management_product,
						client: this.commonVariablesService.user_management_product,
					},
				];
				let response = await this.commonService.httpPostMethod(
					url,
					params,
					"application/json",
					true,
					"Producer User Setup"
				);
				if (response.body.status == 0) {
					this.commonService.successmsg(
						"Producer User Details Added Successfully",
						"Success"
					);
					this.fetchAllProducerUserData("", "addProducerUser");
					this.resetProducerUserForm();
				} else if (response.body.status != -114) {
					this.commonService.errorsmsg(
						"Unable to add:" + response.body.txt,
						"Error"
					);
					this.resetProducerUserForm();
				}
			}
		}
	}
	/*
	 * Created By : Manasa R
	 * Description : To edit producer user details with in popup.
	 *********************************************/
	editProducerUserSetupData(value) {
		$("#btnCreateProducerUser")[0].innerHTML = "Update User";
		this.receivedEditData = value;
		$("#producerUserEmail").attr("disabled", "true");
		$("#collapseBasicProducer").show();
		let status;
		if (value.status == "true") status = "Active";
		else status = "Inactive";
		this.producerUserSetupForm.patchValue({
			producerUserFirstName:
				this.receivedEditData.first_name +
				" " +
				this.receivedEditData.last_name,
			producerUserEmailID: this.receivedEditData.email_id.toLowerCase(),
			producerUserPhoneNo: this.receivedEditData.mobile_no,
			producerUserSelectStatus: status,
		});
	}
	/*
	 * Created By : Manasa R
	 * Description : To delete producer details with in popup.
	 *********************************************/
	async deleteProducerUserSetupData(data) {
		let url =
			this.commonVariablesService.baseURL +
			"api/v1/transact/broker_user_creation";
		let params = [
			{
				status: "false",
				email: data.email_id.toLowerCase(),
				first_name: data.first_name,
				last_name: "",
				phone_no: data.mobile_no,
				producer_code: this.producerCode,
				branch_location: this.producerBranch,
				branch_code: this.producerBranchCode,
				broker_type: "ProducerEntity",
				broker_user_type: "ProducerUser",
				product: this.commonVariablesService.user_management_product,
				client: this.commonVariablesService.user_management_product,
			},
		];
		let response = await this.commonService.httpPostMethod(
			url,
			params,
			"application/json",
			true,
			"Producer User Setup"
		);
		if (response.body.status == 0) {
			this.commonService.warningmsg("deleted Sucessfully", "Worning");
			this.fetchAllProducerUserData("", "addProducerUser");
			this.resetProducerUserForm();
		} else if (response.body.status != -114)
			this.commonService.errorsmsg("unable to delete user details", "Error");
	}

	/*
	 * Created By : Keerthana
	 * Description :reset the producer user form.
	 *********************************************/
	resetProducerUserForm() {
		$("#producerUserEmail").removeAttr("disabled");
		this.producerUserSetupForm.reset();
		this.submitted = false;
	}
	/*
	 * Created By : Keerthana
	 * Description :reset the client user form.
	 *********************************************/
	resetClientUserForm() {
		$("#txtclientUserEmail").removeAttr("disabled");
		this.clientUserDetailsForm.reset();
		this.submitted = false;
	}

	/*
	 * Created By : Manasa R
	 * Description : To delete producer details with producer user voayge grid and updates in voyageArr.
	 *********************************************/
	async deleteProducerUserData(element, mailId, gcRunningId, policy_ref_num) {
		$(element).remove();
		let index1;
		if (this.selectedPolicyStatus == 0) {
			for (let i = 0; i < this.voyageArrData.length; i++) {
				if (this.voyageArrData[i].gc_running_id == gcRunningId) {
					index1 = this.voyageArrData[i].producer_users
						.map(function (e) {
							return e.email.toLowerCase();
						})
						.indexOf(mailId.toLowerCase());
				}
			}

			if (index1 != -1) {
				for (
					let count = 0;
					count < this.deleteVoyageProducerUsersData.length;
					count++
				) {
					if (
						this.deleteVoyageProducerUsersData[count].gcRunningId == gcRunningId
					) {
						this.deleteVoyageProducerUsersData[
							count
						].deletevoyageGridProducerUserData.push(mailId.toLowerCase());
						break;
					}
				}
			}
		}
		for (let i = 0; i < this.voyageArr.length; i++) {
			if (this.voyageArr[i].gc_running_id == gcRunningId) {
				for (
					let count = 0;
					count < this.voyageArr[i].producer_users.length;
					count++
				) {
					if (
						mailId.toLowerCase() ==
						this.voyageArr[i].producer_users[count].email.toLowerCase()
					) {
						this.voyageArr[i].producer_users.splice(count, 1);
					}
				}
			}
		}
		this.producerUserDataTable();
		this.commonService.warningmsg("Deleted successfuly", "Worning");
	}

	/*
	 * Created By : Manasa R
	 * Description : To check the status of producer user  added or not with in popup.
	 *********************************************/
	producerUserIsChecked(val) {
		var index = this.checkedProducerUsers.indexOf(val);
		if (index === -1) {
			this.defaultProducerUserLength.push(val.toLowerCase());
			this.checkedProducerUsers.push(val.toLowerCase());
		} else {
			this.defaultProducerUserLength.splice(index, 1);
			this.checkedProducerUsers.splice(index, 1);
		}
	}
	/*
	 * Created By : Manasa R
	 * Description : To save added producer details with in popup and updates in voyageArr.
	 *********************************************/
	savingSelectedProducerUsers() {
		if (this.selectedPolicyStatus == 0) {
			this.deleteProducerUserArr = [];
			/* var runningId = this.cookie.get("producerRunningId"); */
			var runningId = window.localStorage.getItem("producerRunningId");
			for (let i = 0; i < this.voyageArrData.length; i++) {
				if (this.voyageArrData[i].gc_running_id == runningId) {
					let producerData = this.voyageArrData[i].producer_users;
					for (let count1 = 0; count1 < producerData.length; count1++) {
						for (
							let count = 0;
							count < this.deleteVoyageProducerUsersData.length;
							count++
						) {
							if (
								this.deleteVoyageProducerUsersData[count].gcRunningId ==
								runningId
							) {
								//if (this.deleteProducerUserArr.length > 0) {
								if (
									$("#" + $.escapeSelector(producerData[count1].email)).prop(
										"checked"
									) == false
								) {
									let index = this.deleteVoyageProducerUsersData[
										count
									].deletevoyageGridProducerUserData.indexOf(
										producerData[count1].email.toLowerCase()
									);
									if (index == -1)
										this.deleteVoyageProducerUsersData[
											count
										].deletevoyageGridProducerUserData.push(
											producerData[count1].email.toLowerCase()
										);
								} else {
									let index1 = this.deleteVoyageProducerUsersData[
										count
									].deletevoyageGridProducerUserData.indexOf(
										producerData[count1].email.toLowerCase()
									);
									if (index1 > -1)
										this.deleteVoyageProducerUsersData[
											count
										].deletevoyageGridProducerUserData.splice(index1, 1);
								}
							}
							//}
						}
					}
				}
			}
		}
		let producerUserdata = JSON.parse(
			JSON.stringify(this.checkedProducerUsers)
		);
		/* let gcRunningId = this.cookie.get("producerRunningId"); */
		let gcRunningId = window.localStorage.getItem("producerRunningId");
		let certificateAllowedDetaies = JSON.parse(JSON.stringify(this.voyageArr));
		for (let i = 0; i < this.voyageArr.length; i++) {
			if (this.voyageArr[i].gc_running_id == gcRunningId) {
				this.voyageArr[i].producer_users = [];
				for (let count = 0; count < producerUserdata.length; count++) {
					if (certificateAllowedDetaies[i].producer_users.length == 0) {
						this.voyageArr[i].producer_users.push({
							email: producerUserdata[count],
							allow_certificate: "No",
						});
					} else {
						let flag = 0;
						for (
							let j = 0;
							j < certificateAllowedDetaies[i].producer_users.length;
							j++
						) {
							if (
								certificateAllowedDetaies[i].producer_users[
									j
								].email.toLowerCase() == producerUserdata[count].toLowerCase()
							) {
								flag = 1;
								this.voyageArr[i].producer_users.push({
									email: producerUserdata[count],
									allow_certificate:
										certificateAllowedDetaies[i].producer_users[j]
											.allow_certificate,
								});
								break;
							}
						}
						if (flag == 0) {
							this.voyageArr[i].producer_users.push({
								email: producerUserdata[count],
								allow_certificate: "No",
							});
						}
					}
				}
			}
		}
		this.modalRef.hide();
		this.producerUserDataTable();
	}
	/*
	 * Created By : Manasa R
	 * Description : To update producer details to the serve on submit the entire form.
	 *********************************************/
	async updateProducerUsersInDraft() {
		await this.checkAndUpdateInDraft();
	}
	/*
	 * Created By : PriyaDharshini M
	 * Description : To convert incomlete policies to completed.
	 *********************************************/
	async convertToPolicy() {
		//this.isShowConvertPolicyButton = true;
		const ret = await this.checkClientAndProducerUsers();
		if (ret) {
			this.isShowConvertPolicyButton = false;
			return;
		}
		let voyageurl,
			voyageresponse,
			voyageparams,
			proposalurl,
			proposalresponse,
			proposalparams,
			depositurl,
			depositparams,
			depositresponse,
			openingBalance = [],
			subvoyageurl,
			subvoyageresponse,
			subvoyageparams,
			insillionmapurl,
			insillionmapresponse,
			insillionmapparams,
			completeResponse,
			subvoyageId = "",
			voyageId = "",
			insillionPolicyId;
		// let insillionPolicyId = '';
		let totalapiFlag = 0,
			totalSuccessFlag = 0;
		for (let j = 0; j < this.voyageArrGridData.length; j++) {
			for (let i = 0; i < this.voyageArrForPolicy.length; i++) {
				if (
					this.voyageArrForPolicy[i].gc_running_id ==
					this.voyageArrGridData[j].gc_running_id
				) {
					let countOfDuplicate = 0;
					if (openingBalance.length == 0) {
						openingBalance.push(this.voyageArrGridData[j]);
					} else {
						for (let k = 0; k < openingBalance.length; k++) {
							if (
								this.voyageArrGridData[j].gc_running_id ==
									openingBalance[k].gc_running_id &&
								this.voyageArrGridData[j].certificate_bulk ==
									openingBalance[k].certificate_bulk
							) {
								countOfDuplicate++;
							}
						}
						if (countOfDuplicate > 0) break;
						else openingBalance.push(this.voyageArrGridData[j]);
					}
				}
			}
		}

		let effectiveDate,
			lockDate,
			checkForOpeningBalance = 0;
		for (let count = 0; count < openingBalance.length; count++) {
			/* openingBalance[count].declaration_type = 'Both' */
			if (
				openingBalance[count].certificate_allowed != "No" &&
				openingBalance[count].opening_balance == 0
			) {
				checkForOpeningBalance = 1;
				this.commonService.errorsmsg(
					"Unable to convert to Policy because of opening balance is zero",
					"Error"
				);
			} else if (
				parseInt(openingBalance[count].opening_balance) >
				parseInt(openingBalance[count].initial_sum_insured)
			) {
				checkForOpeningBalance = 1;
				this.commonService.errorsmsg(
					"Unable to convert to Policy because of opening balance is greater than Inital balance",
					"Error"
				);
			}
			if (this.policyType == "STOP" || this.policyType == "Project Policy") {
				if (
					openingBalance[count].declaration_type == "Both" ||
					openingBalance[count].declaration_type == "Certificate"
				) {
					this.commonService.errorsmsg(
						"Unable to convert to Policy because of declaration type is Both or Certificate for policy " +
							openingBalance[count].voyage_name,
						""
					);
					this.isShowConvertPolicyButton = false;
					return;
				}
			}
		}
		if (checkForOpeningBalance == 0) {
			for (let count = 0; count < this.voyageArr.length; count++) {
				if (this.voyageArr[count].client_users.length == 0) {
					this.commonService.errorsmsg(
						"Client User details are empty for voyage " +
							this.voyageArr[count].voyage_name,
						"Error"
					);
					checkForOpeningBalance = 1;
					break;
				}
			}
		}
		if (checkForOpeningBalance == 0) {
			for (let count = 0; count < this.voyageArr.length; count++) {
				if (this.voyageArr[count].producer_users.length == 0) {
					this.commonService.errorsmsg(
						"Producer User details are empty for voyage " +
							this.voyageArr[count].voyage_name,
						"Error"
					);
					checkForOpeningBalance = 1;
					break;
				}
			}
		}
		if (checkForOpeningBalance == 0) {
			this.voyageArrData = this.voyageArr;
			await this.submit("convertToPolicy");
			this.spinner.show();
			this.policyInceptionDate = new Date(this.policyInceptionDate);
			this.policyExpiryDate = new Date(this.policyExpiryDate);
			this.policyInceptionDate = this.datePipe.transform(
				this.policyInceptionDate,
				"yyyy-MM-dd"
			);
			this.policyExpiryDate = this.datePipe.transform(
				this.policyExpiryDate,
				"yyyy-MM-dd"
			);
			effectiveDate = this.datePipe.transform(
				this.PolicyEffectiveDate,
				"yyyy-MM-dd"
			);
			lockDate = this.datePipe.transform(this.policyLockDate, "yyyy-MM-dd");
			let effectiveDateValue = new Date(effectiveDate);
			let lockDateValue = new Date(lockDate);
			let inceptionDate = new Date(this.policyInceptionDate);
			let expiryDate = new Date(this.policyExpiryDate);
			if (
				effectiveDateValue < inceptionDate ||
				effectiveDateValue > expiryDate
			) {
				this.commonService.errorsmsg(
					"Portal Effective Date Should be Greater than Inception date and Less than Expiry date",
					"Error"
				);
				this.spinner.hide();
				this.isShowConvertPolicyButton = false;
				return;
			}
			if (lockDateValue < inceptionDate || lockDateValue > expiryDate) {
				this.commonService.errorsmsg(
					"Portal Lock Date Should be Greater than Inception date and Less than Expiry date",
					"Error"
				);
				this.spinner.hide();
				this.isShowConvertPolicyButton = false;
				return;
			}

			let aclCommonGroupUrl =
				this.commonVariablesService.baseURL +
				"api/v1/master/marine_mp_common_group";
			let aclCommonGroupResponse = await this.commonService.httpGetMethod(
				aclCommonGroupUrl,
				"",
				true,
				"",
				"Policy Configuration"
			);
			if (aclCommonGroupResponse.status == 0) {
				if (aclCommonGroupResponse.data.length > 0) {
					let groupArray = aclCommonGroupResponse.data[0].value.split(",");
					for (let i = 0; i < groupArray.length; i++) {
						let commonGroupURL =
							this.commonVariablesService.baseURL + "api/v1/group/";
						let commonGroupParam = {
							group_name: groupArray[i],
						};
						let commonGroupResponse = await this.commonService.httpGetMethod(
							commonGroupURL,
							"",
							true,
							commonGroupParam,
							"Policy Configuration"
						);
						if (commonGroupResponse.status == 0) {
							if (commonGroupResponse.data.length > 0) {
								this.allGroupDataId.push(commonGroupResponse.data[0].group_id);
							}
						} else if (commonGroupResponse.status != -114) {
							this.commonService.errorsmsg(commonGroupResponse.txt, "Error");
							this.isShowConvertPolicyButton = false;
							return;
						}
					}
				}
			} else if (aclCommonGroupResponse.status != -114) {
				this.commonService.errorsmsg(aclCommonGroupResponse.txt, "Error");
				this.isShowConvertPolicyButton = false;
				return;
			}
			let brokerName = "",
				insuredGroupId1 = "",
				insuredGroupId2 = "";
			let brokerURL = this.commonVariablesService.baseURL + "api/v1/broker/";
			let brokerParam = { broker_code: this.insuredId };
			let brokerResponse = await this.commonService.httpGetMethod(
				brokerURL,
				"",
				true,
				brokerParam,
				"Policy Configuration"
			);
			if (brokerResponse.status == 0) {
				if (brokerResponse.data.length > 0) {
					brokerName = brokerResponse.data[0].broker_name;
				}
			} else if (brokerResponse.status != -114) {
				this.commonService.errorsmsg(brokerResponse.txt, "Error");
				this.isShowConvertPolicyButton = false;
				return;
			}
			let insuredGroupURL =
				this.commonVariablesService.baseURL + "api/v1/group/";
			let insuredGroupParam = {
				group_name: brokerName,
			};
			let insuredGroupResponse = await this.commonService.httpGetMethod(
				insuredGroupURL,
				"",
				true,
				insuredGroupParam,
				"Policy Configuration"
			);
			if (insuredGroupResponse.status == 0) {
				if (insuredGroupResponse.data.length > 0) {
					insuredGroupId1 = insuredGroupResponse.data[0].group_id;
				}
			} else if (insuredGroupResponse.status != -114) {
				this.commonService.errorsmsg(insuredGroupResponse.txt, "Error");
				this.isShowConvertPolicyButton = false;
				return;
			}
			let name = brokerName + "_" + this.insuredId;
			let insuredCommonGroupParam = {
				group_name: name,
			};
			let insuredCommonGroupResponse = await this.commonService.httpGetMethod(
				insuredGroupURL,
				"",
				true,
				insuredCommonGroupParam,
				"Policy Configuration"
			);
			if (insuredCommonGroupResponse.status == 0) {
				if (insuredCommonGroupResponse.data.length > 0) {
					insuredGroupId2 = insuredCommonGroupResponse.data[0].group_id;
				}
			} else if (insuredCommonGroupResponse.status != -114) {
				this.commonService.errorsmsg(insuredCommonGroupResponse.txt, "Error");
				this.isShowConvertPolicyButton = false;
				return;
			}
			if (this.allGroupDataId.length > 0) {
				let clientId = "";
				if (insuredGroupId1) clientId = insuredGroupId1;
				else if (insuredGroupId2) clientId = insuredGroupId2;
				if (clientId) {
					for (let i = 0; i < this.allGroupDataId.length; i++) {
						let insuredurl =
							this.commonVariablesService.baseURL + "api/v1/group/proxy/entity";
						let insuredParam = {
							group_id: this.allGroupDataId[i],
							entity_id: clientId,
						};
						let insuredResponse = await this.commonService.httpPostMethod(
							insuredurl,
							insuredParam,
							"application/json",
							true,
							"Policy Configuration"
						);
						if (
							insuredResponse.body.status != 0 &&
							insuredResponse.body.status != -144
						) {
							this.commonService.errorsmsg(insuredResponse.body.txt, "Error");
							this.isShowConvertPolicyButton = false;
							return;
						}
					}
				}
			}
			let policyIdComplete = [];
			for (let i = 0; i < this.voyageArrForPolicy.length; i++) {
				subvoyageId = "";
				voyageId = "";
				let openingBalanceYes = "",
					siPercentYes = "",
					premiumBalanceYes = "";
				let openingBalanceNo = "",
					siPercentNo = "",
					premiumBalanceNo = "";
				let openingBalanceBulk = "",
					siPercentBulk = "",
					premiumBalanceBulk = "";
				let openingBalanceCertificate = "",
					siPercentCertificate = "",
					premiumBalanceCertificate = "";
				let clientUser = [],
					producerUser = []; /* , policyId */
				// let clientUserId = "", producerUserId = "";
				// let responseArray;
				this.subvoyagearray = [];
				this.spinner.show();
				voyageurl = this.commonVariablesService.baseURL + "api/v1/quote";
				proposalurl = this.commonVariablesService.baseURL + "api/v1/proposal";
				subvoyageurl =
					this.commonVariablesService.baseURL + "api/v1/policy/meta";
				for (let j = 0; j < this.voyageArrGridData.length; j++) {
					if (
						this.voyageArrForPolicy[i].gc_running_id ==
						this.voyageArrGridData[j].gc_running_id
					) {
						voyageId = this.voyageArrGridData[j].gc_running_id;
						if (subvoyageId == "") subvoyageId = this.voyageArrGridData[j].id;
						else subvoyageId = subvoyageId + "," + this.voyageArrGridData[j].id;
						for (let b = 0; b < this.voyageArrData.length; b++) {
							if (
								this.voyageArrForPolicy[i].gc_running_id ==
								this.voyageArrData[b].gc_running_id
							) {
								clientUser = this.voyageArrData[b].client_users;
								producerUser = this.voyageArrData[b].producer_users;
							}
						}

						/* for (let c = 0; c < this.clientGroupIds.length; c++) {
							if (this.clientGroupIds[c].gcRunningId == this.voyageArrForPolicy[i].gc_running_id) {
								clientUserId = this.clientGroupIds[c].groupId;
							}
						}
						for (let d = 0; d < this.producerGroupIds.length; d++) {
							if (this.producerGroupIds[d].gcRunningId == this.voyageArrForPolicy[i].gc_running_id) {
								producerUserId = this.producerGroupIds[d].groupId;
							}
						} */
						voyageparams = JSON.stringify({
							product_id: this.commonVariablesService.productId,
							__finalize: 1,
							policy_ref_num: this.policyNumber,
							cust_fld_1: this.policyNumberForDispaly,
							gc_booking_date: this.datePipe.transform(
								this.bookingdateForPolicy,
								"yyyy-MM-dd"
							),
							renewal_counter: this.renewalCounter + "",
							policy_number: this.policyNumberForDispaly,
							policy_type: this.policyType,
							policy_currency_type: this.policyCurrencyType,
							gc_policy_start_date: this.datePipe.transform(
								this.inceptionDate,
								"yyyy-MM-dd"
							),
							gc_policy_end_date: this.datePipe.transform(
								this.expiryDate,
								"yyyy-MM-dd"
							),
							tax_applicable: this.tax,
							producer_name: this.producerName,
							producer_code: this.producerCode,
							producer_branch_code: this.producerBranchCode,
							producer_branch_name: this.producerBranch,
							producer_phone_no: this.producerPhoneNumber,
							producer_email: this.producerEmail,
							insured_id: this.insuredId,
							insured_name: this.insuredName,
							insured_add1: this.insuredAdd1,
							insured_add2: this.insuredAdd2,
							insured_add3: this.insuredAdd3,
							insured_city: this.insuredCity,
							insured_country: this.insuredCountry,
							insured_state: this.insuredState,
							insured_zipcode: this.insuredZipcode,
							insured_gstin: this.insuredGSTINNumber,
							status: 0,
							policy_total_premium: this.totalPremium,
							policy_total_sum_insured:
								this.voyageArrGridData[j].initial_sum_insured,
							opening_balance: this.voyageArrGridData[j].opening_balance,
							premium_balance: this.voyageArrGridData[j].premium_balance,
							si_percentage: this.voyageArrGridData[j].si_percentage,
							voyage: this.voyageArrForPolicy[i],
							policy_net_premium: this.policyNetPremium,
							policy_service_tax: this.policyServiceTax,
							policy_stamp_duty: this.policyStampDuty,
							sme: this.sme,
						});
						if (
							this.policyType == "STOP" ||
							this.policyType == "Project Policy"
						) {
							if (this.voyageArrGridData[j].certificate_allowed == "Yes") {
								openingBalanceYes = this.voyageArrGridData[j].opening_balance;
								siPercentYes = this.voyageArrGridData[j].si_percentage;
								premiumBalanceYes = this.voyageArrGridData[j].premium_balance;
							} else if (
								this.voyageArrGridData[j].certificate_allowed == "No"
							) {
								openingBalanceNo = this.voyageArrGridData[j].opening_balance;
								siPercentNo = this.voyageArrGridData[j].si_percentage;
								premiumBalanceNo = this.voyageArrGridData[j].premium_balance;
							}
						} else if (
							this.policyType == "MOP" ||
							this.policyType == "Open Cover"
						) {
							if (this.voyageArrGridData[j].certificate_bulk.includes("Bulk")) {
								openingBalanceBulk = this.voyageArrGridData[j].opening_balance;
								siPercentBulk = this.voyageArrGridData[j].si_percentage;
								premiumBalanceBulk = this.voyageArrGridData[j].premium_balance;
							} else if (
								this.voyageArrGridData[j].certificate_bulk.includes(
									"Certificate"
								)
							) {
								openingBalanceCertificate =
									this.voyageArrGridData[j].opening_balance;
								siPercentCertificate = this.voyageArrGridData[j].si_percentage;
								premiumBalanceCertificate =
									this.voyageArrGridData[j].premium_balance;
							}
						}

						// policyId = this.voyageArrGridData[j].policy_id
						this.subvoyagearray.push({
							id: this.voyageArrGridData[j].id,
							gc_running_id: this.voyageArrGridData[j].gc_running_id,
							sub_voyage_name: this.voyageArrGridData[j].sub_voyage_name,
							coverage_type: this.voyageArrGridData[j].coverage_type,
							declaration_type: this.voyageArrGridData[j].declaration_type,
							certificate_bulk: this.voyageArrGridData[j].certificate_bulk,
							certificate_allowed:
								this.voyageArrGridData[j].certificate_allowed,
							bulk_declaration_type:
								this.voyageArrGridData[j].bulk_declaration_type,
							bov_percentage: this.voyageArrGridData[j].bov_percentage,
							per_seeding_limit: this.voyageArrGridData[j].per_seeding_limit,
							transit_excees: this.voyageArrGridData[j].transit_excees,
							transit_excess_in_certificate:
								this.voyageArrGridData[j].transit_excess_in_certificate,
							mode_of_conveyance: this.voyageArrGridData[j].mode_of_conveyance,
							min_shipment_premium:
								this.voyageArrGridData[j].min_shipment_premium,
							low_balance_trigger:
								this.voyageArrGridData[j].low_balance_trigger,
							low_balance_trigger_amount:
								this.voyageArrGridData[j].low_balance_trigger_amount,
							back_date_days: this.voyageArrGridData[j].back_date_days,
							days_post_expiry: this.voyageArrGridData[j].days_post_expiry,
							display_premium: this.voyageArrGridData[j].display_premium,
							non_standard_clauses:
								this.voyageArrGridData[j].non_standard_clauses,
							from_country: this.voyageArrGridData[j].from_country,
							to_country: this.voyageArrGridData[j].to_country,
							client_in_certificate:
								this.voyageArrGridData[j].client_in_certificate,
							marine_final_rate_percentage:
								this.voyageArrGridData[j].marine_final_rate_percentage,
							opening_balance: this.voyageArrGridData[j].opening_balance,
							premium_balance: this.voyageArrGridData[j].premium_balance,
							si_percentage: this.voyageArrGridData[j].si_percentage,
						});
					}
				}
				// responseArray = this.subvoyagearray;
				subvoyageparams = JSON.stringify({
					tagic_rm_email: this.tagicRMemail,
					underwriter_email: this.underwriterEmail,
					group_name: this.selectGroup.value.groupNameValue,
					portal_effective_date: this.datePipe.transform(
						effectiveDate,
						"yyyy-MM-dd"
					),
					portal_lock_date: this.datePipe.transform(lockDate, "yyyy-MM-dd"),
					sub_voyage: this.subvoyagearray,
					client_users: clientUser,
					producer_users: producerUser,
					opening_balance_certificate: openingBalanceCertificate,
					si_percentage_certificate: siPercentCertificate,
					premium_balance_certificate: premiumBalanceCertificate,
					opening_balance_bulk: openingBalanceBulk,
					si_percentage_bulk: siPercentBulk,
					premium_balance_bulk: premiumBalanceBulk,
					opening_balance_certificateyes: openingBalanceYes,
					si_percentage_certificateyes: siPercentYes,
					premium_balance_certificateyes: premiumBalanceYes,
					opening_balance_certificateno: openingBalanceNo,
					si_percentage_certificateno: siPercentNo,
					premium_balance_certificateno: premiumBalanceNo,
					low_balance_trigger: this.voyageArrForPolicy[i].low_balance_trigger,
					low_balance_trigger_amount:
						this.voyageArrForPolicy[i].low_balance_trigger_amount,
					declaration_type_sub_voyage:
						this.voyageArrForPolicy[i].declaration_type_sub_voyage,
				});
				voyageresponse = await this.commonService.httpPostMethod(
					voyageurl,
					voyageparams,
					"application/json",
					true,
					"Policy Configuration"
				);

				if (voyageresponse.body.status == 0) {
					this.spinner.show();
					policyIdComplete.push(voyageresponse.body.data[0].policy_id);
					insillionPolicyId = voyageresponse.body.data[0].policy_id;
					for (let j = 0; j < this.voyageArrGridData.length; j++) {
						if (
							this.voyageArrForPolicy[i].gc_running_id ==
							this.voyageArrGridData[j].gc_running_id
						) {
							proposalparams = JSON.stringify({
								product_id: this.commonVariablesService.productId,
								__finalize: 1,
								policy_ref_num: this.policyNumber,
								cust_fld_1: this.policyNumberForDispaly,
								gc_booking_date: this.datePipe.transform(
									this.bookingdateForPolicy,
									"yyyy-MM-dd"
								),
								renewal_counter: this.renewalCounter + "",
								policy_number: this.policyNumberForDispaly,
								policy_type: this.policyType,
								policy_currency_type: this.policyCurrencyType,
								gc_policy_start_date: this.datePipe.transform(
									this.inceptionDate,
									"yyyy-MM-dd"
								),
								gc_policy_end_date: this.datePipe.transform(
									this.expiryDate,
									"yyyy-MM-dd"
								),
								tax_applicable: this.tax,
								producer_name: this.producerName,
								producer_code: this.producerCode,
								producer_branch_code: this.producerBranchCode,
								producer_branch_name: this.producerBranch,
								producer_phone_no: this.producerPhoneNumber,
								producer_email: this.producerEmail,
								insured_id: this.insuredId,
								insured_name: this.insuredName,
								insured_add1: this.insuredAdd1,
								insured_add2: this.insuredAdd2,
								insured_add3: this.insuredAdd3,
								insured_city: this.insuredCity,
								insured_district: this.insuredDistrict,
								insured_country: this.insuredCountry,
								insured_state: this.insuredState,
								insured_zipcode: this.insuredZipcode,
								insured_gstin: this.insuredGSTINNumber,
								status: 0,
								policy_total_premium: this.totalPremium,
								policy_total_sum_insured:
									this.voyageArrGridData[j].initial_sum_insured,
								opening_balance: this.voyageArrGridData[j].opening_balance,
								premium_balance: this.voyageArrGridData[j].premium_balance,
								si_percentage: this.voyageArrGridData[j].si_percentage,
								voyage: this.voyageArrForPolicy[i],
								policy_net_premium: this.policyNetPremium,
								policy_service_tax: this.policyServiceTax,
								policy_stamp_duty: this.policyStampDuty,
								proposal_id: voyageresponse.body.data[0].proposal_id,
							});
						}
					}
					proposalresponse = await this.commonService.httpPostMethod(
						proposalurl,
						proposalparams,
						"application/json",
						true,
						"Policy Configuration"
					);
					if (proposalresponse.body.status == 0) {
						subvoyageresponse = await this.commonService.httpPostMethod(
							subvoyageurl + "/" + voyageresponse.body.data[0].policy_id,
							subvoyageparams,
							"application/json",
							true,
							"Policy Configuration"
						);
						if (subvoyageresponse.body.status == 0) {
							this.spinner.show();
							let aclurl =
								this.commonVariablesService.baseURL +
								"api/v1/marine_mp_gc_data/acl";
							//let aclClientparams = JSON.stringify({ 'policy_id': voyageresponse.body.data[0].policy_id, 'group_id': clientUserId })
							let aclClientparams = [],
								aclProducerparams = [];
							// Added by sharann
							depositurl = `${this.commonVariablesService.baseURL}api/v1/deposit/od`;
							depositparams = {
								broker_id: proposalresponse.body.data[0].policy_no,
								od_amount: "10",
							};
							depositresponse = await this.commonService.httpPostMethod(
								depositurl,
								depositparams,
								"application/json",
								true,
								"Policy Configuration"
							);
							if (
								depositresponse.body.status != 0 &&
								depositresponse.body.status != -114
							) {
								this.commonService.errorsmsg(depositresponse.body.txt, "Error");
								this.isShowConvertPolicyButton = false;
								return;
							}
							for (let j = 0; j < this.voyageArr.length; j++) {
								if (
									this.voyageArrForPolicy[i].gc_running_id ==
									this.voyageArr[j].gc_running_id
								) {
									for (
										let k = 0;
										k < this.voyageArr[j].client_users.length;
										k++
									) {
										aclClientparams.push({
											policy_no: proposalresponse.body.data[0].policy_no,
											email_id: this.voyageArr[j].client_users[k].toLowerCase(),
											status: 0,
										});
									}
									for (
										let k = 0;
										k < this.voyageArr[j].producer_users.length;
										k++
									) {
										aclProducerparams.push({
											policy_no: proposalresponse.body.data[0].policy_no,
											email_id:
												this.voyageArr[j].producer_users[k].email.toLowerCase(),
											status: 0,
										});
									}
								}
							}
							//let aclProducerparams = JSON.stringify({ 'policy_id': voyageresponse.body.data[0].policy_id, 'group_id': producerUserId })
							let clientResponse, producerResponse;
							this.spinner.show();
							clientResponse = await this.commonService.httpPostMethod(
								aclurl,
								aclClientparams,
								"application/json",
								true,
								"Policy Configuration"
							);
							this.spinner.show();
							producerResponse = await this.commonService.httpPostMethod(
								aclurl,
								aclProducerparams,
								"application/json",
								true,
								"Policy Configuration"
							);
							if (
								clientResponse.body.status == 0 &&
								producerResponse.body.status == 0
							) {
								for (let idx = 0; idx < this.allGroupDataId.length; idx++) {
									let aclCommonGroupurl =
										this.commonVariablesService.baseURL + "api/v1/policy/acl";
									let commonGroupParam = JSON.stringify({
										policy_id: voyageresponse.body.data[0].policy_id,
										group_id: this.allGroupDataId[idx],
									});
									let commonGroupResponse =
										await this.commonService.httpPostMethod(
											aclCommonGroupurl,
											commonGroupParam,
											"application/json",
											true,
											"Policy Configuration"
										);
									if (
										commonGroupResponse.body.status != 0 &&
										commonGroupResponse.body.status != -114
									) {
										this.commonService.errorsmsg(
											commonGroupResponse.body.txt,
											"Error"
										);
										this.isShowConvertPolicyButton = false;
										return;
									}
								}
								insillionmapurl =
									this.commonVariablesService.baseURL +
									"api/v1/marine_mp_gc_data/insillion_map";
								insillionmapparams = {
									policy_number: this.policyNumberForDispaly,
									sub_voyage_gc_running_id: subvoyageId,
									voyage_gc_running_id: voyageId,
									insillion_policy_id: insillionPolicyId,
									policy_ref_num: this.policyNumber,
								};
								totalapiFlag++;
								insillionmapresponse = await this.commonService.httpPostMethod(
									insillionmapurl,
									insillionmapparams,
									"application/json",
									true,
									"Policy Configuration"
								);
								if (insillionmapresponse.body.status == 0) totalSuccessFlag++;
								else if (insillionmapresponse.body.status != -114) {
									this.commonService.errorsmsg(
										insillionmapresponse.body.txt,
										"Error"
									);
									this.isShowConvertPolicyButton = false;
									return;
								}
							} else if (clientResponse.body.status != -114) {
								this.commonService.errorsmsg(clientResponse.body.txt, "Error");
								this.isShowConvertPolicyButton = false;
								return;
							}
						} else if (subvoyageresponse.body.status != -114) {
							this.commonService.errorsmsg(subvoyageresponse.body.txt, "Error");
							this.isShowConvertPolicyButton = false;
							return;
						}
					} else if (proposalresponse.body.status != -114) {
						this.commonService.errorsmsg(proposalresponse.body.txt, "Error");
						this.isShowConvertPolicyButton = false;
						return;
					}
				} else if (voyageresponse.body.status != -114) {
					this.commonService.errorsmsg(voyageresponse.body.txt, "Error");
					this.isShowConvertPolicyButton = false;
					return;
				}
			}

			if (
				totalapiFlag == totalSuccessFlag &&
				totalapiFlag != 0 &&
				totalSuccessFlag != 0
			) {
				this.spinner.show();
				/* this.triggerMailToClient();
				this.triggerMailToProducer(); */
				let completeURL =
					this.commonVariablesService.baseURL +
					"api/v1/marine_mp_gc_data/completed";
				let params = JSON.stringify({
					policy_ref_num: this.policyNumber,
					policy_number: this.policyNumberForDispaly,
					insillion_policy_id: policyIdComplete,
					parent_ref_num: this.policyNumber,
				});
				completeResponse = await this.commonService.httpPostMethod(
					completeURL,
					params,
					"application/json",
					true,
					"Policy Configuration"
				);
				if (completeResponse.body.status == 0) {
					await this.triggerMailToProducer();
					await this.triggerMailToClient();
					this.commonService.successmsg(
						"Successfully Converted to Policy",
						"Success"
					);
					this.router.navigate(["/master-policy-complete"]);
				} else if (completeResponse.body.status != -114) {
					this.commonService.errorsmsg(completeResponse.body.txt, "Error");
					this.isShowConvertPolicyButton = false;
					return;
				}
			} else {
				this.commonService.errorsmsg("Unable to convert to policy", "Error");
				this.isShowConvertPolicyButton = false;
				return;
			}
		}
		this.isShowConvertPolicyButton = false;
	}

	/*
	 * Created By : Manasa R
	 * Description : To group client user details.
	 *********************************************/
	async clientDataToPolicy() {
		for (let i = 0; i < this.voyageArr.length; i++) {
			var groupId;
			let data = {};
			let urlforgroup = this.commonVariablesService.baseURL + "api/v1/group";
			if (this.selectedPolicyStatus == 1) {
				this.spinner.show();
				let groupParam = new HttpParams()
					.set(
						"group_name",
						this.voyageArr[i].policy_ref_num +
							"_CLIENT_" +
							this.voyageArr[i].gc_running_id
					)
					.set("status", "0");
				let createGroupResponse = await this.commonService.httpPostMethod(
					urlforgroup,
					groupParam,
					"application/x-www-form-urlencoded; charset=UTF-8",
					true,
					"Policy Configuration"
				);
				if (createGroupResponse.body.status == 0) {
					data = {
						gcRunningId: this.voyageArr[i].gc_running_id,
						groupId:
							this.voyageArr[i].policy_ref_num +
							"_CLIENT_" +
							this.voyageArr[i].gc_running_id,
					};
					this.clientGroupIds.push(data);
				} else if (createGroupResponse.body.status != -114) {
					this.commonService.errorsmsg(createGroupResponse.body.txt, "Error");
					return false;
				}
			}
			let allGroupDataResponse = await this.commonService.httpGetMethod(
				urlforgroup,
				"",
				true,
				"",
				"Policy Configuration"
			);
			if (allGroupDataResponse.status == 0) {
				for (
					let count1 = 0;
					count1 < allGroupDataResponse.data.length;
					count1++
				) {
					if (
						allGroupDataResponse.data[count1].group_name ==
						this.voyageArr[i].policy_ref_num +
							"_CLIENT_" +
							this.voyageArr[i].gc_running_id
					) {
						groupId = allGroupDataResponse.data[count1].group_id;
						break;
					}
				}
			} else if (allGroupDataResponse.status != -114) {
				this.commonService.errorsmsg(allGroupDataResponse.txt, "Error");
				return false;
			}
			this.spinner.show();
			let url =
				this.commonVariablesService.baseURL + "api/v1/group/users/" + groupId;
			let clientUserResponseOnPolicy = await this.commonService.httpGetMethod(
				url,
				"",
				true,
				"",
				"Policy Configuration"
			);
			if (clientUserResponseOnPolicy.status == 0) {
				for (let k = 0; k < this.voyageArr[i].client_users.length; k++) {
					var flag1 = 1;
					// var clintUser = "";
					for (
						let count2 = 0;
						count2 < clientUserResponseOnPolicy.data.length;
						count2++
					) {
						if (
							clientUserResponseOnPolicy.data[count2] ==
							this.voyageArr[i].client_users[k]
						) {
							flag1 = 0;
							// clintUser = "";
							break;
						}
						/* else {
							// already flag1 has value `1`
							// flag1 = 1;
						} */
					}
					if (flag1 == 1 || clientUserResponseOnPolicy.data.length == 0) {
						url =
							this.commonVariablesService.baseURL +
							"api/v1/group/" +
							groupId +
							"/" +
							this.voyageArr[i].client_users[k];
						let clientUserResponse = await this.commonService.httpPostMethod(
							url,
							"",
							"",
							true,
							"Policy Configuration"
						);
						if (
							clientUserResponse.body.status != 0 &&
							clientUserResponse.body.status != -114
						) {
							this.commonService.errorsmsg(
								clientUserResponse.body.txt,
								"Error"
							);
							return false;
						}
					}
				}
			} else if (clientUserResponseOnPolicy.status != -114) {
				this.commonService.errorsmsg(clientUserResponseOnPolicy.txt, "Error");
				return false;
			}
		}
		return true;
	}
	/*
	 * Created By : Manasa R
	 * Description : To group producer user details.
	 *********************************************/
	async producerDataToPolicy() {
		for (let i = 0; i < this.voyageArr.length; i++) {
			var groupId;
			let urlforgroup = this.commonVariablesService.baseURL + "api/v1/group";
			if (this.selectedPolicyStatus == 1) {
				this.spinner.show();
				let groupParam = new HttpParams()
					.set(
						"group_name",
						this.voyageArr[i].policy_ref_num +
							"_PRODUCER_" +
							this.voyageArr[i].gc_running_id
					)
					.set("status", "0");
				let createGroupResponse = await this.commonService.httpPostMethod(
					urlforgroup,
					groupParam,
					"application/x-www-form-urlencoded; charset=UTF-8",
					true,
					"Policy Configuration"
				);
				if (createGroupResponse.body.status == 0) {
					let data = {
						gcRunningId: this.voyageArr[i].gc_running_id,
						groupId:
							this.voyageArr[i].policy_ref_num +
							"_PRODUCER_" +
							this.voyageArr[i].gc_running_id,
					};
					this.producerGroupIds.push(data);
				} else if (createGroupResponse.body.status != -114) {
					this.commonService.errorsmsg(createGroupResponse.body.txt, "Error");
					return false;
				}
			}
			let allGroupDataResponse = await this.commonService.httpGetMethod(
				urlforgroup,
				"",
				true,
				"",
				"Policy Configuration"
			);
			if (allGroupDataResponse.status == 0)
				for (
					let count1 = 0;
					count1 < allGroupDataResponse.data.length;
					count1++
				) {
					if (
						allGroupDataResponse.data[count1].group_name ==
						this.voyageArr[i].policy_ref_num +
							"_PRODUCER_" +
							this.voyageArr[i].gc_running_id
					) {
						groupId = allGroupDataResponse.data[count1].group_id;
						break;
					}
				}
			else if (allGroupDataResponse.status != -114) {
				this.commonService.errorsmsg(allGroupDataResponse.txt, "Error");
				return false;
			}
			this.spinner.show();
			let url =
				this.commonVariablesService.baseURL + "api/v1/group/users/" + groupId;
			let clientUserResponseOnPolicy = await this.commonService.httpGetMethod(
				url,
				"",
				true,
				"",
				"Policy Configuration"
			);
			if (clientUserResponseOnPolicy.status == 0) {
				for (let k = 0; k < this.voyageArr[i].producer_users.length; k++) {
					let flag1 = 0;
					var clintUser = "";
					for (
						let count2 = 0;
						count2 < clientUserResponseOnPolicy.data.length;
						count2++
					) {
						if (
							clientUserResponseOnPolicy.data[count2] ==
							this.voyageArr[i].producer_users[k].email
						) {
							flag1 = 0;
							break;
						} else flag1 = 1;
					}
					if (flag1 == 1 || clientUserResponseOnPolicy.data.length == 0) {
						url =
							this.commonVariablesService.baseURL +
							"api/v1/group/" +
							groupId +
							"/" +
							this.voyageArr[i].producer_users[k].email;
						let producerUserResponse = await this.commonService.httpPostMethod(
							url,
							"",
							"",
							true,
							"Policy Configuration"
						);
						if (
							producerUserResponse.body.status != 0 &&
							producerUserResponse.body.status != -114
						) {
							this.commonService.errorsmsg(
								producerUserResponse.body.txt,
								"Error"
							);
							return false;
						}
					}
				}
			} else if (clientUserResponseOnPolicy.status != -114) {
				this.commonService.errorsmsg(clientUserResponseOnPolicy.txt, "Error");
				return false;
			}
		}
		return true;
	}
	backButton(value) {
		this.spinner.show();
		if (value == "client") this.tabset.tabs[0].active = true;
		if (value == "producer") this.tabset.tabs[1].active = true;
		this.spinner.hide();
	}

	/*
	 * Created By : Sharann
	 * Description : To check client/producer user available or not.
	 *********************************************/
	async checkAndUpdateInDraft() {
		let flag = 0;
		let flag1 = 0;
		this.voyageArrData = [];
		for (let i = 0; i < this.voyageArr.length; i++) {
			this.voyageArrData.push({
				gc_running_id: this.voyageArr[i].gc_running_id,
				client_users: this.voyageArr[i].client_users,
				producer_users: this.voyageArr[i].producer_users,
				rate_applicable: this.voyageArr[i].rate_applicable,
				low_balance_trigger: this.voyageArr[i].low_balance_trigger,
				low_balance_trigger_amount:
					this.voyageArr[i].low_balance_trigger_amount,
				declaration_type_sub_voyage:
					this.voyageArr[i].declaration_type_sub_voyage,
			});
			if (this.selectedPolicyStatus == 0) {
				if (!this.voyageArr[i].client_users.length) {
					flag = 1;
					break;
				}
			}
		}

		if (this.selectedPolicyStatus == 0) {
			for (let i = 0; i < this.voyageArr.length; i++) {
				if (!this.voyageArr[i].producer_users.length) {
					flag1 = 1;
					break;
				}
			}
			if (flag == 1)
				this.commonService.errorsmsg(
					"There should be atleast one client user in each voyage",
					"Error"
				);
			else if (flag1 == 1)
				this.commonService.errorsmsg(
					"There should be atleast one producer user in each voyage",
					"Error"
				);
			else this.submit("");
		} else {
			this.submit("");
		}
	}

	/*
	 * Created By : Sharann
	 * Description : To check client/producer user available or not.
	 *********************************************/
	async savePolicySetup() {
		await this.checkAndUpdateInDraft();
	}

	/*
	 * Created By : Sharann
	 * Description : To check client/producer user mapped in group or not.
	 *********************************************/
	async checkClientAndProducerUsers() {
		return new Promise(async (resolve) => {
			let emarineGrpId = "";
			let count = 0,
				userCount,
				invalid = false;
			let errorsmsg = "Users are not available in the group";
			let param = {
				status: "0",
			};
			const emarineURL = `${this.commonVariablesService.baseURL}api/v1/master/marine_emarine_id`;
			this.isShowConvertPolicyButton = true;
			let emarineResponse = await this.commonService.httpGetMethod(
				emarineURL,
				"",
				true,
				param,
				"Policy Configuration"
			);
			if (emarineResponse.status == 0 && emarineResponse.data.length > 0) {
				emarineGrpId = emarineResponse.data[0].name;
				count++;
			}
			if (count == 0) {
				this.commonService.errorsmsg(errorsmsg, "");
				return resolve(true);
			}

			const url = `${this.commonVariablesService.baseURL}api/v1/group/users/${emarineGrpId}`;
			const response = await this.commonService.httpGetMethod(
				url,
				"application/json",
				true,
				{},
				"Policy Configuration"
			);

			if (response.status != 0) {
				this.commonService.errorsmsg(errorsmsg, "");
				return resolve(true);
			}
			for (let obj of this.voyageArr) {
				userCount = 0;
				/* Check client user */
				if (obj.client_users.length) {
					for (let clientEmailObj of obj.client_users) {
						if (response.data.includes(clientEmailObj)) {
							userCount++;
						}
					}
				}
				/* Check producer user */
				if (obj.producer_users.length) {
					for (let producerEmailObj of obj.producer_users) {
						if (response.data.includes(producerEmailObj.email)) {
							userCount++;
						}
					}
				}

				const totalCount = obj.client_users.length + obj.producer_users.length;
				if (userCount != totalCount) {
					invalid = true;
					break;
				}
			}
			if (invalid) {
				this.commonService.errorsmsg(errorsmsg, "Error");
				return resolve(true);
			} else {
				return resolve(false);
			}
		});
	}

	/*
	 * Created By : Sharann
	 * Description : To check client/producer user already in group or not.
	 *********************************************/
	async checkClientAndProducer(email) {
		return new Promise(async (resolve) => {
			email = (email || "").toLowerCase();
			let emarineGrpId = "";
			let count = 0,
				userCount,
				invalid = false;
			let errorsmsg = "Problem occur while adding user";
			let param = {
				status: "0",
			};
			const emarineURL = `${this.commonVariablesService.baseURL}api/v1/master/marine_emarine_id`;
			let emarineResponse = await this.commonService.httpGetMethod(
				emarineURL,
				"",
				true,
				param,
				"Policy Configuration"
			);
			if (emarineResponse.status == 0 && emarineResponse.data.length > 0) {
				emarineGrpId = emarineResponse.data[0].name;
				count++;
			}
			if (count == 0) {
				this.commonService.errorsmsg(errorsmsg, "");
				return resolve(true);
			}

			const url = `${this.commonVariablesService.baseURL}api/v1/group/users/${emarineGrpId}`;
			const response = await this.commonService.httpGetMethod(
				url,
				"application/json",
				true,
				{},
				"Policy Configuration"
			);

			if (response.status != 0) {
				this.commonService.errorsmsg(errorsmsg, "");
				return resolve(true);
			}
			// convert all email into lowercase
			response.data = response.data.map((v) => v.toLowerCase());
			if (response.data.includes(email)) {
				this.commonService.errorsmsg("Entered email is already exists", "");
				return resolve(true);
			} else {
				return resolve(false);
			}
		});
	}
}
